/*!
 * @piconetworks/form v3.9.0
 * (c) 
 */
'use strict';

var React = require('react');
var cx = require('classnames');
var PropTypes = require('prop-types');
var Select = require('react-select');
require('react-dates/initialize');
var reactDates = require('react-dates');
var moment = require('moment');
var TimePicker = require('react-time-picker/dist/entry.nostyle');
var isEmpty = require('lodash/isEmpty');
var reactBootstrapTypeahead = require('react-bootstrap-typeahead');
var FocusWithin = require('react-focus-within');
var Switch$1 = require('react-switch');
require('styled-jsx/style');
var axios = require('axios');
var DropzoneS3Uploader = require('react-dropzone-s3-uploader');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var TimePicker__default = /*#__PURE__*/_interopDefaultLegacy(TimePicker);
var isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(isEmpty);
var FocusWithin__default = /*#__PURE__*/_interopDefaultLegacy(FocusWithin);
var Switch__default = /*#__PURE__*/_interopDefaultLegacy(Switch$1);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var DropzoneS3Uploader__default = /*#__PURE__*/_interopDefaultLegacy(DropzoneS3Uploader);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var styles$c = {"checkbox":"Checkbox-module_checkbox__1lfA0","disabled":"Checkbox-module_disabled__2ShUO","input":"Checkbox-module_input__2Eb5h","content":"Checkbox-module_content__1D6cm","checkMark":"Checkbox-module_checkMark__GFZL0","checkMarkOuter":"Checkbox-module_checkMarkOuter__3bsqc","selected":"Checkbox-module_selected__2tdMv","checkMarkInner":"Checkbox-module_checkMarkInner__tTn2e","indeterminate":"Checkbox-module_indeterminate__1opql","checkBoxText":"Checkbox-module_checkBoxText__167kq","icon":"Checkbox-module_icon__2UhxB","title":"Checkbox-module_title__3xkuz","description":"Checkbox-module_description__1PUOm"};

var Checkbox = function Checkbox(props) {
  var _classNames4;

  var disabled = props.disabled,
      indeterminated = props.indeterminated,
      text = props.text,
      className = props.className,
      label = props.label,
      input = props.input,
      meta = props.meta,
      required = props.required,
      customTitleClass = props.customTitleClass,
      description = props.description,
      customDescriptionClass = props.customDescriptionClass,
      customContentClass = props.customContentClass,
      icon = props.icon,
      outerClassName = props.outerClassName,
      innerClassName = props.innerClassName,
      _props$style = props.style;
  _props$style = _props$style === void 0 ? {} : _props$style;
  var _props$style$checkMar = _props$style.checkMarkInner,
      checkMarkInner = _props$style$checkMar === void 0 ? {} : _props$style$checkMar;
  return /*#__PURE__*/React__default['default'].createElement(Form.Field, {
    label: label,
    required: required,
    meta: meta,
    className: className
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: cx__default['default'](styles$c.checkbox, _defineProperty({}, styles$c.disabled, disabled)),
    "data-testid": "FormCheckbox_index_div"
  }, /*#__PURE__*/React__default['default'].createElement("input", _extends({
    type: "checkbox",
    className: styles$c.input
  }, input, {
    "data-testid": "FormCheckbox_index_input"
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: cx__default['default'](styles$c.content, _defineProperty({}, styles$c.disabled, disabled), customContentClass),
    "data-testid": "FormCheckbox_index_div"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles$c.checkMark,
    "data-testid": "FormCheckbox_index_div"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: cx__default['default'](styles$c.checkMarkOuter, _defineProperty({}, styles$c.selected, input.checked || indeterminated), outerClassName),
    "data-testid": "FormCheckbox_index_div"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: cx__default['default'](styles$c.checkMarkInner, (_classNames4 = {}, _defineProperty(_classNames4, styles$c.selected, input.checked || indeterminated), _defineProperty(_classNames4, innerClassName, input.checked), _classNames4)),
    style: input.checked ? checkMarkInner.checked : checkMarkInner["default"],
    "data-testid": "FormCheckbox_index_div"
  }, input.checked ? /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "data-testid": "FormCheckbox_index_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "none",
    stroke: "white" // $form-check-input-checked-color
    ,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M4 8.5L6.5 11l6-6",
    "data-testid": "FormCheckbox_index_path"
  })) : indeterminated ? /*#__PURE__*/React__default['default'].createElement("span", {
    className: cx__default['default'](styles$c.indeterminate, styles$c.checkIcon),
    "data-testid": "FormCheckbox_index_span"
  }) : null)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: cx__default['default'](styles$c.checkBoxText, customTitleClass),
    "data-testid": "FormCheckbox_index_div"
  }, icon && /*#__PURE__*/React__default['default'].createElement("img", {
    className: styles$c.icon,
    src: icon,
    "data-testid": "FormCheckbox_index_img"
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: cx__default['default'](styles$c.title),
    "data-testid": "FormCheckbox_index_label"
  }, text)), description && /*#__PURE__*/React__default['default'].createElement("div", {
    className: cx__default['default'](styles$c.checkBoxText, customDescriptionClass),
    "data-testid": "FormCheckbox_index_div"
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    className: cx__default['default'](styles$c.description),
    "data-testid": "FormCheckbox_index_label"
  }, description)))));
};

Checkbox.defaultProps = {
  disabled: false,
  indeterminated: false,
  innerClassName: '',
  text: ''
};
Checkbox.propTypes = {
  label: PropTypes__default['default'].string,
  required: PropTypes__default['default'].bool,
  indeterminated: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].string,
  text: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object, PropTypes__default['default'].func, PropTypes__default['default'].node]),
  disabled: PropTypes__default['default'].bool,
  meta: PropTypes__default['default'].object.isRequired,
  input: PropTypes__default['default'].object.isRequired,
  outerClassName: PropTypes__default['default'].string,
  innerClassName: PropTypes__default['default'].string,
  customTitleClass: PropTypes__default['default'].string,
  description: PropTypes__default['default'].string,
  customDescriptionClass: PropTypes__default['default'].string,
  customContentClass: PropTypes__default['default'].string,
  icon: PropTypes__default['default'].string,
  style: PropTypes__default['default'].object
};

var customStyles = {
  option: function option(provided, state) {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, provided), {}, {
      color: state.isDisabled ? '#AAA' : '#000',
      textAlign: 'left',
      fontSize: '17px',
      fontWeight: 400,
      padding: '11px 0 11px 24px',
      cursor: 'pointer',
      backgroundColor: '#fff'
    }, state.isSelected && {
      backgroundColor: '#F8F8F8',
      fontSize: '17px',
      fontWeight: 500
    }), {}, {
      '&:hover': _objectSpread2({}, !state.isDisabled && {
        backgroundColor: state.selectProps.themeColor,
        color: state.selectProps.contrastColor
      }),
      ':active': {
        backgroundColor: '#fff'
      }
    });
  },
  control: function control(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      borderRadius: '8px',
      minHeight: '44px',
      backgroundColor: state.isDisabled ? '#f8f8f8' : '#fff',
      border: state.selectProps.error && state.selectProps.touched ? '1px solid #FF5E5B' : state.isFocused ? "1px solid ".concat(state.selectProps.themeColor) : '1px solid #ddd',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
      cursor: 'pointer',
      boxSizing: 'border-box',
      '&:hover': _objectSpread2({}, !state.selectProps.error && state.selectProps.touched && {
        border: state.selectProps.error && state.selectProps.touched && '1px solid #FF5E5B'
      }),
      padding: '0 8px 0 0',
      lineHeight: 1
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      padding: '0 24px',
      lineHeight: '2rem',
      minHeight: '2rem'
    });
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: 'none'
    };
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return {
      transform: !state.isFocused ? "rotate(0)" : "rotate(180deg)",
      color: state.selectProps.error && state.selectProps.touched && ' #FF5E5B',
      '.icon-dropdown-indicator': {
        '&:before': {
          color: state.selectProps.error && state.selectProps.touched ? ' #FF5E5B' : '#777777',
          fontSize: '17px',
          padding: '0 16px'
        }
      }
    };
  },
  singleValue: function singleValue(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      fontSize: '16px',
      color: '#000',
      fontWeight: 400,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '0 24px',
      left: 0,
      width: '100%'
    });
  },
  placeholder: function placeholder(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      fontSize: '16px',
      fontWeight: 500,
      color: state.selectProps.error && state.selectProps.touched && '#FF5E5B',
      marginLeft: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '0 24px',
      left: 0,
      width: '100%'
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      minWidth: 200
    });
  }
};

var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/React__default['default'].createElement(Select.components.DropdownIndicator, props, /*#__PURE__*/React__default['default'].createElement("span", {
    className: cx__default['default']('icon-dropdown-indicator'),
    "data-testid": "FormDropdown_index_span"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon-chevron-down",
    "data-testid": "FormDropdown_index_span"
  })));
};

var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "rSelecRef", null);

    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _valueObject,
          _valueObject$options,
          _this2 = this;

      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          changed = _this$props.changed,
          className = _this$props.className,
          classNamePrefix = _this$props.classNamePrefix,
          components = _this$props.components,
          contrastColor = _this$props.contrastColor,
          disabled = _this$props.disabled,
          formatGroupLabel = _this$props.formatGroupLabel,
          formatOptionLabel = _this$props.formatOptionLabel,
          formFieldClassName = _this$props.formFieldClassName,
          group = _this$props.group,
          input = _this$props.input,
          isDisabled = _this$props.isDisabled,
          isMulti = _this$props.isMulti,
          isSearchable = _this$props.isSearchable,
          label = _this$props.label,
          menuPlacement = _this$props.menuPlacement,
          meta = _this$props.meta,
          noOptionsMessage = _this$props.noOptionsMessage,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          required = _this$props.required,
          styles = _this$props.styles,
          themeColor = _this$props.themeColor,
          props = _objectWithoutProperties(_this$props, ["autoFocus", "changed", "className", "classNamePrefix", "components", "contrastColor", "disabled", "formatGroupLabel", "formatOptionLabel", "formFieldClassName", "group", "input", "isDisabled", "isMulti", "isSearchable", "label", "menuPlacement", "meta", "noOptionsMessage", "options", "placeholder", "required", "styles", "themeColor"]);

      var valueObject;

      if (group) {
        valueObject = options === null || options === void 0 ? void 0 : options.find(function (option) {
          var _option$options;

          return option === null || option === void 0 ? void 0 : (_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.find(function (element) {
            return element.value === input.value;
          });
        });
      }

      var formApi = _objectSpread2(_objectSpread2({}, !group && input), group ? {
        value: (_valueObject = valueObject) === null || _valueObject === void 0 ? void 0 : (_valueObject$options = _valueObject.options) === null || _valueObject$options === void 0 ? void 0 : _valueObject$options.find(function (element) {
          return element.value === input.value;
        })
      } : {
        value: options === null || options === void 0 ? void 0 : options.find(function (option) {
          return option.value === input.value;
        })
      });

      return /*#__PURE__*/React__default['default'].createElement(Form.Field, {
        label: label,
        required: required,
        meta: meta,
        className: formFieldClassName
      }, /*#__PURE__*/React__default['default'].createElement(Select__default['default'], _extends({}, formApi, {
        autoFocus: autoFocus,
        className: className,
        classNamePrefix: classNamePrefix || 'react-select',
        components: _objectSpread2({
          DropdownIndicator: DropdownIndicator
        }, components),
        contrastColor: contrastColor,
        error: meta.error,
        formatGroupLabel: formatGroupLabel,
        formatOptionLabel: formatOptionLabel,
        isDisabled: disabled || isDisabled,
        isMulti: isMulti,
        isSearchable: isSearchable,
        menuPlacement: menuPlacement,
        noOptionsMessage: noOptionsMessage,
        onChange: function onChange(e) {
          if (changed) {
            changed(e);
          }

          if (input.onChange) {
            input.onChange(e.value);
          }

          if (input.onBlur) {
            input.onBlur(e.value);
          }

          _this2.rSelecRef.blur();
        },
        options: options,
        placeholder: placeholder || 'Select one',
        ref: function ref(item) {
          return _this2.rSelecRef = item;
        },
        styles: styles || customStyles,
        themeColor: themeColor,
        touched: meta.touched
      }, props, {
        "data-testid": "FormDropdown_index_Select"
      })));
    }
  }]);

  return Dropdown;
}(React__default['default'].Component);
Dropdown.defaultProps = {
  changed: null,
  contrastColor: '#FFF',
  isSearchable: false,
  menuPlacement: 'bottom',
  options: [],
  themeColor: '#7A34FF'
};
Dropdown.propTypes = {
  autoFocus: PropTypes__default['default'].bool,

  /** Passes the event just prior to firing onChange and onBlur */
  changed: PropTypes__default['default'].func,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /** If provided, all inner components will be given a prefixed className attribute */
  classNamePrefix: PropTypes__default['default'].string,

  /** If you wish to overwrite a component, pass in an object with the appropriate namespace: https://react-select.com/components */
  components: PropTypes__default['default'].object,
  formatGroupLabel: PropTypes__default['default'].func,
  formatOptionLabel: PropTypes__default['default'].func,
  formFieldClassName: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  group: PropTypes__default['default'].bool,

  /** Either disabled can be set here or preferable, `isDisabled` */
  disabled: PropTypes__default['default'].bool,
  options: PropTypes__default['default'].array,
  input: PropTypes__default['default'].object.isRequired,

  /** Either disabled can be set here or via `disabled` */
  isDisabled: PropTypes__default['default'].bool,

  /** Support multiple selected options */
  isMulti: PropTypes__default['default'].bool,
  isSearchable: PropTypes__default['default'].bool,
  label: PropTypes__default['default'].node,
  meta: PropTypes__default['default'].object.isRequired,

  /** Text to display when there are no options */
  noOptionsMessage: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  placeholder: PropTypes__default['default'].string,
  menuPlacement: PropTypes__default['default'].oneOf(['auto', 'top', 'bottom']),

  /** Boolean indicating whether a value is required */
  required: PropTypes__default['default'].bool,
  styles: PropTypes__default['default'].object,
  contrastColor: PropTypes__default['default'].string,
  themeColor: PropTypes__default['default'].string
};

var style$9 = {"displayInlineFlex":"FlexboxContainer-module_displayInlineFlex__3UMgJ","displayFlex":"FlexboxContainer-module_displayFlex__Wb7nQ"};

var FlexboxContainer = /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var alignItems = _ref.alignItems,
      children = _ref.children,
      className = _ref.className,
      flexDirection = _ref.flexDirection,
      flexWrap = _ref.flexWrap,
      inline = _ref.inline,
      justifyContent = _ref.justifyContent,
      props = _objectWithoutProperties(_ref, ["alignItems", "children", "className", "flexDirection", "flexWrap", "inline", "justifyContent"]);

  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](inline ? style$9.displayInlineFlex : style$9.displayFlex, alignItems && "align-items-".concat(alignItems), flexDirection && "flex-".concat(flexDirection), flexWrap && "flex-".concat(flexWrap), justifyContent && "justify-content-".concat(justifyContent), className),
    ref: ref
  }, props, {
    "data-testid": "Flexbox_FlexboxContainer_div"
  }), children);
});
FlexboxContainer.propTypes = {
  /** This defines the alignment along the cross axis. */
  alignItems: PropTypes__default['default'].oneOf(['stretch', 'center', 'start', 'end', 'baseline', 'initial']),
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /** Whether the container is display inline-flex (true) or just flex (false) */
  inline: PropTypes__default['default'].bool,

  /** Defines direction flex items are placed in the flex container */
  flexDirection: PropTypes__default['default'].oneOf(['row', 'column', 'row-reverse', 'column-reverse']),

  /** Whether to wrap to the next line */
  flexWrap: PropTypes__default['default'].oneOf(['wrap', 'nowrap', 'wrap-reverse']),

  /** This defines the alignment along the main axis. */
  justifyContent: PropTypes__default['default'].oneOf(['start', 'end', 'center', 'between', 'around', 'initial'])
};
FlexboxContainer.defaultProps = {
  inline: false,
  flexDirection: 'row',
  flexWrap: 'nowrap'
};

var FlexboxChild = function FlexboxChild(_ref) {
  var alignSelf = _ref.alignSelf,
      children = _ref.children,
      className = _ref.className,
      flex = _ref.flex,
      flexFill = _ref.flexFill,
      flexGrow = _ref.flexGrow,
      flexShrink = _ref.flexShrink,
      props = _objectWithoutProperties(_ref, ["alignSelf", "children", "className", "flex", "flexFill", "flexGrow", "flexShrink"]);

  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](flexFill && 'flex-fill', flexGrow && "flex-grow-".concat(flexGrow), flexShrink && "flex-shrink-".concat(flexShrink), alignSelf && "align-self-".concat(alignSelf), className),
    style: {
      flex: flex
    }
  }, props, {
    "data-testid": "Flexbox_FlexboxChild_div"
  }), children);
};

FlexboxChild.propTypes = {
  alignSelf: PropTypes__default['default'].oneOf(['start', 'end', 'center', 'between', 'around', 'initial']),
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /**
   * This is the shorthand for flex-grow, flex-shrink and flex-basis combined.
   */
  flex: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),

  /**
   * Set this on a series of sibling elements to force them into widths equal
   * to their content (or equal widths if their content does not surpass their border-boxes)
   * while taking up all available horizontal space.
   * */
  flexFill: PropTypes__default['default'].bool,

  /**
   * This defines the ability for a flex item to grow if necessary.
   * It accepts a unitless value that serves as a proportion.
   * It dictates what amount of the available space inside the flex container the item should take up.
   */
  flexGrow: PropTypes__default['default'].number,

  /**
   * This defines the ability for a flex item to shrink if necessary.
   */
  flexShrink: PropTypes__default['default'].number
}; // maybe i can remove this?

var Flexbox = {
  Child: FlexboxChild,
  Container: FlexboxContainer
};

var Trigger = /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      className = _ref.className;
  return /*#__PURE__*/React__default['default'].cloneElement(children, {
    ref: ref,
    onClick: onClick,
    disabled: disabled,
    className: className
  });
});
Trigger.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  disabled: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node.isRequired,
  onClick: PropTypes__default['default'].func
};
Trigger.defaultProps = {
  disabled: false
};

var style$8 = {"container":"DynamicFieldItem-module_container__3wZOZ","item":"DynamicFieldItem-module_item__1r73T","inputContainer":"DynamicFieldItem-module_inputContainer__U8mTo","itemButton":"DynamicFieldItem-module_itemButton__31R-U"};

var Item = function Item(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      flexboxContainer = _ref.flexboxContainer,
      onClick = _ref.onClick,
      triggerComponent = _ref.triggerComponent,
      props = _objectWithoutProperties(_ref, ["children", "disabled", "flexboxContainer", "onClick", "triggerComponent"]);

  return /*#__PURE__*/React__default['default'].createElement(Flexbox.Container, _extends({}, flexboxContainer, props), /*#__PURE__*/React__default['default'].isValidElement(triggerComponent) && /*#__PURE__*/React__default['default'].createElement(Trigger, {
    onClick: onClick,
    disabled: disabled,
    className: style$8.itemButton,
    "data-testid": "FormDynamicField_Item_Trigger"
  }, triggerComponent), children);
};

Item.propTypes = {
  /**
   * Adding flexbox container props to here,
   */
  flexboxContainer: PropTypes__default['default'].object,

  /**
   * Disables the onClick Actioon, preventing mouse events,
   */
  disabled: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node.isRequired,
  triggerComponent: PropTypes__default['default'].any.isRequired,

  /**
   * On click action for bottom of the list button
   */
  onClick: PropTypes__default['default'].func
};
Item.defaultProps = {
  disabled: false
};

var styles$b = {"box":"RegularBox-module_box__FYskv","left":"RegularBox-module_left__20jaU","center":"RegularBox-module_center__3649L","right":"RegularBox-module_right__3XwiF"};

var RegularBox = function RegularBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      alignText = _ref.alignText,
      props = _objectWithoutProperties(_ref, ["children", "className", "alignText"]);

  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](styles$b[alignText], styles$b.box, className)
  }, props, {
    "data-testid": "Regular_RegularBox_div"
  }), children);
};

RegularBox.propTypes = {
  /** Aligns children using text-align */
  alignText: PropTypes__default['default'].oneOf(['left', 'center', 'right']),
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};
RegularBox.defaultProps = {
  alignText: 'left'
};

var styles$a = {"contentPaneContainer":"ContentPane-module_contentPaneContainer__3BVEG","contentPaneChild":"ContentPane-module_contentPaneChild__Hn5za"};

var ContentPaneContainer = function ContentPaneContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      flexboxContainer = _ref.flexboxContainer,
      props = _objectWithoutProperties(_ref, ["children", "className", "flexboxContainer"]);

  return /*#__PURE__*/React__default['default'].createElement(Flexbox.Container, _extends({
    className: cx__default['default'](styles$a.contentPaneContainer, className)
  }, flexboxContainer, props), children);
};

ContentPaneContainer.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  flexboxContainer: PropTypes__default['default'].object
};
ContentPaneContainer.defaultProps = {
  flexboxContainer: {
    alignItems: 'start',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  }
};

var ContentPaneChild = function ContentPaneChild(_ref) {
  var children = _ref.children,
      className = _ref.className,
      flexboxChild = _ref.flexboxChild,
      noTopPadding = _ref.noTopPadding,
      noRightPadding = _ref.noRightPadding,
      noBottomPadding = _ref.noBottomPadding,
      noLeftPadding = _ref.noLeftPadding,
      props = _objectWithoutProperties(_ref, ["children", "className", "flexboxChild", "noTopPadding", "noRightPadding", "noBottomPadding", "noLeftPadding"]);

  return /*#__PURE__*/React__default['default'].createElement(Flexbox.Child, _extends({
    className: cx__default['default'](styles$a.contentPaneChild, noTopPadding && 'pt-0', noRightPadding && 'pr-0', noBottomPadding && 'pb-0', noLeftPadding && 'pl-0', className)
  }, flexboxChild, props), children);
};

ContentPaneChild.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  flexboxChild: PropTypes__default['default'].object,
  noTopPadding: PropTypes__default['default'].bool,
  noRightPadding: PropTypes__default['default'].bool,
  noBottomPadding: PropTypes__default['default'].bool,
  noLeftPadding: PropTypes__default['default'].bool
};
ContentPaneChild.defaultProps = {
  flexboxChild: {
    flexFill: true
  },
  noTopPadding: false,
  noRightPadding: false,
  noBottomPadding: false,
  noLeftPadding: false
};

var ContentPane = {
  Child: ContentPaneChild,
  Container: ContentPaneContainer
};

var styles$9 = {"scrollableWrapper":"Scrollable-module_scrollableWrapper__1wtmy","scrollableHeader":"Scrollable-module_scrollableHeader__1WM7A","scrollableContainer":"Scrollable-module_scrollableContainer__3sbrs"};

var ScrollableTemplate = function ScrollableTemplate(_ref) {
  var children = _ref.children,
      styleClass = _ref.styleClass,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "styleClass", "className"]);

  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](className, styles$9[styleClass])
  }, props, {
    "data-testid": "Scrollable_ScrollableTemplate_div"
  }), children);
};

ScrollableTemplate.propTypes = {
  children: PropTypes__default['default'].node,
  styleClass: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var createTemplate = function createTemplate(styleClass) {
  return function (_ref) {
    var children = _ref.children,
        props = _objectWithoutProperties(_ref, ["children"]);

    return /*#__PURE__*/React__default['default'].createElement(ScrollableTemplate, _extends({
      styleClass: styleClass
    }, props, {
      "data-testid": "Scrollable_index_ScrollableTemplate"
    }), children);
  };
};

var Scrollable = {
  Wrapper: createTemplate('scrollableWrapper'),
  Header: createTemplate('scrollableHeader'),
  Container: createTemplate('scrollableContainer')
};

var Box = {
  Regular: RegularBox,
  Flexbox: Flexbox,
  ContentPane: ContentPane,
  Scrollable: Scrollable
};

var Container = function Container(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      flexboxContainer = _ref.flexboxContainer,
      onClick = _ref.onClick,
      triggerComponent = _ref.triggerComponent,
      props = _objectWithoutProperties(_ref, ["children", "className", "disabled", "flexboxContainer", "onClick", "triggerComponent"]);

  return /*#__PURE__*/React__default['default'].createElement(Box.Flexbox.Container, _extends({
    className: cx__default['default'](className)
  }, flexboxContainer, props), children, /*#__PURE__*/React__default['default'].isValidElement(triggerComponent) && /*#__PURE__*/React__default['default'].createElement(Trigger, {
    onClick: onClick,
    disabled: disabled,
    "data-testid": "FormDynamicField_Container_Trigger"
  }, triggerComponent));
};

Container.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /**
   * Adding flexbox container props to here,
   */
  flexboxContainer: PropTypes__default['default'].object,

  /**
   * Disables the onClick Actioon, preventing mouse events,
   */
  disabled: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node.isRequired,
  triggerComponent: PropTypes__default['default'].any.isRequired,

  /**
   * On click action for bottom of the list button
   */
  onClick: PropTypes__default['default'].func
};
Container.defaultProps = {
  disabled: false
};

var DynamicField = {
  Container: Container,
  Item: Item
};

var styles$8 = {"feedback":"Feedback-module_feedback__VOwlo","primary":"Feedback-module_primary__OHMlU","focus":"Feedback-module_focus__2WMa2","secondary":"Feedback-module_secondary__2g6Id","success":"Feedback-module_success__3tY0L","info":"Feedback-module_info__2siN-","warning":"Feedback-module_warning__11bHh","danger":"Feedback-module_danger__3RC7z","light":"Feedback-module_light__324J9","dark":"Feedback-module_dark__3HIkJ","facebook":"Feedback-module_facebook__3wNig","github":"Feedback-module_github__1vLqW","google":"Feedback-module_google__22kd8","linkedin":"Feedback-module_linkedin__1g5hG","twitter":"Feedback-module_twitter__3fnKe","text":"Feedback-module_text__333Xc"};

var FormFeedback = function FormFeedback(_ref) {
  var children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["children", "className", "variant", "icon"]);

  return /*#__PURE__*/React__default['default'].createElement(Box.Flexbox.Container, _extends({
    alignItems: "center",
    className: cx__default['default'](styles$8.feedback, styles$8[variant], className)
  }, props), icon, children && /*#__PURE__*/React__default['default'].createElement("span", {
    className: cx__default['default'](styles$8.text),
    "data-testid": "FormFeedback_index_span"
  }, children));
};

FormFeedback.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  icon: PropTypes__default['default'].any,
  variant: PropTypes__default['default'].string
};

var style$7 = {"field":"Field-module_field__29vAU","name":"Field-module_name__3oQCM","required":"Field-module_required__3L5H8"};

var FormField = function FormField(_ref) {
  var children = _ref.children,
      label = _ref.label,
      required = _ref.required,
      name = _ref.name,
      className = _ref.className,
      meta = _ref.meta,
      props = _objectWithoutProperties(_ref, ["children", "label", "required", "name", "className", "meta"]);

  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](style$7.field, className)
  }, props, {
    "data-testid": "FormField_index_div"
  }), label && /*#__PURE__*/React__default['default'].createElement(Form.Label, {
    htmlFor: name,
    className: cx__default['default'](style$7.name),
    required: required
  }, label, required && /*#__PURE__*/React__default['default'].createElement("span", {
    className: cx__default['default'](style$7.required),
    "data-testid": "FormField_index_span"
  }, "*")), children, /*#__PURE__*/React__default['default'].createElement(Form.FieldError, {
    name: name,
    meta: meta
  }));
};

FormField.propTypes = {
  children: PropTypes__default['default'].node.isRequired,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  label: PropTypes__default['default'].node,
  meta: PropTypes__default['default'].object.isRequired,
  name: PropTypes__default['default'].string,
  required: PropTypes__default['default'].bool
};
FormField.defaultProps = {
  meta: {}
};

var style$6 = {"description":"FormFieldError-module_description__9eFE8","error":"FormFieldError-module_error__1moOh"};

var FormFieldError = function FormFieldError(_ref) {
  var className = _ref.className,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      dirtySinceLastSubmit = _ref$meta.dirtySinceLastSubmit,
      submitError = _ref$meta.submitError,
      submitting = _ref$meta.submitting,
      props = _objectWithoutProperties(_ref, ["className", "meta"]);

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, (error || submitError && !dirtySinceLastSubmit && !submitting) && touched && /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](style$6.description, _defineProperty({}, style$6.error, error || submitError), className)
  }, props, {
    "data-testid": "FormFieldError_index_div"
  }), (error || submitError) && /*#__PURE__*/React__default['default'].createElement("span", {
    "data-testid": "FormFieldError_index_span"
  }, error || submitError)));
};

FormFieldError.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  meta: PropTypes__default['default'].shape({
    dirtySinceLastSubmit: PropTypes__default['default'].bool,
    error: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].bool]),
    submitError: PropTypes__default['default'].string,
    submitting: PropTypes__default['default'].bool,
    touched: PropTypes__default['default'].bool
  }).isRequired
};

var style$5 = {"container":"FieldStatus-module_container__1SM2K","visible":"FieldStatus-module_visible__3WaqQ","loading":"FieldStatus-module_loading__2CrSC","spinner-border":"FieldStatus-module_spinner-border__1l77a"};

var FieldStatus = function FieldStatus(_ref) {
  var _cx;

  var className = _ref.className,
      message = _ref.message,
      variant = _ref.variant,
      show = _ref.show,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "message", "variant", "show", "children"]);

  var classes = cx__default['default'](style$5.container, variant && "validation-".concat(variant), (_cx = {}, _defineProperty(_cx, style$5.visible, show), _defineProperty(_cx, style$5.loading, variant === 'loading'), _cx), className);
  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: classes,
    "data-validation": variant !== 'loading' ? message : null
  }, props, {
    "data-testid": "FormFieldStatus_index_div"
  }), /*#__PURE__*/React__default['default'].cloneElement(children, {
    isInlineRight: true
  }));
};

FieldStatus.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /**
   * Inline validation message
   */
  message: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].element]).isRequired,
  show: PropTypes__default['default'].bool,

  /**
   * Inline validation variant it can be success or danger
   */
  variant: PropTypes__default['default'].oneOf(['success', 'danger', 'warning', 'loading'])
};
FieldStatus.defaultProps = {
  variant: 'success'
};

var style$4 = {"datePicker":"Date-module_datePicker__3Roki","error":"Date-module_error__2qb0v"};

var Failure = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#FF4440' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '20' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_failure_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m10 0c5.5228475 0 10 4.4771525 10 10s-4.4771525 10-10 10-10-4.4771525-10-10 4.4771525-10 10-10zm-3.29525886 5.29248734c-.38998312-.38998312-1.02227068-.38998312-1.4122538 0s-.38998312 1.02227068 0 1.4122538l3.29525886 3.29525886-3.29525886 3.2952589c-.38998312.3899831-.38998312 1.0222706 0 1.4122538.38998312.3899831 1.02227068.3899831 1.4122538 0l3.29525886-3.2952589 3.2952589 3.2952589c.3899831.3899831 1.0222706.3899831 1.4122538 0 .3899831-.3899832.3899831-1.0222707 0-1.4122538l-3.2952589-3.2952589 3.2952589-3.29525886c.3899831-.38998312.3899831-1.02227068 0-1.4122538-.3899832-.38998312-1.0222707-.38998312-1.4122538 0l-3.2952589 3.29525886z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_failure_path"
  }));
});

var Success = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#28BF6F' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '20' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_success_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m10 0c5.5228475 0 10 4.4771525 10 10s-4.4771525 10-10 10-10-4.4771525-10-10 4.4771525-10 10-10zm5.6845058 5.83742051c-.4263673-.44719343-1.1076892-.44894255-1.5283684-.01082225l-5.57959797 5.93530224-2.720151-2.88602764c-.42484987-.44123137-1.11454898-.44356653-1.5379643-.0025967-.42636728.44404418-.42303888 1.15631524.00084078 1.59776864l3.4897725 3.6966451c.42737369.4450923 1.11133946.4412294 1.53548443-.0005003l6.33866276-6.72583741c.419652-.43705052.4247365-1.15983441.0013212-1.60393168z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_success_path"
  }));
});

var CardSettings = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color;
      _ref.width;
      _ref.height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    "data-testid": "Default_settings_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_settings_title"
  }, "icon/settings"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon/settings",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Default_settings_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Bounds",
    points: "0 0 23.9999985 0 23.9999985 23.9999985 0 23.9999985",
    "data-testid": "Default_settings_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16,15 C17.3062521,15 18.4175144,15.8348501 18.8293257,17.0000889 L21,17 C21.5522847,17 22,17.4477153 22,18 C22,18.5522847 21.5522847,19 21,19 L18.8289758,19.0009007 C18.4168852,20.1656226 17.3058822,21 16,21 C14.6941178,21 13.5831148,20.1656226 13.1710242,19.0009007 L3,19 C2.44771525,19 2,18.5522847 2,18 C2,17.4477153 2.44771525,17 3,17 L13.1706743,17.0000889 C13.5824856,15.8348501 14.6937479,15 16,15 Z M16,16.5 C15.1715729,16.5 14.5,17.1715729 14.5,18 C14.5,18.8284271 15.1715729,19.5 16,19.5 C16.8284271,19.5 17.5,18.8284271 17.5,18 C17.5,17.1715729 16.8284271,16.5 16,16.5 Z M8,9 C9.30625206,9 10.4175144,9.8348501 10.8293257,11.0000889 L21,11 C21.5522847,11 22,11.4477153 22,12 C22,12.5522847 21.5522847,13 21,13 L10.8289758,13.0009007 C10.4168852,14.1656226 9.30588222,15 8,15 C6.69411778,15 5.58311485,14.1656226 5.17102423,13.0009007 L3,13 C2.44771525,13 2,12.5522847 2,12 C2,11.4477153 2.44771525,11 3,11 L5.17067428,11.0000889 C5.58248558,9.8348501 6.69374794,9 8,9 Z M8,10.5 C7.17157288,10.5 6.5,11.1715729 6.5,12 C6.5,12.8284271 7.17157288,13.5 8,13.5 C8.82842712,13.5 9.5,12.8284271 9.5,12 C9.5,11.1715729 8.82842712,10.5 8,10.5 Z M16,3 C17.3062521,3 18.4175144,3.8348501 18.8293257,5.00008893 L21,5 C21.5522847,5 22,5.44771525 22,6 C22,6.55228475 21.5522847,7 21,7 L18.8289758,7.00090072 C18.4168852,8.16562257 17.3058822,9 16,9 C14.6941178,9 13.5831148,8.16562257 13.1710242,7.00090072 L3,7 C2.44771525,7 2,6.55228475 2,6 C2,5.44771525 2.44771525,5 3,5 L13.1706743,5.00008893 C13.5824856,3.8348501 14.6937479,3 16,3 Z M16,4.5 C15.1715729,4.5 14.5,5.17157288 14.5,6 C14.5,6.82842712 15.1715729,7.5 16,7.5 C16.8284271,7.5 17.5,6.82842712 17.5,6 C17.5,5.17157288 16.8284271,4.5 16,4.5 Z",
    id: "Combined-Shape",
    fill: color,
    "data-testid": "Default_settings_path"
  })));
});

var Warning = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#ffc107' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '17' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_warning_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -4)",
    "data-testid": "Default_warning_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m0 0h24v24h-24z",
    "data-testid": "Default_warning_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m4.46889451 20.9999987c-.35188519 0-.69754185-.0928401-1.00207254-.2691474-.95592348-.5534294-1.28220942-1.7770016-.72878003-2.7329251l7.53110476-13.00827188c.175087-.30242304.426357-.55369301.72878-.72878003.9559235-.55342938 2.1794958-.22714345 2.7329252.72878003l7.5311047 13.00827188c.1763073.3045307.2691475.6501874.2691475 1.0020725 0 1.1045695-.8954305 2-2 2zm6.74710549-6.719999h1.568l.336-3.0879998.084-2.07200001h-2.408l.084 2.07200001zm.784 4.3880002c.4106687 0 .7466654-.1399986 1.008-.42s.392-.6253313.392-1.036-.1306654-.7559986-.392-1.036-.5973313-.42-1.008-.42-.7466654.1399986-1.008.42-.392.6253313-.392 1.036.1306654.7559986.392 1.036.5973313.42 1.008.42z",
    fill: color,
    "data-testid": "Default_warning_path"
  })));
});

var Calculator = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#120A20' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_calculator_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M18,2 C19.1045695,2 20,2.8954305 20,4 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,4 C4,2.8954305 4.8954305,2 6,2 L18,2 Z M7.5,17 C6.67157288,17 6,17.6715729 6,18.5 C6,19.3284271 6.67157288,20 7.5,20 C8.32842712,20 9,19.3284271 9,18.5 C9,17.6715729 8.32842712,17 7.5,17 Z M12,17 C11.1715729,17 10.5,17.6715729 10.5,18.5 C10.5,19.3284271 11.1715729,20 12,20 C12.8284271,20 13.5,19.3284271 13.5,18.5 C13.5,17.6715729 12.8284271,17 12,17 Z M16.5,13 C15.6715729,13 15,13.6715729 15,14.5 L15,14.5 L15,18.5 C15,19.3284271 15.6715729,20 16.5,20 C17.3284271,20 18,19.3284271 18,18.5 L18,18.5 L18,14.5 C18,13.6715729 17.3284271,13 16.5,13 Z M7.5,13 C6.67157288,13 6,13.6715729 6,14.5 C6,15.3284271 6.67157288,16 7.5,16 C8.32842712,16 9,15.3284271 9,14.5 C9,13.6715729 8.32842712,13 7.5,13 Z M12,13 C11.1715729,13 10.5,13.6715729 10.5,14.5 C10.5,15.3284271 11.1715729,16 12,16 C12.8284271,16 13.5,15.3284271 13.5,14.5 C13.5,13.6715729 12.8284271,13 12,13 Z M7.5,9 C6.67157288,9 6,9.67157288 6,10.5 C6,11.3284271 6.67157288,12 7.5,12 C8.32842712,12 9,11.3284271 9,10.5 C9,9.67157288 8.32842712,9 7.5,9 Z M12,9 C11.1715729,9 10.5,9.67157288 10.5,10.5 C10.5,11.3284271 11.1715729,12 12,12 C12.8284271,12 13.5,11.3284271 13.5,10.5 C13.5,9.67157288 12.8284271,9 12,9 Z M16.5,9 C15.6715729,9 15,9.67157288 15,10.5 C15,11.3284271 15.6715729,12 16.5,12 C17.3284271,12 18,11.3284271 18,10.5 C18,9.67157288 17.3284271,9 16.5,9 Z M17,4 L7,4 C6.44771525,4 6,4.44771525 6,5 L6,5 L6,6 C6,6.55228475 6.44771525,7 7,7 L7,7 L17,7 C17.5522847,7 18,6.55228475 18,6 L18,6 L18,5 C18,4.44771525 17.5522847,4 17,4 L17,4 Z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_calculator_path"
  }));
});

var Calendar = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#120A20' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_calendar_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M4,4 L4,4.99833453 C4,6.66097987 5.34314575,8 7,8 L7,8 L7.17593691,7.99490448 C8.74794518,7.9036074 10,6.59690238 10,4.99833453 L10,4.99833453 L10,4 L14,4 L14,4.99833453 C14,6.60159968 15.24892,7.90394292 16.8237272,7.99492245 L17,8 L17.1759369,7.99490448 C18.7479452,7.9036074 20,6.59690238 20,4.99833453 L20,4.99833453 L20,4 L21.0081969,4 C21.5559546,4 22,4.44494629 22,4.99339768 L22,21.0066023 C22,21.5552407 21.5446944,22 21.0081969,22 L2.99180311,22 C2.44404538,22 2,21.5550537 2,21.0066023 L2,4.99339768 C2,4.44475929 2.45530558,4 2.99180311,4 L4,4 Z M20,10 L4,10 L4,20 L20,20 L20,10 Z M6,17 C6.55228475,17 7,17.4477153 7,18 C7,18.5522847 6.55228475,19 6,19 C5.44771525,19 5,18.5522847 5,18 C5,17.4477153 5.44771525,17 6,17 Z M10,17 C10.5522847,17 11,17.4477153 11,18 C11,18.5522847 10.5522847,19 10,19 C9.44771525,19 9,18.5522847 9,18 C9,17.4477153 9.44771525,17 10,17 Z M14,17 C14.5522847,17 15,17.4477153 15,18 C15,18.5522847 14.5522847,19 14,19 C13.4477153,19 13,18.5522847 13,18 C13,17.4477153 13.4477153,17 14,17 Z M18,17 C18.5522847,17 19,17.4477153 19,18 C19,18.5522847 18.5522847,19 18,19 C17.4477153,19 17,18.5522847 17,18 C17,17.4477153 17.4477153,17 18,17 Z M6,14 C6.55228475,14 7,14.4477153 7,15 C7,15.5522847 6.55228475,16 6,16 C5.44771525,16 5,15.5522847 5,15 C5,14.4477153 5.44771525,14 6,14 Z M10,14 C10.5522847,14 11,14.4477153 11,15 C11,15.5522847 10.5522847,16 10,16 C9.44771525,16 9,15.5522847 9,15 C9,14.4477153 9.44771525,14 10,14 Z M14,14 C14.5522847,14 15,14.4477153 15,15 C15,15.5522847 14.5522847,16 14,16 C13.4477153,16 13,15.5522847 13,15 C13,14.4477153 13.4477153,14 14,14 Z M18,14 C18.5522847,14 19,14.4477153 19,15 C19,15.5522847 18.5522847,16 18,16 C17.4477153,16 17,15.5522847 17,15 C17,14.4477153 17.4477153,14 18,14 Z M6,11 C6.55228475,11 7,11.4477153 7,12 C7,12.5522847 6.55228475,13 6,13 C5.44771525,13 5,12.5522847 5,12 C5,11.4477153 5.44771525,11 6,11 Z M10,11 C10.5522847,11 11,11.4477153 11,12 C11,12.5522847 10.5522847,13 10,13 C9.44771525,13 9,12.5522847 9,12 C9,11.4477153 9.44771525,11 10,11 Z M14,11 C14.5522847,11 15,11.4477153 15,12 C15,12.5522847 14.5522847,13 14,13 C13.4477153,13 13,12.5522847 13,12 C13,11.4477153 13.4477153,11 14,11 Z M18,11 C18.5522847,11 19,11.4477153 19,12 C19,12.5522847 18.5522847,13 18,13 C17.4477153,13 17,12.5522847 17,12 C17,11.4477153 17.4477153,11 18,11 Z M7,2 C7.55228475,2 8,2.44335318 8,3.0093689 L8,4.9906311 C8,5.50827165 7.61727982,5.93490293 7.11733256,5.99320924 L7,6 C6.44771525,6 6,5.55664682 6,4.9906311 L6,3.0093689 C6,2.49172835 6.38272018,2.06509707 6.88266744,2.00679076 L7,2 Z M17,2 C17.5522847,2 18,2.44335318 18,3.0093689 L18,4.9906311 C18,5.50827165 17.6172798,5.93490293 17.1173326,5.99320924 L17,6 C16.4477153,6 16,5.55664682 16,4.9906311 L16,3.0093689 C16,2.49172835 16.3827202,2.06509707 16.8826674,2.00679076 L17,2 Z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_calendar_path"
  }));
});

var Calendar2 = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_calendar2_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14 4v.998A2.998 2.998 0 0017 8l.176-.005A3.003 3.003 0 0020 4.998v-.463c1.196.692 2 1.983 2 3.46v10.01A3.998 3.998 0 0118 22H6a4 4 0 01-4-3.995V7.995c0-1.479.805-2.77 2-3.46v.463A2.998 2.998 0 007 8l.176-.005A3.003 3.003 0 0010 4.998V4h4zm4.006 6H5.994C4.894 10 4 10.895 4 12v6c0 1.113.893 2 1.994 2h12.012c1.1 0 1.994-.895 1.994-2v-6c0-1.113-.893-2-1.994-2zM6 17a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM6 14a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM6 11a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM7 2a1 1 0 011 1.01v1.98c0 .518-.383.945-.883 1.003L7 6a1 1 0 01-1-1.01V3.01c0-.518.383-.945.883-1.003L7 2zm10 0a1 1 0 011 1.01v1.98c0 .518-.383.945-.883 1.003L17 6a1 1 0 01-1-1.01V3.01c0-.518.383-.945.883-1.003L17 2z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_calendar2_path"
  }));
});

var Checkmark = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_checkmark_svg"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    fill: color,
    fillRule: "evenodd",
    points: "4.41 11.48 8.877 15.944 19.59 5.23 21 6.65 8.879 18.772 3 12.89",
    "data-testid": "Default_checkmark_polygon"
  }));
});

var Clock = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_clock_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm0 2a1 1 0 011 1v4.423l4.696 2.711a1 1 0 11-1 1.732l-5.196-3-.015-.009-.028-.017-.015-.01.017.01-.023-.015-.05-.035a1.108 1.108 0 01-.043-.036l-.02-.017-.017-.017a1.23 1.23 0 01-.078-.085l-.04-.052-.022-.032a1.043 1.043 0 01-.035-.056l-.012-.022-.012-.022a.856.856 0 01-.067-.17l-.008-.029a.82.82 0 01-.015-.069l-.004-.024-.004-.023A.79.79 0 0111 12V7a1 1 0 011-1z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_clock_path"
  }));
});

var Guide = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#7A34FF' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: width,
    width: height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_guide_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19,3 C20.1045695,3 21,3.8954305 21,5 L21,15 L20.994,15 L20.8735518,15.1431486 C20.4705201,15.6539169 20.23,16.2988702 20.23,17 C20.23,17.76889 20.5192564,18.4702205 20.9948871,19.0011096 L21,19 L20.999,19.018 L20.9945143,19.1492623 C20.989946,19.2111821 20.9825586,19.2723178 20.9724798,19.3325417 C20.9656661,19.3732156 20.9576977,19.4131594 20.9485594,19.4526552 C20.9442612,19.4712144 20.9398096,19.4892738 20.9351147,19.5072347 C20.9272664,19.5372715 20.9186761,19.5672286 20.9094138,19.5968891 C20.9027786,19.6181491 20.8956923,19.6395591 20.8882575,19.6608055 C20.8784901,19.688701 20.8682599,19.7159705 20.8574589,19.7429498 C20.8512348,19.7585041 20.8446935,19.7742582 20.8379582,19.7899092 C20.824732,19.820642 20.8107673,19.8509572 20.7960781,19.8808521 C20.7876256,19.8980459 20.7791195,19.9147478 20.7703877,19.9313123 C20.7575155,19.9557385 20.7440322,19.9800732 20.730063,20.0040903 C20.7209505,20.0197573 20.7116387,20.035277 20.7021244,20.0506581 C20.6852209,20.0779774 20.6678081,20.1046703 20.6497855,20.1309115 C20.6380037,20.1480655 20.6259815,20.1649988 20.6137053,20.1817341 C20.5646658,20.2485663 20.5117721,20.3120297 20.4552125,20.3719979 C20.4437786,20.3841204 20.432216,20.3960789 20.420507,20.4078921 C20.4151928,20.4132573 20.4093785,20.4190559 20.4035289,20.4248186 C20.3746544,20.4532809 20.3444791,20.4812552 20.3134622,20.5082883 C20.2391561,20.5730264 20.1603412,20.632159 20.0773394,20.6853279 C20.0676458,20.6915413 20.0574097,20.6979725 20.0471117,20.7043129 C20.0174035,20.7225994 19.9873936,20.7400146 19.9569027,20.7566592 C19.9513305,20.7596991 19.9461974,20.7624704 19.9410508,20.7652198 C19.660575,20.9150559 19.3402074,21 19,21 L7,21 C4.790861,21 3,19.209139 3,17 L3,7 C3,4.790861 4.790861,3 7,3 L19,3 Z M18.6460127,15.0000709 L7,15 C5.8954305,15 5,15.8954305 5,17 C5,18.0543618 5.81587779,18.9181651 6.85073766,18.9945143 L7,19 L18.6464877,19.0008291 C18.3785873,18.3881746 18.23,17.7114395 18.23,17 C18.23,16.2889227 18.378436,15.6125146 18.6460127,15.0000709 Z M12,5 C9.790861,5 8,6.790861 8,9 C8,11.209139 9.790861,13 12,13 C14.209139,13 16,11.209139 16,9 C16,6.790861 14.209139,5 12,5 Z M12,8 C12.3796958,8 12.693491,8.28215388 12.7431534,8.64822944 L12.75,8.75 L12.75,11.25 L12.7431534,11.3517706 C12.693491,11.7178461 12.3796958,12 12,12 C11.6203042,12 11.306509,11.7178461 11.2568466,11.3517706 L11.25,11.25 L11.25,8.75 L11.2568466,8.64822944 C11.306509,8.28215388 11.6203042,8 12,8 Z M12,6 C12.4142136,6 12.75,6.33578644 12.75,6.75 C12.75,7.16421356 12.4142136,7.5 12,7.5 C11.5857864,7.5 11.25,7.16421356 11.25,6.75 C11.25,6.33578644 11.5857864,6 12,6 Z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_guide_path"
  }));
});

var Help = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#7A34FF' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_help_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M11.8971346,14.9226594 C11.6720106,14.9226594 11.4581459,14.9633646 11.2555343,15.0447761 C11.0529226,15.1261877 10.8756401,15.2374484 10.7236814,15.3785617 C10.5717226,15.5196751 10.4535343,15.6852094 10.3691128,15.8751696 C10.2846912,16.0651299 10.2424811,16.2632283 10.2424811,16.4694708 C10.2424811,16.6865682 10.2875052,16.8873804 10.3775549,17.0719132 C10.4676045,17.256446 10.5886068,17.4192666 10.7405656,17.5603799 C10.8925243,17.7014932 11.0669928,17.8100403 11.2639764,17.8860244 C11.4609599,17.9620085 11.6720106,18 11.8971346,18 C12.3586389,18 12.7469721,17.8507478 13.0621458,17.5522388 C13.3773195,17.2537299 13.5349039,16.8873834 13.5349039,16.4531886 C13.5349039,16.2469461 13.4926938,16.0488476 13.4082723,15.8588874 C13.3238508,15.6689271 13.2056624,15.5061065 13.0537037,15.3704206 C12.9017449,15.2347347 12.7272764,15.1261877 12.5302929,15.0447761 C12.3333093,14.9633646 12.1222587,14.9226594 11.8971346,14.9226594 Z M12.0153242,6 C11.4750264,6 10.9628769,6.07326928 10.4788602,6.21981004 C9.99484346,6.3663508 9.56148616,6.58615864 9.17877527,6.87924016 C8.79606438,7.17232168 8.48370944,7.54138176 8.24170108,7.98643148 C8.16749502,8.1228953 8.09467815,8.30566693 8.02325046,8.53474636 C8.00641124,8.5887523 7.99500579,8.64430449 7.98920381,8.70057649 C7.94105969,9.16751385 8.2805587,9.58506989 8.74749606,9.63321401 L9.74745496,9.7363692 C10.0955201,9.77225685 10.4255693,9.5914803 10.5857218,9.28888199 L10.632619,9.18363914 C10.6979717,9.00551255 10.7705364,8.86424523 10.850313,8.75983718 C11.0866933,8.45047335 11.4412583,8.29579376 11.9140188,8.29579376 C12.2967297,8.29579376 12.5978286,8.39891349 12.8173246,8.60515604 C13.0368206,8.81139859 13.1465669,9.08819365 13.1465669,9.43554953 C13.1465669,9.68521156 13.0790307,9.89959205 12.9439562,10.0786974 C12.8539066,10.198101 12.7513512,10.3138852 12.6362885,10.4260514 L11.8971346,11.0963365 C11.6720106,11.2808693 11.477844,11.459972 11.3146291,11.6336499 C11.1514141,11.8073279 11.0135277,11.9864306 10.9009657,12.1709634 C10.7884036,12.3554962 10.7039834,12.559022 10.6477024,12.7815468 C10.5914214,13.0040717 10.5632813,13.2564436 10.5632813,13.5386703 C10.5632813,13.8803824 10.8402937,14.1573948 11.1820058,14.1573948 L12.7738817,14.1573948 C13.0076847,14.1573948 13.1972195,13.96786 13.1972195,13.734057 C13.1972195,13.5603791 13.2112896,13.4111268 13.2394301,13.2862958 C13.2675706,13.1614648 13.3154087,13.042063 13.382946,12.9280868 C13.4504832,12.8141107 13.5433455,12.7028499 13.6615356,12.5943012 C13.7797257,12.4857525 13.9288682,12.3609234 14.1089674,12.21981 C14.4016287,12.0027126 14.6633315,11.7937595 14.8940836,11.5929444 C15.1248358,11.3921293 15.3218164,11.1777488 15.4850313,10.9497965 C15.6482462,10.7218442 15.7748766,10.4721859 15.8649262,10.2008141 C15.9549759,9.92944233 16,9.61465579 16,9.25644505 C16,8.69199175 15.8874397,8.20352988 15.6623156,7.79104478 C15.4371916,7.37855967 15.1389067,7.03935004 14.767452,6.7734057 C14.3959973,6.50746136 13.971082,6.31207661 13.4926934,6.18724559 C13.0143048,6.06241457 12.5218533,6 12.0153242,6 Z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_help_path"
  }));
});

var Issue = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#FF4440' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_issue_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Default_issue_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z",
    fill: color,
    "data-testid": "Default_issue_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12,14.098 C12.45,14.098 12.774,13.792 12.828,13.306 L13.602,6.538 C13.656,6.016 13.368,5.62 12.882,5.62 L11.118,5.62 C10.632,5.62 10.344,6.016 10.398,6.538 L11.172,13.306 C11.226,13.792 11.55,14.098 12,14.098 Z M12,18.382 C12.9,18.382 13.566,17.716 13.566,16.852 L13.566,16.816 C13.566,15.952 12.9,15.286 12,15.286 C11.1,15.286 10.434,15.952 10.434,16.816 L10.434,16.852 C10.434,17.716 11.1,18.382 12,18.382 Z",
    fill: "#fff",
    "data-testid": "Default_issue_path"
  })));
});

var Info = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 12 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_info_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Standard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Default_info_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_info",
    fill: color,
    "data-testid": "Default_info_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M8,0 C10.209139,-4.05812251e-16 12,1.790861 12,4 L12,8 C12,10.209139 10.209139,12 8,12 L4,12 C1.790861,12 2.705415e-16,10.209139 0,8 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 L8,0 Z M6.65546875,4.6484375 L4.89179688,4.6484375 C4.62226563,4.6484375 4.4328125,4.69726562 4.3234375,4.79492188 C4.2140625,4.89257812 4.159375,5.05664062 4.159375,5.28710938 C4.159375,5.51757812 4.21601563,5.68261719 4.32929688,5.78222656 C4.42369792,5.86523438 4.56963976,5.9136556 4.7671224,5.92749023 L4.89179688,5.93164062 L5.55390625,5.93164062 L5.55390625,8.77929688 L4.29414063,8.77929688 C4.02070313,8.77929688 3.82832031,8.828125 3.71699219,8.92578125 C3.60566406,9.0234375 3.55,9.18554688 3.55,9.41210938 C3.55,9.64257812 3.60761719,9.80859375 3.72285156,9.91015625 C3.81888021,9.99479167 3.96712782,10.0441623 4.1675944,10.0582682 L4.29414063,10.0625 L8.25507813,10.0625 C8.52070313,10.0625 8.71113281,10.0117188 8.82636719,9.91015625 C8.94160156,9.80859375 8.99921875,9.64257812 8.99921875,9.41210938 C8.99921875,9.18554688 8.94257813,9.0234375 8.82929688,8.92578125 C8.73489583,8.84440104 8.58624132,8.79692925 8.38333333,8.78336589 L8.25507813,8.77929688 L6.9953125,8.77929688 L6.9953125,4.90039062 C6.9953125,4.82226562 6.96601563,4.76074219 6.90742188,4.71582031 C6.86347656,4.68212891 6.80524902,4.66107178 6.73273926,4.65264893 L6.65546875,4.6484375 Z M6.10471231,1.75 C5.67652803,1.75 5.40010526,1.82454739 5.27544402,1.97364217 C5.15078277,2.12273695 5.08845215,2.4699148 5.08845215,3.01517572 C5.08845215,3.30910543 5.14942776,3.50505857 5.27137898,3.60303514 C5.3933302,3.70101171 5.66568792,3.75 6.08845215,3.75 C6.52205648,3.75 6.79712424,3.69781683 6.9136554,3.59345048 C7.03018657,3.48908413 7.08845215,3.21964856 7.08845215,2.78514377 C7.08845215,2.33359957 7.0234115,2.04818956 6.8933302,1.92891374 C6.7632489,1.80963791 6.50037627,1.75 6.10471231,1.75 Z",
    id: "Shape",
    "data-testid": "Default_info_path"
  }))));
});

var Return = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#7A34FF' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_return_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M11.8833789,18.9932723 C11.3860402,18.9355072 11,18.5128358 11,18 C11,17.4477153 11.4477153,17 12,17 L12,17 L16,17 C18.209139,17 20,15.209139 20,13 C20,10.8578046 18.3160315,9.10892112 16.1996403,9.00489531 L16,9 L5.421,8.99910678 L8.70680912,12.28 C9.09773029,12.6705243 9.09773029,13.3094757 8.70680912,13.7 C8.31588794,14.0905243 7.68629733,14.0905243 7.29537615,13.7 L2.29319088,8.70264069 C1.90226971,8.3121164 1.90226971,7.67895142 2.29319088,7.28842712 L7.29537615,2.29 C7.68629733,1.89947571 8.31588794,1.89947571 8.70680912,2.29 C9.09773029,2.68052429 9.09773029,3.31947571 8.70680912,3.71 L5.413,6.99910678 L16,7 C19.3137085,7 22,9.6862915 22,13 C22,16.3137085 19.3137085,19 16,19 L12,19 Z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_return_path"
  }));
});

var styles$7 = {"loading":"LoadingIcon-module_loading__3Lv_s","spinner-border":"LoadingIcon-module_spinner-border__3In7G"};

var LoadingIcon = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      className = _ref.className;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    role: "status",
    "data-testid": "LoadingIcon_loading_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,14.258231 23.3762203,16.3707704 22.2915649,18.1747141 L20.5763803,17.1454684 C21.4802128,15.6422098 22,13.8818063 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,13.8822261 2.52001916,15.6429951 3.42422463,17.1464744 L1.70903973,18.1757196 C0.624011557,16.3715554 0,14.2586506 0,12 C0,5.372583 5.372583,0 12,0 Z",
    fill: "currentcolor",
    fillRule: "evenodd",
    "data-testid": "LoadingIcon_loading_path"
  }));
});

var Loading = function Loading(_ref) {
  _ref.variant;
      var size = _ref.size;
      _ref.children;
      var className = _ref.className;
      _objectWithoutProperties(_ref, ["variant", "size", "children", "className"]);

  return /*#__PURE__*/React__default['default'].createElement(LoadingIcon, {
    className: cx__default['default'](className, size && size, styles$7.loading),
    "data-testid": "LoadingIcon_index_LoadingIcon"
  });
};

Loading.propTypes = {
  /**
   * Color of base element (to determine whether to use light or dark loader)
   */
  variant: PropTypes__default['default'].oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link', 'facebook', 'github', 'google', 'linkedin', 'twitter']),

  /**
   * Component size presets
   */
  size: PropTypes__default['default'].oneOf(['sm']),

  /**
   * This component may be used to wrap child elements or components
   */
  children: PropTypes__default['default'].element,

  /**
   * An ARIA accessible role - typically status
   */
  role: PropTypes__default['default'].string
};
Loading.defaultProps = {
  role: 'status',
  variant: 'primary'
};

var FacebookIcon = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'loginIcon/facebook' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '30px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '30px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    version: "1.1",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_facebook_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_facebook_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "loginIcon/facebook",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_facebook_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M30,15 C30,6.71572266 23.2842773,0 15,0 C6.71572266,0 0,6.71572266 0,15 C0,22.4869336 5.4852832,28.6924805 12.65625,29.8177734 L12.65625,19.3359375 L8.84765625,19.3359375 L8.84765625,15 L12.65625,15 L12.65625,11.6953125 C12.65625,7.9359375 14.8956445,5.859375 18.3219727,5.859375 C19.9630957,5.859375 21.6796875,6.15234375 21.6796875,6.15234375 L21.6796875,9.84375 L19.7882227,9.84375 C17.9248535,9.84375 17.34375,11 17.34375,12.1862402 L17.34375,15 L21.5039062,15 L20.8388672,19.3359375 L17.34375,19.3359375 L17.34375,29.8177734 C24.5147168,28.6924805 30,22.4869336 30,15",
    fill: color,
    "data-testid": "Default_facebook_path"
  })));
});

var GoogleIconSVG = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '27' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '27' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "GoogleIcon_google_svg"
  }, /*#__PURE__*/React__default['default'].createElement("defs", {
    "data-testid": "GoogleIcon_google_defs"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "a",
    d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z",
    "data-testid": "GoogleIcon_google_path"
  })), /*#__PURE__*/React__default['default'].createElement("clipPath", {
    id: "b",
    "data-testid": "GoogleIcon_google_clipPath"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z",
    "data-testid": "GoogleIcon_google_path"
  })), /*#__PURE__*/React__default['default'].createElement("path", {
    clipPath: "url(#b)",
    d: "M0 37V11l17 13z",
    fill: "#FBBC05",
    "data-testid": "GoogleIcon_google_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    clipPath: "url(#b)",
    d: "M0 11l17 13 7-6.1L48 14V0H0z",
    fill: "#EA4335",
    "data-testid": "GoogleIcon_google_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    clipPath: "url(#b)",
    d: "M0 37l30-23 7.9 1L48 0v48H0z",
    fill: "#34A853",
    "data-testid": "GoogleIcon_google_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    clipPath: "url(#b)",
    d: "M48 48L17 24l-4-3 35-10z",
    fill: "#4285F4",
    "data-testid": "GoogleIcon_google_path"
  }));
});

var styles$6 = {"whiteBackground":"GoogleIcon-module_whiteBackground__VXhlL","svg":"GoogleIcon-module_svg__7kM8f"};

var GoogleIcon = function GoogleIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: cx__default['default'](styles$6['whiteBackground'], className),
    "data-testid": "GoogleIcon_index_div"
  }, /*#__PURE__*/React__default['default'].createElement(GoogleIconSVG, {
    "data-testid": "GoogleIcon_index_GoogleIconSVG"
  }));
};

GoogleIcon.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var OverflowIcon = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'icon/overflow' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_overflow_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_overflow_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon/overflow",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_overflow_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Bounds",
    points: "0 0 23.9999985 0 23.9999985 23.9999985 0 23.9999985",
    "data-testid": "Default_overflow_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "shape",
    d: "M5.99999976,9.9999994 C4.8999998,9.9999994 3.99999976,10.8999989 3.99999976,11.9999994 C3.99999976,13.0999995 4.8999998,13.9999994 5.99999976,13.9999994 C7.09999947,13.9999994 7.99999976,13.0999995 7.99999976,11.9999994 C7.99999976,10.8999989 7.09999947,9.9999994 5.99999976,9.9999994 Z M17.999999,9.9999994 C16.8999986,9.9999994 15.999999,10.8999989 15.999999,11.9999994 C15.999999,13.0999995 16.8999986,13.9999994 17.999999,13.9999994 C19.0999992,13.9999994 19.999999,13.0999995 19.999999,11.9999994 C19.999999,10.8999989 19.0999992,9.9999994 17.999999,9.9999994 Z M11.9999994,9.9999994 C10.8999989,9.9999994 9.9999994,10.8999989 9.9999994,11.9999994 C9.9999994,13.0999995 10.8999989,13.9999994 11.9999994,13.9999994 C13.0999995,13.9999994 13.9999994,13.0999995 13.9999994,11.9999994 C13.9999994,10.8999989 13.0999995,9.9999994 11.9999994,9.9999994 Z",
    fill: color,
    "data-testid": "Default_overflow_path"
  })));
});

var PicoIcon = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 280 280",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_pico_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M180 260.876l-37.468-13.625A16 16 0 0 1 132 232.215V155.42L26.638 59.637C9.672 44.213 0 22.928 0 0h180v260.876zm36 13.091V0h32c8.837 0 16 7.163 16 16v264a8 8 0 0 1-10.734 7.518L216 273.967z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_pico_path"
  }));
});

var PicoIcon2 = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 420 420",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_pico2_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_pico2_title"
  }, "brandmark/white/circle"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "brandmark/white/circle",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Default_pico2_g"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    id: "bounds",
    fill: "#7A34FF",
    x: "0",
    y: "0",
    width: "420",
    height: "420",
    "data-testid": "Default_pico2_rect"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M230.363636,309.791378 L200.420328,298.88779 C195.364691,297.046825 192,292.240777 192,286.860385 L192,225.390656 L192,225.390656 L107.790094,148.729949 C94.2304527,136.385894 86.5,119.350757 86.5,101 L230.363636,101 L230.363636,309.791378 Z M259.136364,320.268709 L259.136364,101 L284.7,101 C291.769245,101 297.5,106.730755 297.5,113.8 L297.5,325.096869 C297.5,328.631491 294.634622,331.496869 291.1,331.496869 C290.353106,331.496869 289.611976,331.36613 288.910164,331.110571 L259.136364,320.268709 L259.136364,320.268709 Z",
    id: "Picrow",
    fill: "#FFFFFF",
    "data-testid": "Default_pico2_path"
  })));
});

var Plus = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'addOption/default' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '18px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '18px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    version: "1.1",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_plus_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_plus_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Inputs",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_plus_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "addOption/default",
    fill: color,
    "data-testid": "Default_plus_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Combined-Shape",
    d: "M9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M9,2 C5.13400675,2 2,5.13400675 2,9 C2,12.8659932 5.13400675,16 9,16 C12.8659932,16 16,12.8659932 16,9 C16,5.13400675 12.8659932,2 9,2 Z M9,4 C9.55228475,4 10,4.44771525 10,5 L10,8 L13,8 C13.5522847,8 14,8.44771525 14,9 C14,9.55228475 13.5522847,10 13,10 L10,10 L10,13 C10,13.5522847 9.55228475,14 9,14 C8.44771525,14 8,13.5522847 8,13 L8,10 L5,10 C4.44771525,10 4,9.55228475 4,9 C4,8.44771525 4.44771525,8 5,8 L8,8 L8,5 C8,4.44771525 8.44771525,4 9,4 Z",
    "data-testid": "Default_plus_path"
  }))));
});

var Minus = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'removeOption/default' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '18px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '18px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    version: "1.1",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_minus_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_minus_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Inputs",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_minus_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "removeOption/default",
    fill: color,
    "data-testid": "Default_minus_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Combined-Shape",
    d: "M9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M9,2 C5.13400675,2 2,5.13400675 2,9 C2,12.8659932 5.13400675,16 9,16 C12.8659932,16 16,12.8659932 16,9 C16,5.13400675 12.8659932,2 9,2 Z M13,8 C13.5522847,8 14,8.44771525 14,9 C14,9.55228475 13.5522847,10 13,10 L5,10 C4.44771525,10 4,9.55228475 4,9 C4,8.44771525 4.44771525,8 5,8 L13,8 Z",
    "data-testid": "Default_minus_path"
  }))));
});

var TwitterIcon = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1DA1F2' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_twitter_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Default_twitter_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "0 0 100 0 100 100 0 100",
    "data-testid": "Default_twitter_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M38.405,75.3975 C61.99,75.3975 74.89,55.8575 74.89,38.9125 C74.89,38.3575 74.89,37.805 74.8525,37.255 C77.3620784,35.4397771 79.5283887,33.1921985 81.25,30.6175 C78.9096976,31.6545044 76.4270732,32.3345716 73.885,32.635 C76.56186,31.0324551 78.5653088,28.51193 79.5225,25.5425 C77.0053937,27.0361383 74.2516153,28.0887801 71.38,28.655 C67.4052069,24.4284857 61.0892984,23.3940315 55.9738732,26.1316998 C50.858448,28.8693682 48.2156875,34.6983143 49.5275,40.35 C39.2172393,39.8331238 29.6111895,34.9633082 23.1,26.9525 C19.6965569,32.8116118 21.4349697,40.3071487 27.07,44.07 C25.029353,44.0095189 23.0331984,43.4590329 21.25,42.465 L21.25,42.6275 C21.2516703,48.7314824 25.5543787,53.9888379 31.5375,55.1975 C29.649674,55.7123501 27.6689515,55.7876107 25.7475,55.4175 C27.4273698,60.6410571 32.2414364,64.2194597 37.7275,64.3225 C33.1868376,67.8910799 27.5776488,69.8283193 21.8025,69.8225 C20.7822589,69.8205414 19.7630102,69.7587687 18.75,69.6375 C24.6140899,73.4006914 31.4372835,75.3967923 38.405,75.3875",
    fill: color,
    fillRule: "nonzero",
    "data-testid": "Default_twitter_path"
  })));
});

var Tada = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'party_popper' : _ref$title;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "58px",
    width: "60px",
    version: "1.1",
    viewBox: "0 0 60 58",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_tada_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_tada_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "party_popper",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_tada_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#F7B600",
    fillRule: "nonzero",
    points: "0 58 8.6 55 2.1 52",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#FFDD7D",
    fillRule: "nonzero",
    points: "24.9 33.4 12.8 21.2 10.8 26.8",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#F7B600",
    fillRule: "nonzero",
    points: "10.8 26.8 8.6 33.1 35.4 45.6 36.7 45.2 24.9 33.4",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#FFDD7D",
    fillRule: "nonzero",
    points: "6.5 39.4 26.5 48.7 35.4 45.6 8.6 33.1",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#F7B600",
    fillRule: "nonzero",
    points: "4.3 45.7 17.5 51.9 26.5 48.7 6.5 39.4",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#FFDD7D",
    fillRule: "nonzero",
    points: "4.3 45.7 2.1 52 8.6 55 17.5 51.9",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M29.9,28.2 C36.6,34.8 40.1,42.2 37.7,44.6 C35.2,47 27.8,43.6 21,36.9 C14.3,30.3 10.8,22.9 13.2,20.5 C15.7,18.1 23.1,21.6 29.9,28.2",
    fill: "#493816",
    fillRule: "nonzero",
    "data-testid": "Default_tada_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M21.5,11.5 C19.9,9.2 21.6,8.2 23.8,8.6 C21.7,6.1 23,4.3 26.3,5 C27.3,5.2 25.9,6.9 25,6.9 C27.7,8.9 26.2,11.1 23.3,10.6 C25.9,14.1 21.5,13.2 19.5,13.4 C19,16 22,19 21,19 C18.8,19 15.2,10.7 21.5,11.5",
    fill: "#42ADE2",
    fillRule: "nonzero",
    "data-testid": "Default_tada_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M42.5,16.3 C41,17 36.8,10.4 42,10.3 C39,7.6 39.4,6.3 43.4,6.2 C38.8,1.6 46.1,1.33226763e-15 46.8,2.4 C47,3.1 44.6,1.8 43.8,3.1 C42.9,4.6 49.4,8.5 42.7,8.2 C45.2,10.7 45.3,11.9 41.4,12.3 C41.9,13.1 43.5,15.9 42.5,16.3",
    fill: "#FF8736",
    fillRule: "nonzero",
    "data-testid": "Default_tada_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M44.2,31.9 L45.7,30.6 C45.7,30.6 47.1,32.7 48.1,33.5 C48.9,29.9 48.7,27.8 52.8,30.2 C50.5,24 54.3,26.3 58,28 C57.8,26.4 58,26.6 59.6,26.1 C61,31.4 57.2,29.8 54.2,28.1 C56,32.9 54.1,32.6 50.3,31 C50.2,33 49.6,35.3 48.4,35.5 C47,35.9 44.2,31.9 44.2,31.9",
    fill: "#ED4C5C",
    fillRule: "nonzero",
    "data-testid": "Default_tada_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M33,17.1 C31.2,19.5 28.3,20.8 26.2,22.9 C24,25.1 22.7,31.1 22.7,31.1 C22.7,31.1 23.5,24.8 25.6,22.4 C27.5,20.2 30.3,18.6 31.8,16.1 C34.4,11.5 32,5.5 28.6,2 C29.3,1.4 30.3,0.6 30.8,1.77635684e-15 C34.1,4.1 36.9,12 33,17.1",
    fill: "#C28FEF",
    fillRule: "nonzero",
    "data-testid": "Default_tada_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M36.1,22.2 C33.5,24.1 31.6,26.9 29.8,29.5 C28.2,31.8 23.1,34.7 23.1,34.7 C23.1,34.7 27.9,31.4 29.4,29 C31.2,26 33,22.9 35.8,20.7 C41.4,16.4 49.5,16.8 55.8,19.1 C55.4,20 54.7,21.9 54.7,21.9 C54.7,21.9 41.4,18.3 36.1,22.2",
    fill: "#FF8736",
    fillRule: "nonzero",
    "data-testid": "Default_tada_path"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Group",
    fill: "#42ADE2",
    fillRule: "nonzero",
    transform: "translate(1.000000, 8.000000)",
    "data-testid": "Default_tada_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M46.2,13.7 C44.5,15.9 43.7,18.6 42.4,21.1 C41.2,23.4 39.6,25.6 37.3,26.8 C34.7,28.1 29,27.7 29,27.7 C29,27.7 34.7,27.6 37.1,26 C39.5,24.4 40.8,21.6 41.7,19 C43.5,14 45.7,8.6 50.9,6.4 C51.2,7.3 51.9,9.2 51.9,9.2 C51.9,9.2 49,10 46.2,13.7",
    "data-testid": "Default_tada_path"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    points: "1.03847916 1.32491916 5.03844084 1.32491916 5.03844084 5.32488084 1.03847916 5.32488084",
    transform: "translate(3.038460, 3.324900) rotate(-45.008103) translate(-3.038460, -3.324900) ",
    "data-testid": "Default_tada_polygon"
  })), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#FF8736",
    fillRule: "nonzero",
    points: "6.00103918 18.1970392 10.0010008 18.1970392 10.0010008 22.1970008 6.00103918 22.1970008",
    transform: "translate(8.001020, 20.197020) rotate(-45.000000) translate(-8.001020, -20.197020) ",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#ED4C5C",
    fillRule: "nonzero",
    points: "13.1859792 4.82197916 17.1859408 4.82197916 17.1859408 8.82194084 13.1859792 8.82194084",
    transform: "translate(15.185960, 6.821960) rotate(-45.008103) translate(-15.185960, -6.821960) ",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#C28FEF",
    fillRule: "nonzero",
    points: "44.0329892 38.6956892 48.0329508 38.6956892 48.0329508 42.6956508 44.0329892 42.6956508",
    transform: "translate(46.032970, 40.695670) rotate(-45.000000) translate(-46.032970, -40.695670) ",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#ED4C5C",
    fillRule: "nonzero",
    points: "37.7313292 48.3906892 41.7312908 48.3906892 41.7312908 52.3906508 37.7313292 52.3906508",
    transform: "translate(39.731310, 50.390670) rotate(-45.000000) translate(-39.731310, -50.390670) ",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#FF8736",
    fillRule: "nonzero",
    points: "50.1069892 50.6066692 54.1069508 50.6066692 54.1069508 54.6066308 50.1069892 54.6066308",
    transform: "translate(52.106970, 52.606650) rotate(-45.000000) translate(-52.106970, -52.606650) ",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Group",
    fill: "#42ADE2",
    fillRule: "nonzero",
    transform: "translate(47.000000, 6.000000)",
    "data-testid": "Default_tada_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    points: "5.90597918 31.7313992 9.90594082 31.7313992 9.90594082 35.7313608 5.90597918 35.7313608",
    transform: "translate(7.905960, 33.731380) rotate(-45.000000) translate(-7.905960, -33.731380) ",
    "data-testid": "Default_tada_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    points: "1.18451918 1.82287918 5.18448082 1.82287918 5.18448082 5.82284082 1.18451918 5.82284082",
    transform: "translate(3.184500, 3.822860) rotate(-45.000000) translate(-3.184500, -3.822860) ",
    "data-testid": "Default_tada_polygon"
  })), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "Shape",
    fill: "#ED4C5C",
    fillRule: "nonzero",
    points: "17.8728892 24.7924092 21.8728508 24.7924092 21.8728508 28.7923708 17.8728892 28.7923708",
    transform: "translate(19.872870, 26.792390) rotate(-45.000000) translate(-19.872870, -26.792390) ",
    "data-testid": "Default_tada_polygon"
  })));
});

var Timer = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_timer_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 17a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1zm-2.5-.67a1 1 0 01.366 1.366l-1.5 2.598a1 1 0 11-1.732-1l1.5-2.598A1 1 0 019.5 16.33zm6.366.366l1.5 2.598a1 1 0 11-1.732 1l-1.5-2.598a1 1 0 011.732-1zM7.67 14.5a1 1 0 01-.366 1.366l-2.598 1.5a1 1 0 11-1-1.732l2.598-1.5a1 1 0 011.366.366zM12 2c5.523 0 10 4.477 10 10a9.954 9.954 0 01-1.34 5.005L13 12.581a2 2 0 01-1-1.732V2zm-6 9a1 1 0 010 2H3a1 1 0 010-2h3zM4.706 6.634l2.598 1.5a1 1 0 11-1 1.732l-2.598-1.5a1 1 0 111-1.732zm3.66-2.928l1.5 2.598a1 1 0 11-1.732 1l-1.5-2.598a1 1 0 111.732-1z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_timer_path"
  }));
});

var ArrowLeft = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'icon/arrow/left/default' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#120A20' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "24px",
    width: "24px",
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_ArrowLeft_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_ArrowLeft_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon/arrow/left/default",
    fill: "currentcolor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_ArrowLeft_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "shape",
    d: "M5.29277221,8.29277221 C5.68313516,7.90240926 6.31182673,7.90240926 6.70218967,8.29277221 L12,13.5890103 L17.2978103,8.29277221 C17.6881733,7.90240926 18.3168648,7.90240926 18.7072278,8.29277221 C19.0975907,8.68313516 19.0975907,9.3218226 18.7072278,9.71218554 L12.7068146,15.7094542 C12.3164517,16.0998172 11.6835483,16.0998172 11.2931854,15.7094542 L5.29277221,9.71218554 C4.90240926,9.3218226 4.90240926,8.68313516 5.29277221,8.29277221 Z",
    fill: color,
    transform: "translate(12.000000, 12.001113) rotate(-270.000000) translate(-12.000000, -12.001113) ",
    "data-testid": "Default_ArrowLeft_path"
  })));
});

var ArrowRight = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'icon/arrow/right/default' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#120A20' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "24px",
    width: "24px",
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_ArrowRight_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_ArrowRight_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon/arrow/right/default",
    fill: "currentcolor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_ArrowRight_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "shape",
    d: "M5.29277221,8.29277221 C5.68313516,7.90240926 6.31182673,7.90240926 6.70218967,8.29277221 L12,13.5890103 L17.2978103,8.29277221 C17.6881733,7.90240926 18.3168648,7.90240926 18.7072278,8.29277221 C19.0975907,8.68313516 19.0975907,9.3218226 18.7072278,9.71218554 L12.7068146,15.7094542 C12.3164517,16.0998172 11.6835483,16.0998172 11.2931854,15.7094542 L5.29277221,9.71218554 C4.90240926,9.3218226 4.90240926,8.68313516 5.29277221,8.29277221 Z",
    fill: color,
    transform: "translate(12.000000, 12.001113) rotate(-90.000000) translate(-12.000000, -12.001113) ",
    "data-testid": "Default_ArrowRight_path"
  })));
});

var ArrowDown = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'icon/arrow/down/default' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#120A20' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "24px",
    width: "24px",
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_ArrowDown_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_ArrowDown_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon/arrow/down/default",
    fill: "currentcolor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_ArrowDown_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "shape",
    d: "M5.29277221,8.29277221 C5.68313516,7.90240926 6.31182673,7.90240926 6.70218967,8.29277221 L12,13.5890103 L17.2978103,8.29277221 C17.6881733,7.90240926 18.3168648,7.90240926 18.7072278,8.29277221 C19.0975907,8.68313516 19.0975907,9.3218226 18.7072278,9.71218554 L12.7068146,15.7094542 C12.3164517,16.0998172 11.6835483,16.0998172 11.2931854,15.7094542 L5.29277221,9.71218554 C4.90240926,9.3218226 4.90240926,8.68313516 5.29277221,8.29277221 Z",
    fill: color,
    "data-testid": "Default_ArrowDown_path"
  })));
});

var ArrowUp = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'icon/arrow/up/default' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#120A20' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "24px",
    width: "24px",
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_ArrowUp_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Default_ArrowUp_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon/arrow/up/default",
    fill: "currentcolor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Default_ArrowUp_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "shape",
    d: "M5.29277221,8.29566543 C5.68313516,7.90530248 6.31182673,7.90530248 6.70218967,8.29566543 L12,13.5919035 L17.2978103,8.29566543 C17.6881733,7.90530248 18.3168648,7.90530248 18.7072278,8.29566543 C19.0975907,8.68602838 19.0975907,9.32471581 18.7072278,9.71507876 L12.7068146,15.7123475 C12.3164517,16.1027104 11.6835483,16.1027104 11.2931854,15.7123475 L5.29277221,9.71507876 C4.90240926,9.32471581 4.90240926,8.68602838 5.29277221,8.29566543 Z",
    fill: color,
    transform: "translate(12.000000, 12.004006) rotate(-180.000000) translate(-12.000000, -12.004006) ",
    "data-testid": "Default_ArrowUp_path"
  })));
});

var ArrowLeft2 = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentcolor' : _ref$fill;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "data-testid": "Default_ArrowLeft2_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: fill,
    d: "M12.586 27.414l-10-10c-0.781-0.781-0.781-2.047 0-2.828l10-10c0.781-0.781 2.047-0.781 2.828 0s0.781 2.047 0 2.828l-6.586 6.586h19.172c1.105 0 2 0.895 2 2s-0.895 2-2 2h-19.172l6.586 6.586c0.39 0.39 0.586 0.902 0.586 1.414s-0.195 1.024-0.586 1.414c-0.781 0.781-2.047 0.781-2.828 0z",
    "data-testid": "Default_ArrowLeft2_path"
  }));
});

var ArrowRight2 = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentcolor' : _ref$fill;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "data-testid": "Default_ArrowRight2_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: fill,
    d: "M19.414 27.414l10-10c0.781-0.781 0.781-2.047 0-2.828l-10-10c-0.781-0.781-2.047-0.781-2.828 0s-0.781 2.047 0 2.828l6.586 6.586h-19.172c-1.105 0-2 0.895-2 2s0.895 2 2 2h19.172l-6.586 6.586c-0.39 0.39-0.586 0.902-0.586 1.414s0.195 1.024 0.586 1.414c0.781 0.781 2.047 0.781 2.828 0z",
    "data-testid": "Default_ArrowRight2_path"
  }));
});

var Clear = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#AAA7B0' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height,
      className = _ref.className;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    "data-testid": "Default_clear_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 3a9 9 0 110 18 9 9 0 010-18zM8.705 7.292a.999.999 0 10-1.413 1.413L10.588 12l-3.296 3.295a.999.999 0 101.413 1.413L12 13.412l3.295 3.296a.999.999 0 001.413-1.413L13.412 12l3.296-3.295a.999.999 0 00-1.413-1.413L12 10.588z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_clear_path"
  }));
});

var Drag = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#DDDCE0' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_drag_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Standard",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Default_drag_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_drag",
    fill: color,
    "data-testid": "Default_drag_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M9,16 C10.1045695,16 11,16.8954305 11,18 C11,19.1045695 10.1045695,20 9,20 C7.8954305,20 7,19.1045695 7,18 C7,16.8954305 7.8954305,16 9,16 Z M15,16 C16.1045695,16 17,16.8954305 17,18 C17,19.1045695 16.1045695,20 15,20 C13.8954305,20 13,19.1045695 13,18 C13,16.8954305 13.8954305,16 15,16 Z M9,10 C10.1045695,10 11,10.8954305 11,12 C11,13.1045695 10.1045695,14 9,14 C7.8954305,14 7,13.1045695 7,12 C7,10.8954305 7.8954305,10 9,10 Z M15,10 C16.1045695,10 17,10.8954305 17,12 C17,13.1045695 16.1045695,14 15,14 C13.8954305,14 13,13.1045695 13,12 C13,10.8954305 13.8954305,10 15,10 Z M9,4 C10.1045695,4 11,4.8954305 11,6 C11,7.1045695 10.1045695,8 9,8 C7.8954305,8 7,7.1045695 7,6 C7,4.8954305 7.8954305,4 9,4 Z M15,4 C16.1045695,4 17,4.8954305 17,6 C17,7.1045695 16.1045695,8 15,8 C13.8954305,8 13,7.1045695 13,6 C13,4.8954305 13.8954305,4 15,4 Z",
    id: "shape",
    "data-testid": "Default_drag_path"
  }))));
});

var Filter = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#120A20' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_filter_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 2c5.523 0 10 1.567 10 3.5v.727a2 2 0 01-.52 1.345L14 15.8V21c0 .522-.799.95-1.818.996L12 22c-1.105 0-2-.448-2-1v-5.201L2.52 7.572A2 2 0 012 6.227V5.5l.005-.113C2.176 3.507 6.585 2 12 2zm0 2c-4.142 0-7.5.672-7.5 1.5S7.858 7 12 7c4.142 0 7.5-.672 7.5-1.5S16.142 4 12 4z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_filter_path"
  }));
});

var Search = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#7A34FF' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_search_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_search_path"
  }));
});

var Verified = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#7A34FF' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_verified_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M9.411 2.08c.195.051.382.129.557.23L12 3.483l2.032-1.173a2.308 2.308 0 013.383 1.401l.607 2.267 2.267.607a2.308 2.308 0 011.401 3.383L20.517 12l1.173 2.032a2.308 2.308 0 01-1.401 3.383l-2.267.607-.607 2.267a2.308 2.308 0 01-3.383 1.401L12 20.517 9.968 21.69a2.308 2.308 0 01-3.383-1.401l-.607-2.267-2.267-.607a2.308 2.308 0 01-1.401-3.383L3.483 12 2.31 9.968A2.308 2.308 0 013.71 6.585l2.267-.607.607-2.267A2.308 2.308 0 019.41 2.08zm7.222 6.218a.989.989 0 00-1.406-.01l-4.89 4.89-1.88-1.873a1.002 1.002 0 00-1.414-.002.995.995 0 000 1.41l2.589 2.59a.996.996 0 001.412-.001l5.588-5.588c.385-.386.39-1.024 0-1.416z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_verified_path"
  }));
});

var Unverified = (function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#CCCBCE' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Default_unverified_svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 20.517L9.968 21.69a2.308 2.308 0 01-3.383-1.401l-.607-2.267-2.267-.607a2.308 2.308 0 01-1.401-3.383L3.483 12 2.31 9.968A2.308 2.308 0 013.71 6.585l2.267-.607.607-2.267A2.308 2.308 0 019.968 2.31L12 3.483l2.032-1.173a2.308 2.308 0 013.383 1.401l.607 2.267 2.267.607a2.308 2.308 0 011.401 3.383L20.517 12l1.173 2.032a2.308 2.308 0 01-1.401 3.383l-2.267.607-.607 2.267a2.308 2.308 0 01-3.383 1.401L12 20.517zm4-11.26c0-.565-.113-1.053-.338-1.466a3 3 0 00-.895-1.018 3.826 3.826 0 00-1.274-.586A5.827 5.827 0 0012.015 6c-.54 0-1.052.073-1.536.22a4.045 4.045 0 00-1.3.66 3.45 3.45 0 00-.937 1.106 3.12 3.12 0 00-.219.549.85.85 0 00.724 1.098l1 .103a.85.85 0 00.886-.552c.065-.178.138-.32.217-.424.237-.31.591-.464 1.064-.464.383 0 .684.103.903.31.22.205.33.482.33.83 0 .25-.068.464-.203.643s-.298.35-.49.513l-.557.504c-.225.185-.42.364-.582.538a3.285 3.285 0 00-.414.537 2.2 2.2 0 00-.253.61 3.096 3.096 0 00-.085.758c0 .341.277.618.619.618h1.592c.234 0 .423-.19.423-.423 0-.174.014-.323.042-.448a1.23 1.23 0 01.144-.358c.067-.114.16-.225.279-.334a7.63 7.63 0 01.447-.374c.293-.217.554-.426.785-.627.23-.2.428-.415.591-.643.163-.228.29-.478.38-.75A3 3 0 0016 9.257zm-2.465 7.196a1.448 1.448 0 00-.481-1.083 1.826 1.826 0 00-.524-.325 1.641 1.641 0 00-.633-.122c-.225 0-.439.04-.641.122a1.71 1.71 0 00-.532.334 1.505 1.505 0 00-.482 1.09c0 .218.046.418.136.603a1.647 1.647 0 00.886.814c.197.076.408.114.633.114.462 0 .85-.15 1.165-.448.315-.298.473-.665.473-1.099z",
    fill: color,
    fillRule: "evenodd",
    "data-testid": "Default_unverified_path"
  }));
});

var DefaultIcon = {
  ArrowDown: ArrowDown,
  ArrowLeft: ArrowLeft,
  ArrowLeft2: ArrowLeft2,
  ArrowRight: ArrowRight,
  ArrowRight2: ArrowRight2,
  ArrowUp: ArrowUp,
  Calculator: Calculator,
  Calendar: Calendar,
  Calendar2: Calendar2,
  CardSettings: CardSettings,
  Checkmark: Checkmark,
  Clear: Clear,
  Clock: Clock,
  Drag: Drag,
  Facebook: FacebookIcon,
  Failure: Failure,
  Filter: Filter,
  Google: GoogleIcon,
  Guide: Guide,
  Help: Help,
  Issue: Issue,
  Info: Info,
  Loading: Loading,
  Minus: Minus,
  Overflow: OverflowIcon,
  Pico: PicoIcon,
  Pico2: PicoIcon2,
  Plus: Plus,
  Return: Return,
  Search: Search,
  Success: Success,
  Tada: Tada,
  Timer: Timer,
  Twitter: TwitterIcon,
  Unverified: Unverified,
  Verified: Verified,
  Warning: Warning
};

var leftArrow$1 = /*#__PURE__*/React__default['default'].createElement(DefaultIcon.ArrowLeft, {
  height: 24,
  width: 24,
  color: "#7A34FF"
});
var rightArrow$1 = /*#__PURE__*/React__default['default'].createElement(DefaultIcon.ArrowRight, {
  height: 24,
  width: 24,
  color: "#7A34FF"
});

var DateInput = /*#__PURE__*/function (_React$Component) {
  _inherits(DateInput, _React$Component);

  var _super = _createSuper(DateInput);

  function DateInput(props) {
    var _this;

    _classCallCheck(this, DateInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChangeValue", function (startDate, endDate) {
      var input = _this.props.input;

      _this.setState({
        startDate: startDate,
        endDate: endDate
      }, function () {
        if (input) {
          var start = moment__default['default'](startDate).startOf('day');
          var end = moment__default['default'](endDate).endOf('day');
          input.onChange([new Date(start), new Date(end)]);
        }
      });
    });

    _this.state = {
      startDate: moment__default['default'](props.input && props.input.value[0]).startOf('day'),
      endDate: moment__default['default'](props.input && props.input.value[1]).endOf('day'),
      focusedInput: null
    };
    return _this;
  }

  _createClass(DateInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!Array.isArray(this.props.input.value)) {
        var startDate = moment__default['default']().startOf('day');
        var endDate = moment__default['default']().endOf('day');
        this.props.input.onChange([new Date(startDate), new Date(endDate)]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate,
          focusedInput = _this$state.focusedInput;

      var _this$props = this.props,
          meta = _this$props.meta,
          label = _this$props.label,
          required = _this$props.required,
          endDateId = _this$props.endDateId,
          startDateId = _this$props.startDateId,
          formFieldClassName = _this$props.formFieldClassName,
          className = _this$props.className,
          disabled = _this$props.disabled,
          datePickerProps = _this$props.datePickerProps,
          args = _objectWithoutProperties(_this$props, ["meta", "label", "required", "endDateId", "startDateId", "formFieldClassName", "className", "disabled", "datePickerProps"]);

      return /*#__PURE__*/React__default['default'].createElement(Form.Field, {
        label: label,
        required: required,
        meta: meta,
        className: formFieldClassName
      }, /*#__PURE__*/React__default['default'].createElement("div", _extends({
        className: cx__default['default'](style$4.datePicker, _defineProperty({}, style$4.error, meta && meta.error), className)
      }, args, {
        "data-testid": "DateRange_index_div"
      }), /*#__PURE__*/React__default['default'].createElement(reactDates.DateRangePicker, _extends({
        navPrev: leftArrow$1,
        navNext: rightArrow$1,
        displayFormat: 'MM / DD / YYYY',
        dayAriaLabelFormat: 'MM / DD / YYYY',
        isOutsideRange: function isOutsideRange() {
          return false;
        },
        hideKeyboardShortcutsPanel: true,
        disabled: disabled,
        customArrowIcon: /*#__PURE__*/React__default['default'].createElement(DefaultIcon.ArrowRight2, {
          height: 18,
          width: 18,
          fill: meta && meta.error && focusedInput === null ? '#FF4440' : '#120A20'
        }),
        customInputIcon: /*#__PURE__*/React__default['default'].createElement(DefaultIcon.Calendar2, {
          width: 24,
          height: 24
        }),
        numberOfMonths: 1,
        startDate: startDate,
        startDateId: startDateId,
        endDate: endDate,
        endDateId: endDateId,
        onDatesChange: function onDatesChange(_ref) {
          var startDate = _ref.startDate,
              endDate = _ref.endDate;
          return _this2.handleChangeValue(startDate, endDate);
        },
        focusedInput: focusedInput,
        onFocusChange: function onFocusChange(focusedInput) {
          return _this2.setState({
            focusedInput: focusedInput
          });
        }
      }, datePickerProps, {
        "data-testid": "DateRange_index_DateRangePicker"
      }))));
    }
  }]);

  return DateInput;
}(React__default['default'].Component);

DateInput.defaultProps = {
  disabled: false,
  endDateId: 'End_date_unique_id',
  startDateId: 'Start_date_unique_id'
};
DateInput.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  datePickerProps: PropTypes__default['default'].object,
  disabled: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(['startDate', 'endDate']), PropTypes__default['default'].bool]),
  endDateId: PropTypes__default['default'].string,
  formFieldClassName: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  input: PropTypes__default['default'].object.isRequired,
  label: PropTypes__default['default'].string,
  meta: PropTypes__default['default'].object,
  required: PropTypes__default['default'].bool,
  startDateId: PropTypes__default['default'].string
};

var style$3 = {"datePicker":"Date-module_datePicker__cZP8t","error":"Date-module_error__3Gc_o"};

var leftArrow = /*#__PURE__*/React__default['default'].createElement(DefaultIcon.ArrowLeft, {
  height: 24,
  width: 24,
  color: "#7A34FF"
});
var rightArrow = /*#__PURE__*/React__default['default'].createElement(DefaultIcon.ArrowRight, {
  height: 24,
  width: 24,
  color: "#7A34FF"
});

var SingleDateInput = /*#__PURE__*/function (_React$Component) {
  _inherits(SingleDateInput, _React$Component);

  var _super = _createSuper(SingleDateInput);

  function SingleDateInput(props) {
    var _this;

    _classCallCheck(this, SingleDateInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChangeValue", function (date) {
      var input = _this.props.input;

      _this.setState({
        date: date
      }, function () {
        return input && input.onChange(new Date(date));
      });
    });

    _this.state = {
      date: Array.isArray(props.input.value) ? moment__default['default'](new Date()) : moment__default['default'](props.input && props.input.value),
      focused: null
    };
    return _this;
  }

  _createClass(SingleDateInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var input = this.props.input;

      if (Array.isArray(input.value)) {
        input.onChange(new Date());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          date = _this$state.date,
          focused = _this$state.focused;

      var _this$props = this.props,
          meta = _this$props.meta,
          label = _this$props.label,
          required = _this$props.required,
          id = _this$props.id,
          formFieldClassName = _this$props.formFieldClassName,
          className = _this$props.className,
          disabled = _this$props.disabled,
          datePickerProps = _this$props.datePickerProps,
          args = _objectWithoutProperties(_this$props, ["meta", "label", "required", "id", "formFieldClassName", "className", "disabled", "datePickerProps"]);

      return /*#__PURE__*/React__default['default'].createElement(Form.Field, {
        label: label,
        required: required,
        meta: meta,
        className: formFieldClassName
      }, /*#__PURE__*/React__default['default'].createElement("div", _extends({
        className: cx__default['default'](style$3.datePicker, _defineProperty({}, style$3.error, meta && meta.error), className)
      }, args, {
        "data-testid": "SingleDate_index_div"
      }), /*#__PURE__*/React__default['default'].createElement(reactDates.SingleDatePicker, _extends({
        navPrev: leftArrow,
        navNext: rightArrow,
        displayFormat: 'MM / DD / YYYY',
        dayAriaLabelFormat: 'MM / DD / YYYY',
        hideKeyboardShortcutsPanel: true,
        isOutsideRange: function isOutsideRange() {
          return false;
        },
        customInputIcon: /*#__PURE__*/React__default['default'].createElement(DefaultIcon.Calendar2, {
          width: 24,
          height: 24
        }),
        numberOfMonths: 1,
        date: date,
        id: id,
        onDateChange: function onDateChange(date) {
          return _this2.handleChangeValue(date);
        },
        focused: focused,
        onFocusChange: function onFocusChange(_ref) {
          var focused = _ref.focused;
          return _this2.setState({
            focused: focused
          });
        },
        disabled: disabled
      }, datePickerProps, {
        "data-testid": "SingleDate_index_SingleDatePicker"
      }))));
    }
  }]);

  return SingleDateInput;
}(React__default['default'].Component);

SingleDateInput.defaultProps = {
  disabled: false,
  id: 'Single_date_picker'
};
SingleDateInput.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  datePickerProps: PropTypes__default['default'].object,
  disabled: PropTypes__default['default'].bool,
  formFieldClassName: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  id: PropTypes__default['default'].string,
  input: PropTypes__default['default'].object.isRequired,
  label: PropTypes__default['default'].string,
  meta: PropTypes__default['default'].object,
  required: PropTypes__default['default'].bool
};

var style$2 = {"timePicker":"Time-module_timePicker__9bn21","dropdownForm":"Time-module_dropdownForm__29bij"};

var TimeInput = /*#__PURE__*/function (_React$Component) {
  _inherits(TimeInput, _React$Component);

  var _super = _createSuper(TimeInput);

  function TimeInput() {
    var _this;

    _classCallCheck(this, TimeInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      date: null,
      format: 'am'
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (time) {
      _this.setState({
        time: time
      });

      _this.props.input.onChange(time);
    });

    return _this;
  }

  _createClass(TimeInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var icon;

      var _this$props = this.props,
          className = _this$props.className,
          dontShowAmPm = _this$props.dontShowAmPm,
          type = _this$props.type,
          input = _this$props.input,
          args = _objectWithoutProperties(_this$props, ["className", "dontShowAmPm", "type", "input"]);

      switch (type) {
        case 'clock':
          icon = /*#__PURE__*/React__default['default'].createElement(DefaultIcon.Clock, {
            height: 24,
            width: 24
          });
          break;

        case 'timer':
          icon = /*#__PURE__*/React__default['default'].createElement(DefaultIcon.Timer, {
            height: 24,
            width: 24
          });
          break;

        default:
          icon = null;
      }

      return /*#__PURE__*/React__default['default'].createElement(Flexbox.Container, null, /*#__PURE__*/React__default['default'].createElement(TimePicker__default['default'], _extends({
        clockIcon: icon,
        className: cx__default['default'](style$2.timePicker, className),
        onChange: this.onChange,
        value: this.state.date,
        name: input.name
      }, args, {
        "data-testid": "Time_index_TimePicker"
      })), type === 'clock' && !dontShowAmPm && /*#__PURE__*/React__default['default'].createElement(Form.Dropdown, {
        formFieldClassName: cx__default['default'](style$2.dropdownForm),
        options: [{
          label: 'AM',
          value: 'am'
        }, {
          label: 'PM',
          value: 'PM'
        }],
        input: {
          value: this.state.format,
          onChange: function onChange(val) {
            return _this2.setState({
              format: val
            });
          }
        },
        meta: {}
      }));
    }
  }]);

  return TimeInput;
}(React__default['default'].Component);
TimeInput.defaultProps = {
  dontShowAmPm: true,
  type: 'clock',
  clearIcon: null
};
TimeInput.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  dontShowAmPm: PropTypes__default['default'].bool,
  input: PropTypes__default['default'].object.isRequired,
  required: PropTypes__default['default'].bool,
  type: PropTypes__default['default'].oneOf(['time', 'clock', null])
};

var FormDate = {
  SingleDate: SingleDateInput,
  Date: DateInput,
  Time: TimeInput
};

var Async = /*#__PURE__*/function (_Component) {
  _inherits(Async, _Component);

  var _super = _createSuper(Async);

  function Async(props) {
    var _this;

    _classCallCheck(this, Async);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "cache", {});

    _defineProperty(_assertThisInitialized(_this), "typeaheadRef", /*#__PURE__*/React__default['default'].createRef());

    _defineProperty(_assertThisInitialized(_this), "inputRef", /*#__PURE__*/React__default['default'].createRef());

    _defineProperty(_assertThisInitialized(_this), "handleSearch", function (query) {
      if (_this.props.debugMode) {
        console.log('this.cache', _this.cache);
        console.log('query', query);
      }

      if (_this.cache[query]) {
        _this.setState({
          options: _this.cache[query].options
        });

        return;
      }

      _this.setState({
        isLoading: true
      });

      _this.props.makeAndHandleRequest(query).then(function (response) {
        _this.cache[query] = _objectSpread2(_objectSpread2({}, response), {}, {
          page: 1
        });

        _this.setState({
          isLoading: false,
          options: response.options
        });

        if (_this.props.debugMode) {
          console.log('Response:', response);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectionChange", function (selected) {
      // console.log('selection changed', selected)
      var labelKey = _this.props.labelKey; // not handling allowMultiple just yet

      return _this.setState({
        selected: selected
      }, function () {
        if (selected.length > 0) {
          if (typeof labelKey == 'string') {
            _this.inputRef.value = selected[0][labelKey];
          } else {
            // labelKey is a function
            _this.inputRef.value = labelKey(selected[0]);
          }
        } else {
          _this.inputRef.value = '';
        }
      });
    });

    _this.state = _this.getInitialState();
    return _this;
  }

  _createClass(Async, [{
    key: "getInitialState",
    value: function getInitialState() {
      var _this$props = this.props,
          handleRenderMenuItemChildren = _this$props.handleRenderMenuItemChildren,
          handleRenderMenu = _this$props.handleRenderMenu;
      return _objectSpread2(_objectSpread2({
        isLoading: false,
        options: [],
        query: '',
        selected: []
      }, handleRenderMenuItemChildren && {
        renderMenuItemChildren: handleRenderMenuItemChildren
      }), handleRenderMenu && {
        renderMenu: handleRenderMenu
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          allowMultiple = _this$props2.allowMultiple,
          autoFocus = _this$props2.autoFocus,
          className = _this$props2.className,
          debugMode = _this$props2.debugMode,
          id = _this$props2.id,
          labelKey = _this$props2.labelKey,
          minLength = _this$props2.minLength,
          maxResults = _this$props2.maxResults,
          placeholder = _this$props2.placeholder,
          notifyOnChange = _this$props2.notifyOnChange,
          props = _objectWithoutProperties(_this$props2, ["allowMultiple", "autoFocus", "className", "debugMode", "id", "labelKey", "minLength", "maxResults", "placeholder", "notifyOnChange"]);

      if (debugMode) {
        console.log('Typeahead state:', this.state);
      }

      return /*#__PURE__*/React__default['default'].createElement(reactBootstrapTypeahead.AsyncTypeahead, _extends({}, this.state, {
        autoFocus: autoFocus,
        id: id,
        className: className,
        labelKey: labelKey,
        maxResults: maxResults,
        multiple: allowMultiple,
        minLength: minLength,
        onChange: this.handleSelectionChange,
        onInputChange: function onInputChange(query) {
          return _this2.setState({
            query: query
          }, function () {
            return notifyOnChange(query);
          });
        },
        onSearch: this.handleSearch,
        placeholder: placeholder,
        ref: this.typeaheadRef,
        renderInput: function renderInput(_ref) {
          var inputRef = _ref.inputRef,
              referenceElementRef = _ref.referenceElementRef,
              inputProps = _objectWithoutProperties(_ref, ["inputRef", "referenceElementRef"]);

          var input = {
            autoComplete: 'off',
            onBlur: inputProps.onBlur,
            onChange: inputProps.onChange,
            onFocus: inputProps.onFocus,
            onKeyDown: inputProps.onKeyDown
          };
          return /*#__PURE__*/React__default['default'].createElement(Form.Search, {
            isDirty: !isEmpty__default['default'](_this2.state.query),
            isSearching: _this2.state.isLoading,
            onClear: function onClear() {
              _this2.typeaheadRef.current.clear();

              _this2.inputRef.value = '';

              _this2.setState(_this2.getInitialState, function () {
                return notifyOnChange('');
              });
            }
          }, /*#__PURE__*/React__default['default'].createElement(Form.Input, {
            input: input,
            ref: function ref(node) {
              inputRef(node);
              referenceElementRef(node);
              _this2.inputRef = node;
            }
          }));
        },
        useCache: false
      }, props, {
        "data-testid": "FormTypeahead_Async_AsyncTypeahead"
      }));
    }
  }]);

  return Async;
}(React.Component);

Async.defaultProps = {
  autoFocus: false,
  notifyOnChange: function notifyOnChange(value) {
    return value;
  }
};
Async.propTypes = {
  /* Whether to allow more than one item to be selected */
  allowMultiple: PropTypes__default['default'].bool,
  autoFocus: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /* To see helpful console logs */
  debugMode: PropTypes__default['default'].bool,

  /* Unique identifier for Async */
  id: PropTypes__default['default'].string.isRequired,
  handleRenderMenu: PropTypes__default['default'].func,
  handleRenderMenuItemChildren: PropTypes__default['default'].func,

  /* Value to key options selected by */
  labelKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  maxResults: PropTypes__default['default'].number,
  minLength: PropTypes__default['default'].number,

  /* passes query options */
  makeAndHandleRequest: PropTypes__default['default'].func.isRequired,
  notifyOnChange: PropTypes__default['default'].func,
  placeholder: PropTypes__default['default'].string,

  /* will position the menu using fixed instead of absolute positioning */
  positionFixed: PropTypes__default['default'].bool
};

var Sync = /*#__PURE__*/function (_Component) {
  _inherits(Sync, _Component);

  var _super = _createSuper(Sync);

  function Sync(props) {
    var _this;

    _classCallCheck(this, Sync);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "cache", {});

    _defineProperty(_assertThisInitialized(_this), "typeaheadRef", /*#__PURE__*/React__default['default'].createRef());

    _defineProperty(_assertThisInitialized(_this), "inputRef", null);

    _defineProperty(_assertThisInitialized(_this), "handleSelectionChange", function (selected) {
      var labelKey = _this.props.labelKey; // not handling allowMultiple just yet

      return _this.setState({
        selected: selected
      }, function () {
        if (selected.length > 0) {
          if (typeof labelKey == 'string') {
            _this.inputRef.value = selected[0][labelKey];
          } else {
            // labelKey is a function
            _this.inputRef.value = labelKey(selected[0]);
          }
        } else {
          _this.inputRef.value = '';
        }
      });
    });

    _this.state = _this.getInitialState();
    return _this;
  }

  _createClass(Sync, [{
    key: "getInitialState",
    value: function getInitialState() {
      var _this$props = this.props,
          handleRenderMenuItemChildren = _this$props.handleRenderMenuItemChildren,
          handleRenderMenu = _this$props.handleRenderMenu,
          stayOpen = _this$props.stayOpen;
      return _objectSpread2(_objectSpread2(_objectSpread2({
        isLoading: false,
        query: '',
        selected: []
      }, handleRenderMenuItemChildren && {
        renderMenuItemChildren: handleRenderMenuItemChildren
      }), handleRenderMenu && {
        renderMenu: handleRenderMenu
      }), stayOpen && {
        open: stayOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          autoFocus = _this$props2.autoFocus,
          allowMultiple = _this$props2.allowMultiple,
          className = _this$props2.className,
          debugMode = _this$props2.debugMode,
          id = _this$props2.id,
          labelKey = _this$props2.labelKey,
          minLength = _this$props2.minLength,
          options = _this$props2.options,
          maxResults = _this$props2.maxResults,
          placeholder = _this$props2.placeholder;

      if (debugMode) {
        console.log('Typeahead state:', this.state);
      }

      return /*#__PURE__*/React__default['default'].createElement(reactBootstrapTypeahead.Typeahead, _extends({}, this.state, {
        id: id,
        autoFocus: autoFocus,
        className: className,
        labelKey: labelKey,
        maxResults: maxResults,
        multiple: allowMultiple,
        minLength: minLength,
        onChange: this.handleSelectionChange,
        onInputChange: function onInputChange(query) {
          return _this2.setState({
            query: query
          });
        },
        options: options,
        placeholder: placeholder,
        ref: this.typeaheadRef,
        renderInput: function renderInput(_ref) {
          var inputRef = _ref.inputRef,
              referenceElementRef = _ref.referenceElementRef,
              inputProps = _objectWithoutProperties(_ref, ["inputRef", "referenceElementRef"]);

          var input = {
            autoComplete: 'off',
            name: id,
            onChange: inputProps.onChange,
            onBlur: inputProps.onBlur,
            onFocus: inputProps.onFocus,
            onKeyDown: inputProps.onKeyDown
          };
          return /*#__PURE__*/React__default['default'].createElement(Form.Search, {
            isDirty: !isEmpty__default['default'](_this2.state.query),
            isSearching: _this2.state.isLoading,
            onClear: function onClear() {
              _this2.typeaheadRef.current.clear();

              _this2.inputRef.value = '';

              _this2.setState(_this2.getInitialState);
            }
          }, /*#__PURE__*/React__default['default'].createElement(Form.Input, {
            input: input,
            ref: function ref(node) {
              inputRef(node);
              referenceElementRef(node);
              _this2.inputRef = node;
            }
          }));
        },
        "data-testid": "FormTypeahead_Sync_Typeahead"
      }));
    }
  }]);

  return Sync;
}(React.Component);

Sync.defaultProps = {
  autoFocus: false,
  stayOpen: false
};
Sync.propTypes = {
  /* Whether to allow more than one item to be selected */
  allowMultiple: PropTypes__default['default'].bool,
  autoFocus: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /* To see helpful console logs */
  debugMode: PropTypes__default['default'].bool,

  /* Unique identifier for ASync */
  id: PropTypes__default['default'].string.isRequired,
  handleRenderMenu: PropTypes__default['default'].func,
  handleRenderMenuItemChildren: PropTypes__default['default'].func,

  /* Value to key options selected by */
  labelKey: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].func]),
  minLength: PropTypes__default['default'].number,
  maxResults: PropTypes__default['default'].number,

  /* An array of objects typeahead will source it's results from */
  options: PropTypes__default['default'].array.isRequired,
  placeholder: PropTypes__default['default'].string,

  /* will position the menu using fixed instead of absolute positioning */
  positionFixed: PropTypes__default['default'].bool,

  /* whether we force the menu to remain open */
  stayOpen: PropTypes__default['default'].bool
};

var FormTypeahead = {
  Async: Async,
  Sync: Sync
};

var styles$5 = {"container":"FormInput-module_container__ll_c1","prefix":"FormInput-module_prefix__3yML6","input":"FormInput-module_input__l-msZ","isPrefix":"FormInput-module_isPrefix__1gNuh","isInlineLeft":"FormInput-module_isInlineLeft__3g39k","isInlineRight":"FormInput-module_isInlineRight__3cvv2","error":"FormInput-module_error__125Gq","disabled":"FormInput-module_disabled__2oH1f"};

var FormInput = /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      formFieldClassName = _ref.formFieldClassName,
      input = _ref.input,
      _ref$isInlineLeft = _ref.isInlineLeft,
      isInlineLeft = _ref$isInlineLeft === void 0 ? false : _ref$isInlineLeft,
      _ref$isInlineRight = _ref.isInlineRight,
      isInlineRight = _ref$isInlineRight === void 0 ? false : _ref$isInlineRight,
      label = _ref.label,
      step = _ref.step,
      max = _ref.max,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? '' : _ref$maxLength,
      meta = _ref.meta,
      min = _ref.min,
      placeholder = _ref.placeholder,
      prefix = _ref.prefix,
      prefixValue = _ref.prefixValue,
      required = _ref.required,
      type = _ref.type,
      _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? '#7A34FF' : _ref$themeColor,
      props = _objectWithoutProperties(_ref, ["autoFocus", "className", "disabled", "formFieldClassName", "input", "isInlineLeft", "isInlineRight", "label", "step", "max", "maxLength", "meta", "min", "placeholder", "prefix", "prefixValue", "required", "type", "themeColor"]);

  return /*#__PURE__*/React__default['default'].createElement(Form.Field, _extends({
    className: formFieldClassName,
    label: label,
    name: input.name,
    required: required,
    meta: meta
  }, props), /*#__PURE__*/React__default['default'].createElement(FocusWithin__default['default'], {
    "data-testid": "FormInput_index_FocusWithin"
  }, function (_ref2) {
    var _cx, _cx2;

    var isFocused = _ref2.isFocused,
        focusProps = _ref2.focusProps;
    return /*#__PURE__*/React__default['default'].createElement("div", _extends({}, focusProps, {
      className: cx__default['default'](styles$5.container, (_cx = {}, _defineProperty(_cx, styles$5.error, meta.touched && (meta.error || meta.submitError) && !meta.dirtySinceLastSubmit && !meta.submitting), _defineProperty(_cx, styles$5.disabled, disabled), _cx), className),
      "data-testid": "FormInput_index_div"
    }), prefix && /*#__PURE__*/React__default['default'].createElement("div", {
      className: cx__default['default'](styles$5.prefix),
      "data-testid": "FormInput_index_div"
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      "data-testid": "FormInput_index_span"
    }, prefixValue)), /*#__PURE__*/React__default['default'].createElement("input", _extends({
      className: cx__default['default'](styles$5.input, (_cx2 = {}, _defineProperty(_cx2, styles$5.isPrefix, prefix), _defineProperty(_cx2, styles$5.isInlineLeft, isInlineLeft), _defineProperty(_cx2, styles$5.isInlineRight, isInlineRight), _cx2)),
      disabled: disabled,
      type: type,
      placeholder: placeholder,
      autoFocus: autoFocus,
      min: min,
      max: max,
      step: step,
      maxLength: maxLength
    }, input, {
      ref: ref,
      style: isFocused ? {
        borderColor: themeColor
      } : {},
      "data-testid": "FormInput_index_input"
    })));
  }));
});
FormInput.displayName = 'FormInput';
FormInput.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  disabled: PropTypes__default['default'].bool,
  formFieldClassName: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  input: PropTypes__default['default'].object.isRequired,
  isInlineLeft: PropTypes__default['default'].bool,
  isInlineRight: PropTypes__default['default'].bool,
  meta: PropTypes__default['default'].object.isRequired,
  prefix: PropTypes__default['default'].bool,
  prefixValue: PropTypes__default['default'].oneOfType([PropTypes__default['default'].element, PropTypes__default['default'].string]),
  required: PropTypes__default['default'].bool,
  type: PropTypes__default['default'].oneOf(['password', 'email', 'text']),
  step: PropTypes__default['default'].string,
  themeColor: PropTypes__default['default'].string
};
FormInput.defaultProps = {
  step: null,
  meta: {
    touched: false
  }
};

var styles$4 = {"label":"Label-module_label__2VbzL","secondary":"Label-module_secondary__3F6Mk","error":"Label-module_error__KJsB0"};

var FormLabel = function FormLabel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      input = _ref.input,
      name = _ref.name,
      props = _objectWithoutProperties(_ref, ["children", "className", "input", "name"]);

  return /*#__PURE__*/React__default['default'].createElement("label", _extends({
    htmlFor: name,
    className: cx__default['default'](styles$4.label, className)
  }, input, props, {
    "data-testid": "FormLabel_index_label"
  }), children);
};

FormLabel.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  input: PropTypes__default['default'].object,
  name: PropTypes__default['default'].string
};

var style$1 = {"container":"Radio-module_container__W8rCv","label":"Radio-module_label__3NNQj","checkmark":"Radio-module_checkmark__8_6M5","inner":"Radio-module_inner__2Xicw"};

var Radio = function Radio(_ref) {
  var text = _ref.text,
      label = _ref.label,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      input = _ref.input,
      meta = _ref.meta,
      required = _ref.required,
      _ref$changed = _ref.changed,
      changed = _ref$changed === void 0 ? null : _ref$changed,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["text", "label", "className", "disabled", "input", "meta", "required", "changed", "color"]);

  return /*#__PURE__*/React__default['default'].createElement(Form.Field, _extends({
    label: label,
    required: required,
    meta: meta
  }, props, {
    className: className
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: cx__default['default'](style$1.container),
    "data-testid": "FormRadio_index_label"
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: style$1.label,
    "data-testid": "FormRadio_index_p"
  }, " ", text), /*#__PURE__*/React__default['default'].createElement("input", _extends({
    type: "radio"
  }, input, {
    disabled: disabled,
    onChange: function onChange(value) {
      if (changed) {
        changed(value);
      }

      input.onChange(value);
    },
    "data-testid": "FormRadio_index_input"
  })), /*#__PURE__*/React__default['default'].createElement("span", {
    className: style$1.checkmark,
    style: {
      borderColor: input.checked && color
    },
    "data-testid": "FormRadio_index_span"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: style$1.inner,
    style: {
      backgroundColor: color
    },
    "data-testid": "FormRadio_index_span"
  }))));
};

Radio.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  disabled: PropTypes__default['default'].bool,
  input: PropTypes__default['default'].object.isRequired,
  label: PropTypes__default['default'].string,
  meta: PropTypes__default['default'].object.isRequired,
  required: PropTypes__default['default'].bool,
  text: PropTypes__default['default'].string
};

var styles$3 = {"container":"FormSearch-module_container__1MeMq","searching":"FormSearch-module_searching__19Ao_","spinner-border":"FormSearch-module_spinner-border__3VBiJ","isDirty":"FormSearch-module_isDirty__3ItO-","pseudoInline":"FormSearch-module_pseudoInline__3-ZMw"};

var Apps = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Navigation_apps_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Navigation_apps_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_nav/apps",
    fill: "#414044",
    "data-testid": "Navigation_apps_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M26.5,11 C28.709139,11 30.5,12.790861 30.5,15 L30.5,18 L34,18 C36.209139,18 38,19.790861 38,22 L37.999,25.5 L41,25.5 C43.209139,25.5 45,27.290861 45,29.5 C45,31.709139 43.209139,33.5 41,33.5 L37.999,33.5 L38,38 C38,40.209139 36.209139,42 34,42 L29,42 L29,39 C29,37.4023191 27.75108,36.0963391 26.1762728,36.0050927 L26,36 C24.4023191,36 23.0963391,37.24892 23.0050927,38.8237272 L23,39 L23,42 L18,42 C15.790861,42 14,40.209139 14,38 L14,33 L17,33 C18.5976809,33 19.9036609,31.75108 19.9949073,30.1762728 L20,30 C20,28.4023191 18.75108,27.0963391 17.1762728,27.0050927 L17,27 L14,27 L14,22 C14,19.790861 15.790861,18 18,18 L22.5,18 L22.5,15 C22.5,12.790861 24.290861,11 26.5,11 Z",
    id: "Combined-Shape",
    "data-testid": "Navigation_apps_path"
  }))));
});

var Contacts = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Navigation_contacts_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-8 -8)",
    "data-testid": "Navigation_contacts_g"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    height: "56",
    width: "56",
    fill: "#F9F4FF",
    rx: "28",
    x: "8",
    y: "8",
    "data-testid": "Navigation_contacts_rect"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M36,36.5 C38.2091,36.5 40,34.7091 40,32.5 C40,30.2909 38.2091,28.5 36,28.5 C33.7909,28.5 32,30.2909 32,32.5 C32,34.7091 33.7909,36.5 36,36.5 Z M45,42 C45,39.0043 38.9957,37.5 36,37.5 C33.0043,37.5 27,39.0043 27,42 L27,45.2111 C27,45.923 27.5785,46.5 28.2945,46.5 L43.7055,46.5 C44.4204,46.5 45,45.9254 45,45.2111 L45,42 Z",
    fill: "#7A34FF",
    "data-testid": "Navigation_contacts_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M47.1111 28.6111C47.1111 30.3293 45.7182 31.7222 44 31.7222 42.2818 31.7222 40.8889 30.3293 40.8889 28.6111 40.8889 26.8929 42.2818 25.5 44 25.5 45.7182 25.5 47.1111 26.8929 47.1111 28.6111zM42.2176 35.719C44.4647 36.5528 46.5287 37.8136 47.4675 39.5L49.9932 39.5C50.5492 39.5 51 39.0531 51 38.4976L51 36C51 33.67 46.33 32.5 44 32.5 43.7003 32.5 43.3619 32.5194 42.9998 32.558 42.9905 33.6972 42.7092 34.7714 42.2176 35.719zM31.1111 28.6111C31.1111 30.3293 29.7182 31.7222 28 31.7222 26.2818 31.7222 24.8889 30.3293 24.8889 28.6111 24.8889 26.8929 26.2818 25.5 28 25.5 29.7182 25.5 31.1111 26.8929 31.1111 28.6111zM29.7824 35.719C29.2908 34.7714 29.0095 33.6972 29.0002 32.558 28.6381 32.5194 28.2997 32.5 28 32.5 25.67 32.5 21 33.67 21 36L21 38.4976C21 39.0512 21.4499 39.5 22.0068 39.5L24.5325 39.5C25.4713 37.8136 27.5353 36.5528 29.7824 35.719z",
    fill: "#C9ADFF",
    "data-testid": "Navigation_contacts_path"
  })));
});

var Messages = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Navigation_messages_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-8 -8)",
    "data-testid": "Navigation_messages_g"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    height: "56",
    width: "56",
    fill: "#F9F4FF",
    rx: "28",
    x: "8",
    y: "8",
    "data-testid": "Navigation_messages_rect"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M49.6530682,22.2078504 L21.1847734,33.6929995 C19.5858384,34.3382076 19.6082385,35.3288115 21.2341956,35.8950826 L28.3958027,38.3877131 L31.1776721,47.43508 C31.5104725,48.5765165 32.4438067,48.8203689 33.2519853,47.9765211 L37.0663891,43.993723 C37.0827446,43.9766756 37.097678,43.9599987 37.1133225,43.9433219 L44.0989294,49.4485296 C45.4671085,50.5269647 46.8687099,49.9744057 47.2135991,48.2211147 L51.9332482,24.2227823 C52.2781375,22.4694913 51.2520031,21.5630128 49.6530682,22.2078504 Z",
    fill: "#C9ADFF",
    "data-testid": "Navigation_messages_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M45.0283525,28.6284308 L33.1822963,40.2088232 L33.1819408,40.2091938 L33.1808741,40.2103056 C32.9728739,40.4145042 32.801496,40.8069656 32.7769626,41.1038132 L32.7769626,41.1038132 L32.4615845,44.9065016 C32.3022955,46.7983956 32.0167841,46.139846 31.6679837,45.0035978 L29.4013148,37.7273106 L44.2493295,27.814972 C46.5458651,26.323322 46.5458651,27.1819936 45.0283525,28.6284308 Z",
    fill: "#7A34FF",
    "data-testid": "Navigation_messages_path"
  })));
});

var Performance = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Navigation_performance_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-8 -8)",
    "data-testid": "Navigation_performance_g"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    height: "56",
    width: "56",
    fill: "#F9F4FF",
    rx: "28",
    x: "8",
    y: "8",
    "data-testid": "Navigation_performance_rect"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M49.5 29.7C49.5 28.485 48.4926 27.5 47.25 27.5 46.0074 27.5 45 28.485 45 29.7L45 47.3C45 48.515 46.0074 49.5 47.25 49.5 48.4926 49.5 49.5 48.515 49.5 47.3L49.5 29.7zM42 24.75C42 23.5074 40.9926 22.5 39.75 22.5 38.5074 22.5 37.5 23.5074 37.5 24.75L37.5 47.25C37.5 48.4926 38.5074 49.5 39.75 49.5 40.9926 49.5 42 48.4926 42 47.25L42 24.75z",
    fill: "#7A34FF",
    "data-testid": "Navigation_performance_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M34.5 33.75C34.5 32.5074 33.4926 31.5 32.25 31.5 31.0074 31.5 30 32.5074 30 33.75L30 47.25C30 48.4926 31.0074 49.5 32.25 49.5 33.4926 49.5 34.5 48.4926 34.5 47.25L34.5 33.75zM27 41.6429C27 40.4594 25.9926 39.5 24.75 39.5 23.5074 39.5 22.5 40.4594 22.5 41.6429L22.5 47.3571C22.5 48.5406 23.5074 49.5 24.75 49.5 25.9926 49.5 27 48.5406 27 47.3571L27 41.6429z",
    fill: "#C9ADFF",
    "data-testid": "Navigation_performance_path"
  })));
});

var Resources = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Navigation_resources_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-8 -8)",
    "data-testid": "Navigation_resources_g"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    height: "56",
    width: "56",
    fill: "#F9F4FF",
    rx: "28",
    x: "8",
    y: "8",
    "data-testid": "Navigation_resources_rect"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M36,51 C44.2843,51 51,44.2843 51,36 C51,27.7157 44.2843,21 36,21 C27.7157,21 21,27.7157 21,36 C21,44.2843 27.7157,51 36,51 Z M30.732,29.6869 C30.244,30.4557 30,31.2166 30,31.9696 C30,32.3342 30.152,32.675 30.456,32.9921 C30.768,33.3012 31.148,33.4557 31.596,33.4557 C32.356,33.4557 32.872,33.0079 33.144,32.1123 C33.432,31.2563 33.784,30.7886 34.2,30.3527 C34.616,29.9089 35.264,29.6869 36.144,29.6869 C36.896,29.6869 37.508,29.9049 37.98,30.3408 C38.46,30.7768 38.7,31.1334 38.7,31.7675 C38.7,32.0925 38.62,32.3937 38.46,32.6711 C38.308,32.9485 38.116,33.2021 37.884,33.432 C37.66,33.6539 37.292,33.9868 36.78,34.4306 C36.196,34.9379 35.732,35.3778 35.388,35.7503 C35.044,36.1149 34.768,36.5429 34.56,37.0343 C34.352,37.5178 34.248,38.0925 34.248,38.7583 C34.248,39.2893 34.388,39.6896 34.668,39.959 C34.956,40.2285 35.308,40.3633 35.724,40.3633 C36.524,40.3633 37,39.9511 37.152,39.1268 C37.24,38.7384 37.304,38.469 37.344,38.3184 C37.392,38.1598 37.456,38.0053 37.536,37.8547 C37.616,37.6962 37.736,37.5258 37.896,37.3435 C38.064,37.1532 38.284,36.9353 38.556,36.6896 C39.54,35.8177 40.22,35.1995 40.596,34.8349 C40.98,34.4624 41.308,34.0225 41.58,33.5152 C41.86,33.0079 42,32.4174 42,31.7437 C42,30.8877 41.756,30.0951 41.268,29.3659 C40.788,28.6367 40.104,28.0621 39.216,27.642 C38.328,27.214 37.304,27 36.144,27 C34.896,27 33.804,27.2536 32.868,27.7609 C31.932,28.2682 31.22,28.9102 30.732,29.6869 Z M34.572,44.5363 C34.94,44.8454 35.368,45 35.856,45 C36.328,45 36.744,44.8415 37.104,44.5244 C37.464,44.2074 37.644,43.7715 37.644,43.2166 C37.644,42.7173 37.472,42.2972 37.128,41.9564 C36.784,41.6156 36.36,41.4452 35.856,41.4452 C35.344,41.4452 34.912,41.6156 34.56,41.9564 C34.208,42.2972 34.032,42.7173 34.032,43.2166 C34.032,43.7794 34.212,44.2193 34.572,44.5363 Z",
    fill: "#7A34FF",
    "data-testid": "Navigation_resources_path"
  })));
});

var Revenue = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Navigation_revenue_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-8 -8)",
    "data-testid": "Navigation_revenue_g"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    height: "56",
    width: "56",
    fill: "#F9F4FF",
    rx: "28",
    x: "8",
    y: "8",
    "data-testid": "Navigation_revenue_rect"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M51.3511,28.9454 C41.0098,31.6267 30.6686,25.336 20.3273,28.3267 C19.8102,28.4298 19.5,28.8423 19.5,29.2548 L19.5,45.6517 C19.5,46.3735 20.1205,46.786 20.741,46.6829 C31.0822,44.0017 41.4235,50.2923 51.7648,47.3017 C52.1784,47.1985 52.4886,46.786 52.4886,46.2704 L52.4886,29.8735 C52.5921,29.2548 51.9716,28.7392 51.3511,28.9454 Z M36.046,42.9704 C33.9778,42.9704 32.3232,40.7017 32.3232,37.8142 C32.3232,34.9267 33.9778,32.6579 36.046,32.6579 C38.1143,32.6579 39.7689,34.9267 39.7689,37.8142 C39.7689,40.7017 38.1143,42.9704 36.046,42.9704 Z",
    fill: "#7A34FF",
    "data-testid": "Navigation_revenue_path"
  })));
});

var Settings = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Navigation_settings_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-8 -8)",
    "data-testid": "Navigation_settings_g"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    height: "56",
    width: "56",
    fill: "#F9F4FF",
    rx: "28",
    x: "8",
    y: "8",
    "data-testid": "Navigation_settings_rect"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M49.8465,33.69 L48.462,33.69 C47.8275,33.69 47.154,33.1965 46.9665,32.589 L46.17,30.6555 C45.873,30.0975 45.9945,29.2725 46.4415,28.8225 L47.4255,27.8415 C47.8755,27.3915 47.8755,26.6565 47.4255,26.2095 L45.789,24.5775 C45.342,24.129 44.6085,24.129 44.1585,24.5775 L43.1745,25.56 C42.7275,26.01 41.8995,26.1315 41.3415,25.8315 L39.4125,25.038 C38.808,24.8505 38.31,24.1755 38.31,23.5395 L38.31,22.155 C38.31,21.522 37.7895,21 37.155,21 L34.848,21 C34.2135,21 33.693,21.522 33.693,22.155 L33.693,23.5395 C33.693,24.1755 33.198,24.849 32.592,25.038 L30.66,25.83 C30.0975,26.13 29.2755,26.01 28.8255,25.5585 L27.843,24.5775 C27.393,24.129 26.661,24.129 26.211,24.5775 L24.5805,26.2095 C24.129,26.658 24.129,27.3915 24.5805,27.8415 L25.5585,28.824 C26.0085,29.2725 26.133,30.099 25.83,30.657 L25.038,32.592 C24.8475,33.1995 24.1755,33.693 23.541,33.693 L22.155,33.69 C21.5205,33.69 21,34.2105 21,34.845 L21,37.1535 C21,37.7865 21.5205,38.3085 22.155,38.3085 L23.5425,38.3085 C24.177,38.3085 24.849,38.8065 25.0365,39.4125 L25.8315,41.343 C26.1315,41.9025 26.01,42.732 25.56,43.1775 L24.579,44.1585 C24.1305,44.61 24.1305,45.342 24.579,45.7905 L26.2125,47.4225 C26.6625,47.871 27.3945,47.871 27.8445,47.4225 L28.827,46.4415 C29.274,45.996 30.099,45.873 30.657,46.1715 L32.592,46.968 C33.198,47.1585 33.693,47.832 33.693,48.465 L33.693,49.848 C33.693,50.478 34.2135,51 34.848,51 L37.155,51 C37.791,51 38.3115,50.478 38.3115,49.848 L38.3115,48.465 C38.3115,47.832 38.8095,47.1585 39.414,46.968 L41.3475,46.1715 C41.907,45.873 42.732,45.996 43.182,46.4415 L44.16,47.4225 C44.61,47.871 45.3435,47.871 45.7905,47.4225 L47.427,45.7905 C47.877,45.342 47.877,44.61 47.427,44.1585 L46.443,43.1775 C45.996,42.732 45.8745,41.9025 46.1715,41.343 L46.968,39.4125 C47.1555,38.8065 47.832,38.3085 48.4635,38.3085 L49.848,38.3085 C50.484,38.3085 51.0015,37.7895 51.0015,37.155 L51.0015,34.845 C51,34.212 50.4825,33.69 49.8465,33.69 Z M41.775,35.9985 C41.775,39.1845 39.1905,41.769 36.0045,41.769 C32.817,41.769 30.2325,39.1845 30.2325,35.9985 C30.2325,32.811 32.817,30.2295 36.0045,30.2295 C39.1905,30.2295 41.775,32.8125 41.775,35.9985 Z",
    fill: "#7A34FF",
    "data-testid": "Navigation_settings_path"
  })));
});

var NavigationIcon = {
  Apps: Apps,
  Contacts: Contacts,
  Messages: Messages,
  Performance: Performance,
  Resources: Resources,
  Revenue: Revenue,
  Settings: Settings
};

var Mailchimp = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'brand/mailchimp' : _ref$title;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "64px",
    width: "64px",
    version: "1.1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Brands_mailchimp_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Brands_mailchimp_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("defs", {
    "data-testid": "Brands_mailchimp_defs"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "path-1",
    points: "0 0.0111804969 45.9922291 0.0111804969 45.9922291 49.252331 0 49.252331",
    "data-testid": "Brands_mailchimp_polygon"
  })), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Brands_mailchimp_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "brand/mailchimp",
    "data-testid": "Brands_mailchimp_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FFE01B",
    points: "0 0 64 0 64 64 0 64",
    "data-testid": "Brands_mailchimp_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Mailchimp",
    transform: "translate(8.000000, 8.000000)",
    "data-testid": "Brands_mailchimp_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Fill-1",
    d: "M34.5958435,23.2800002 C34.9521201,23.2370897 35.2934735,23.2353116 35.6070956,23.2800002 C35.7886415,22.8600228 35.8197805,22.1359974 35.6565654,21.3476063 C35.4139166,20.1757473 35.0853713,19.4666576 34.4065422,19.5770157 C33.727713,19.6873739 33.7026844,20.5363375 33.9453332,21.7081965 C34.0818745,22.3675006 34.3251109,22.930908 34.5958435,23.2800002",
    fill: "#1A1919",
    "data-testid": "Brands_mailchimp_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Fill-2",
    d: "M28.7682771,24.2074354 C29.2539272,24.4223434 29.5523911,24.5648252 29.6693091,24.4403611 C29.7443951,24.3626007 29.721834,24.2144291 29.6058561,24.0233471 C29.3662625,23.6286182 28.8732095,23.2283179 28.3499576,23.0034528 C27.2801878,22.5389054 26.0043134,22.693478 25.0200876,23.4069535 C24.6950674,23.64711 24.3869681,23.9797254 24.4311501,24.1818314 C24.4454858,24.2471454 24.4940156,24.2963384 24.6081134,24.3124594 C24.8760259,24.3433976 25.812192,23.8659297 26.8905397,23.7993118 C27.6519751,23.7522525 28.2825095,23.9924089 28.7682771,24.2074354",
    fill: "#1A1919",
    "data-testid": "Brands_mailchimp_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Fill-3",
    d: "M27.7912191,24.7696575 C27.1586872,24.8704141 26.8096959,25.0808177 26.585848,25.2764041 C26.3946666,25.4450826 26.2764561,25.6313046 26.2775066,25.7622882 C26.2779836,25.8246388 26.3046574,25.8605556 26.3259259,25.8785733 C26.3547147,25.9042958 26.3889088,25.9185203 26.4299182,25.9185203 C26.5728049,25.9185203 26.8927723,25.7889591 26.8927723,25.7889591 C27.7731233,25.4711608 28.3538353,25.5095669 28.9293771,25.5758292 C29.2473469,25.611746 29.3976364,25.6317788 29.4673172,25.5217762 C29.4879981,25.4902453 29.5130268,25.4218493 29.4493388,25.3176551 C29.3010469,25.0751279 28.6624047,24.6653447 27.7912191,24.7696575",
    fill: "#1A1919",
    "data-testid": "Brands_mailchimp_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Fill-4",
    d: "M32.6279793,26.8341018 C33.0574618,27.0469947 33.5305389,26.963426 33.684471,26.6475243 C33.8382857,26.331504 33.6147903,25.9027549 33.1854253,25.689862 C32.7557078,25.4769691 32.2828658,25.5605379 32.1289336,25.8765581 C31.9750014,26.1924598 32.1984968,26.621209 32.6279793,26.8341018",
    fill: "#1A1919",
    "data-testid": "Brands_mailchimp_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Fill-5",
    d: "M35.3893579,24.4000584 C35.0404842,24.3941316 34.7509507,24.7806815 34.7428428,25.2632465 C34.7347349,25.7459301 35.0111078,26.1420815 35.3599816,26.1481269 C35.7089728,26.1540538 35.9982713,25.7675039 36.0064967,25.2849388 C36.0146045,24.8021367 35.7383492,24.4059853 35.3893579,24.4000584",
    fill: "#1A1919",
    "data-testid": "Brands_mailchimp_path"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Group",
    "data-testid": "Brands_mailchimp_g"
  }, /*#__PURE__*/React__default['default'].createElement("mask", {
    id: "mask-2",
    fill: "white",
    "data-testid": "Brands_mailchimp_mask"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "0 0.0111804969 45.9922291 0.0111804969 45.9922291 49.252331 0 49.252331",
    "data-testid": "Brands_mailchimp_polygon"
  })), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Clip-7",
    "data-testid": "Brands_mailchimp_g"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Fill-6",
    d: "M11.9521866,33.1037729 C11.86535,32.9941259 11.7226984,33.0275534 11.5846294,33.0599141 C11.488275,33.0826732 11.3789949,33.1083958 11.2592568,33.1061436 C11.0025073,33.1012836 10.7852397,32.9904513 10.6631515,32.8015029 C10.5041666,32.5551826 10.5134496,32.1880728 10.6888852,31.7676212 C10.7125038,31.711079 10.7404701,31.6481357 10.7707865,31.5795027 C11.0505671,30.9461583 11.5190614,29.8860798 10.9931069,28.8759056 C10.5973485,28.1156078 9.95189091,27.6421701 9.17564977,27.5425989 C8.43054757,27.4474135 7.66347185,27.726213 7.17429657,28.2706545 C6.40228562,29.1298123 6.28172501,30.2987079 6.43095696,30.7118102 C6.48571451,30.8630637 6.57125849,30.9049073 6.63341889,30.913442 C6.7646725,30.9313411 6.95890904,30.8348518 7.08052721,30.5048442 C7.08934012,30.4810182 7.10097316,30.4441531 7.11542633,30.3974494 C7.16959635,30.2228441 7.27053355,29.8979336 7.43586375,29.6373887 C7.63527054,29.3231465 7.94572,29.1068161 8.31022197,29.0281074 C8.68142175,28.9478577 9.06096443,29.0192171 9.37869922,29.229028 C9.9193419,29.5861806 10.1276791,30.2544935 9.89678085,30.8923424 C9.77739529,31.2221129 9.58362877,31.8528495 9.62628325,32.3709757 C9.71276728,33.4199116 10.3523496,33.8410744 10.9268338,33.8858815 C11.4855723,33.9070996 11.8759255,33.5908423 11.9747476,33.3594577 C12.0330303,33.2227842 11.983913,33.1394526 11.9521866,33.1037729",
    fill: "#1A1919",
    "data-testid": "Brands_mailchimp_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Fill-8",
    d: "M17.2630814,13.8396954 C19.0850037,11.7156268 21.3281832,9.86905391 23.3374092,8.83220879 C23.4068549,8.79629201 23.4806484,8.87239291 23.4429291,8.94138157 C23.2834742,9.23286461 22.9761974,9.85684458 22.8789029,10.3302823 C22.8636272,10.4040124 22.9432959,10.4596064 23.0049862,10.41717 C24.2551269,9.55753808 26.4295657,8.63662236 28.336797,8.51820367 C28.4188158,8.51310657 28.4584152,8.61907885 28.3931996,8.66957571 C28.1031961,8.89396668 27.7859314,9.20453422 27.5542106,9.51877641 C27.5148462,9.5722367 27.5518605,9.64916736 27.6178985,9.6496415 C28.9573434,9.65924302 30.8453038,10.132088 32.0758211,10.8282572 C32.15925,10.875435 32.0999097,11.0381866 32.0067279,11.0166128 C30.1448537,10.5860856 27.0969968,10.2595155 23.9311644,11.0384237 C21.1048053,11.7338816 18.9475223,12.8075918 17.3737715,13.9622629 C17.2942203,14.0207018 17.1986884,13.9147295 17.2630814,13.8396954 Z M26.3376764,34.4183507 C26.3377939,34.4187063 26.3381464,34.4190619 26.338264,34.4195361 C26.3386165,34.4202473 26.3388515,34.4211956 26.339204,34.4219068 C26.3386165,34.4207215 26.338264,34.4195361 26.3376764,34.4183507 Z M33.8515638,35.3130697 C33.9054988,35.290192 33.9427481,35.2278414 33.9365203,35.1662021 C33.9288824,35.0902197 33.8616693,35.0349814 33.7864658,35.0428048 C33.7864658,35.0428048 29.8980922,35.6234002 26.2247537,34.2668601 C26.6247423,32.9550086 27.6887543,33.4288019 29.2968167,33.559667 C32.1952067,33.7339168 34.7930176,33.3068271 36.712822,32.7510061 C38.376347,32.2692708 40.5614788,31.3197876 42.2584928,29.9685817 C42.8309794,31.2369301 43.0330889,32.632943 43.0330889,32.632943 C43.0330889,32.632943 43.476202,32.5529304 43.8465792,32.7828926 C44.196393,33.0000528 44.453025,33.4516796 44.2778243,34.6191528 C43.9209602,36.8002377 43.0018324,38.5705912 41.457223,40.1990557 C40.5171792,41.2200168 39.3756135,42.1076236 38.0695402,42.7531773 C37.3760229,43.1206427 36.6373835,43.4386781 35.8573822,43.6956668 C30.0345161,45.6140733 24.074286,43.5049404 22.1529541,38.9756329 C21.9996094,38.635194 21.8700009,38.2787526 21.7676536,37.9058345 C20.9488755,34.9210671 21.6440379,31.340176 23.816949,29.0861906 C23.8170666,29.0860721 23.8165965,29.0853609 23.816714,29.0851238 C23.9506703,28.9415752 24.0873291,28.7725411 24.0873291,28.5597668 C24.0873291,28.381961 23.9753464,28.194198 23.8780519,28.0611992 C23.1180265,26.9489644 20.4848464,25.0535542 21.013386,21.3855382 C21.3929287,18.7505742 23.6773525,16.8947554 25.8072567,17.0047579 C25.9871576,17.0141223 26.167411,17.0252648 26.3469594,17.0360517 C27.2700823,17.091053 28.0752298,17.2105385 28.8351377,17.2426621 C30.1067819,17.298019 31.2504627,17.1115599 32.6048308,15.9731284 C33.0618095,15.5889493 33.4279566,15.2559782 34.0479155,15.1500059 C34.112896,15.1388634 34.2750535,15.080306 34.5990161,15.0955973 C34.9296765,15.1133779 35.2443562,15.2050072 35.5273093,15.3949038 C36.6130599,16.1239078 36.7671096,17.8892827 36.8233947,19.1807458 C36.8554737,19.9179288 36.9438397,21.7014399 36.9740367,22.2134022 C37.0431299,23.3841944 37.3481741,23.5493167 37.9654304,23.7542676 C38.312424,23.8694858 38.6347415,23.9554253 39.1095812,24.0898465 C40.5469081,24.4970219 41.3990578,24.9100056 41.9362928,25.4405782 C42.2566127,25.7721268 42.4056096,26.1244195 42.4515543,26.460354 C42.6211147,27.7076027 41.4916521,29.2484681 38.5018429,30.6483927 C35.2334282,32.1787083 31.2685585,32.566088 28.529036,32.2583654 C28.3188187,32.2347764 27.5718364,32.1493111 27.5692513,32.1489555 C25.3778917,31.85119 24.1278685,34.7081742 25.4429898,36.6653424 C26.2905567,37.926697 28.5993042,38.7478044 30.9092268,38.74816 C36.2054334,38.7488712 40.276293,36.4672667 41.7904685,34.4968224 C41.8358256,34.4379094 41.8402908,34.4315083 41.9117341,34.3226912 C41.9861151,34.2093696 41.9247772,34.147019 41.8319479,34.2110291 C40.5947328,35.0649713 35.0995894,38.4552545 29.2217307,37.4353602 C29.2217307,37.4353602 28.507415,37.316823 27.8554946,37.0609011 C27.3372955,36.8576098 26.2530725,36.3545378 26.1212313,35.2321088 C30.8648097,36.7120461 33.8515638,35.3130697 33.8515638,35.3130697 Z M7.79719308,23.9409637 C6.14753376,24.2645704 4.69352106,25.2076526 3.80435715,26.5106138 C3.27299741,26.0634913 2.2828963,25.1979325 2.10804816,24.8606941 C0.688582064,22.1415686 3.6572403,16.8551639 5.73097686,13.8698039 C10.856213,6.49169124 18.8833643,0.907165399 22.5993573,1.92030308 C23.2033355,2.09277474 25.2041011,4.43293668 25.2041011,4.43293668 C25.2041011,4.43293668 21.4896357,6.5119611 18.0449628,9.40995923 C13.4036141,13.0151505 9.89760339,18.2550886 7.79719308,23.9409637 Z M10.5692647,36.4179552 C10.319683,36.4609842 10.0648137,36.4780536 9.80806422,36.4718896 C7.32587863,36.404679 4.64463878,34.1504566 4.37825387,31.4770865 C4.08366766,28.522072 5.58045236,26.2479353 8.23043575,25.708828 C8.5472305,25.6443437 8.93018084,25.6072415 9.34297756,25.6288153 C10.8277767,25.7108431 13.0157286,26.8610098 13.5155969,30.1238655 C13.9583575,33.0136846 13.2552047,35.9560156 10.5692647,36.4179552 Z M44.1938079,31.1856035 C44.1724219,31.1097396 44.034118,30.5989627 43.8437591,29.9833989 C43.6532827,29.3678351 43.4563436,28.9345815 43.4563436,28.9345815 C44.2196591,27.7815699 44.2332897,26.7504146 44.1318825,26.1665002 C44.023425,25.4425933 43.7247261,24.8257256 43.122628,24.1879953 C42.5204125,23.550265 41.2889551,22.8972435 39.558217,22.407092 C39.3602203,22.3510239 38.7074774,22.1703732 38.6500173,22.1527111 C38.6456695,22.1147792 38.6024275,19.9929629 38.5629457,19.0821228 C38.5342744,18.4237671 38.4782243,17.3958122 38.1621345,16.3831487 C37.7852945,15.0127398 37.1287914,13.8134987 36.3091908,13.0462072 C38.5708186,10.681271 39.9825293,8.07629689 39.9791216,5.84127747 C39.9726588,1.54347323 34.7402577,0.243001315 28.2922624,2.93640419 C28.2854471,2.93936762 26.9357793,3.51664391 26.9260263,3.52150394 C26.9200335,3.51557708 24.4561788,1.07691071 24.4191646,1.04431297 C17.0675523,-5.42426351 -5.91804558,20.3491672 1.43086413,26.6087626 L3.03692892,27.9811866 C2.62025451,29.0698325 2.4566869,30.3170812 2.59029062,31.6584485 C2.76196611,33.3810314 3.64290463,35.0326106 5.07071362,36.3086639 C6.42602173,37.5198773 8.20810971,38.2866946 9.93743774,38.2851536 C12.7972859,44.933314 19.3314127,49.0118243 26.9928869,49.2413124 C35.2112196,49.4875142 42.1100834,45.5974781 45.000718,38.6094714 C45.1897843,38.1188459 45.9922291,35.9090749 45.9922291,33.9584263 C45.9922291,31.9980576 44.893553,31.1856035 44.1938079,31.1856035 L44.1938079,31.1856035 Z",
    fill: "#1A1919",
    "data-testid": "Brands_mailchimp_path"
  }))))));
});

var Stripe = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'brand/stripe' : _ref$title;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "64px",
    width: "64px",
    version: "1.1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Brands_stripe_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Brands_stripe_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Brands_stripe_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "brand/stripe",
    "data-testid": "Brands_stripe_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#6772E5",
    points: "0 0 64 0 64 64 0 64",
    "data-testid": "Brands_stripe_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M28.9606299,24.7208791 C28.9606299,23.178022 30.2204724,22.5846154 32.3070866,22.5846154 C35.2992126,22.5846154 39.0787402,23.4945055 42.0708661,25.1164835 L42.0708661,15.8197802 C38.8031496,14.5142857 35.5748031,14 32.3070866,14 C24.3149606,14 19,18.1934066 19,25.1956044 C19,36.1142857 33.9606299,34.3736264 33.9606299,39.0813187 C33.9606299,40.9010989 32.3858268,41.4945055 30.1811024,41.4945055 C26.9133858,41.4945055 22.7401575,40.1494505 19.4330709,38.3296703 L19.4330709,47.7450549 C23.0944882,49.3274725 26.7952756,50 30.1811024,50 C38.3700787,50 44,45.9252747 44,38.843956 C43.9606299,27.0549451 28.9606299,29.1516484 28.9606299,24.7208791 Z",
    fill: "#FFFFFF",
    "data-testid": "Brands_stripe_path"
  }))));
});

var Webhooks = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'brand/webhooks' : _ref$title;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "64px",
    width: "64px",
    version: "1.1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Brands_webhooks_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Brands_webhooks_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Brands_webhooks_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "brand/webhooks",
    "data-testid": "Brands_webhooks_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EEEDEF",
    points: "0 0 64 0 64 64 0 64",
    "data-testid": "Brands_webhooks_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "webhooks",
    transform: "translate(8.000000, 9.000000)",
    "data-testid": "Brands_webhooks_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Path",
    d: "M22.494731,18.7389728 C20.4981684,22.0953056 18.5853447,25.3455063 16.6326275,28.571244 C16.1311346,29.3994129 15.8829285,30.074029 16.2835583,31.1266936 C17.3896653,34.0347877 15.829298,36.8647882 12.8967408,37.6329285 C10.1310969,38.3575999 7.4365842,36.539994 6.88785879,33.579022 C6.40160829,30.9582748 8.43543005,28.3890882 11.3250828,27.9794259 C11.567079,27.9448013 11.8143441,27.9408496 12.2211838,27.9103648 L16.6166324,20.5398309 C13.8521176,17.7909349 12.2066941,14.5778051 12.5708174,10.5959705 C12.8282442,7.78140054 13.9351039,5.34901897 15.9580113,3.35546718 C19.8325848,-0.462276696 25.7436145,-1.08043958 30.3057883,1.84985949 C34.6873118,4.66461762 36.694036,10.1473555 34.9835031,14.8399363 C33.6937349,14.4903026 32.3949343,14.1376581 30.967232,13.7503889 C31.5042904,11.1413087 31.1070479,8.7984996 29.3474006,6.79139904 C28.1848404,5.46625351 26.6929697,4.77169059 24.9967383,4.51576927 C21.5959956,4.00204486 18.2571633,6.18678493 17.2664091,9.52467633 C16.1418607,13.3126882 17.8439256,16.4072662 22.494731,18.739161 L22.494731,18.7389728 Z",
    fill: "#7A34FF",
    "data-testid": "Brands_webhooks_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Path",
    d: "M28.1966956,14.7697461 C29.603322,17.251242 31.0315887,19.7701852 32.4470594,22.2659825 C39.6015656,20.0524513 44.9958601,24.0130219 46.9310769,28.2532241 C49.268617,33.3752258 47.6706142,39.4416901 43.0800256,42.6017538 C38.3680625,45.8455565 32.4090476,45.2913739 28.2343311,41.1243727 C29.2982863,40.2337289 30.3675105,39.3391334 31.5099358,38.3833802 C35.6332798,41.0539944 39.2397004,40.9282919 41.917089,37.7657818 C44.2002459,35.0678819 44.1507552,31.0452128 41.8013599,28.4039542 C39.0900994,25.3560443 35.458463,25.2630846 31.0686597,28.1888674 C29.2476666,24.9582372 27.3950597,21.7533872 25.6316489,18.4994229 C25.0370082,17.4027248 24.3806453,16.7663087 23.0404456,16.5342859 C20.8024513,16.1462641 19.3576249,14.2244079 19.2708752,12.0712816 C19.1856308,9.94186572 20.4402098,8.0169987 22.4010187,7.2671116 C24.3433862,6.5239989 26.6227795,7.12372039 27.9292955,8.7751656 C28.9970143,10.1243978 29.3362982,11.6429898 28.7744003,13.3070429 C28.6182131,13.7710884 28.4159223,14.2200798 28.1966956,14.7699343 L28.1966956,14.7697461 Z",
    fill: "#77747C",
    "data-testid": "Brands_webhooks_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Path",
    d: "M31.5586737,35.055274 L22.9457924,35.055274 C22.1202579,38.4507477 20.3370885,41.1921166 17.2647155,42.9353924 C14.8761792,44.29027 12.3019119,44.7496111 9.56204837,44.3072059 C4.5173876,43.4937149 0.392538137,38.9524287 0.0293556804,33.838895 C-0.381623846,28.0460407 3.60002258,22.8969415 8.90719089,21.740403 C9.27357236,23.0710056 9.64390556,24.4144044 10.010287,25.741808 C5.14100763,28.2261266 3.45569049,31.3562701 4.8184715,35.2703608 C6.01810267,38.7147606 9.42580791,40.6027449 13.1259409,39.8726164 C16.9045439,39.1270574 18.8096522,35.9867523 18.5770649,30.9469841 C22.1592107,30.9469841 25.7443672,30.9099132 29.3268893,30.9652374 C30.7258004,30.9872541 31.8057507,30.8421693 32.8595444,29.6088544 C34.5945403,27.5795489 37.7880997,27.7626455 39.6567016,29.6792327 C41.5663263,31.6379717 41.474872,34.7895674 39.4540345,36.6656965 C37.5043281,38.4759635 34.4240516,38.3792403 32.5998595,36.4285929 C32.22501,36.0266459 31.9295715,35.5492398 31.5586737,35.055274 Z",
    fill: "#77747C",
    "data-testid": "Brands_webhooks_path"
  })))));
});

var WordPress = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'brand/wordpress' : _ref$title;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "64px",
    width: "64px",
    version: "1.1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Brands_wordpress_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Brands_wordpress_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Brands_wordpress_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "brand/wordpress",
    "data-testid": "Brands_wordpress_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#00749A",
    points: "0 0 64 0 64 64 0 64",
    "data-testid": "Brands_wordpress_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "WordPress",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(8.000000, 8.000000)",
    "data-testid": "Brands_wordpress_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M3.3982439,23.9063415 C3.3982439,32.0241951 8.11590244,39.0396098 14.956878,42.3640976 L5.17385366,15.5598049 C4.03590244,18.110439 3.3982439,20.9330732 3.3982439,23.9063415 Z",
    "data-testid": "Brands_wordpress_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M37.7521951,22.8714146 C37.7521951,20.3367805 36.8417561,18.5814634 36.060878,17.2152195 C35.0212683,15.5258537 34.0468293,14.0952195 34.0468293,12.4058537 C34.0468293,10.5205854 35.4766829,8.76565854 37.4907317,8.76565854 C37.5816585,8.76565854 37.6679024,8.77697561 37.7564878,8.78204878 C34.1077073,5.43921951 29.246439,3.3982439 23.907122,3.3982439 C16.7422439,3.3982439 10.4386341,7.07434146 6.7715122,12.6423415 C7.25268293,12.6567805 7.70614634,12.6669268 8.09131707,12.6669268 C10.2364878,12.6669268 13.5570732,12.4066341 13.5570732,12.4066341 C14.6626341,12.3414634 14.7929756,13.9652683 13.6885854,14.096 C13.6885854,14.096 12.577561,14.2267317 11.3412683,14.2915122 L18.8097561,36.5061463 L23.2979512,23.0454634 L20.1026341,14.2907317 C18.9982439,14.2259512 17.952,14.0952195 17.952,14.0952195 C16.8468293,14.030439 16.9763902,12.3406829 18.081561,12.4058537 C18.081561,12.4058537 21.4684878,12.6661463 23.4837073,12.6661463 C25.6284878,12.6661463 28.9494634,12.4058537 28.9494634,12.4058537 C30.0558049,12.3406829 30.1857561,13.9644878 29.0809756,14.0952195 C29.0809756,14.0952195 27.9676098,14.2259512 26.7336585,14.2907317 L34.1451707,36.3371707 L36.1908293,29.5012683 C37.0774634,26.6645854 37.7521951,24.627122 37.7521951,22.8714146 Z",
    "data-testid": "Brands_wordpress_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M24.2669268,25.7002927 L18.113561,43.580878 C19.9508293,44.1209756 21.8938537,44.4163902 23.907122,44.4163902 C26.2954146,44.4163902 28.5857561,44.0035122 30.7176585,43.2538537 C30.6626341,43.1660488 30.6126829,43.0727805 30.5717073,42.9713171 L24.2669268,25.7002927 Z",
    "data-testid": "Brands_wordpress_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M41.9028293,14.0667317 C41.9910244,14.72 42.0409756,15.4212683 42.0409756,16.1756098 C42.0409756,18.2567805 41.6522927,20.5962927 40.481561,23.521561 L34.2169756,41.6339512 C40.3141463,38.078439 44.4152195,31.4727805 44.4152195,23.9067317 C44.4156098,20.3410732 43.5047805,16.9880976 41.9028293,14.0667317 Z",
    "data-testid": "Brands_wordpress_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M23.907122,0 C10.7250732,0 0,10.7242927 0,23.9063415 C0,37.0899512 10.7250732,47.8138537 23.907122,47.8138537 C37.0887805,47.8138537 47.8154146,37.0899512 47.8154146,23.9063415 C47.8150244,10.7242927 37.0887805,0 23.907122,0 Z M23.907122,46.7180488 C11.329561,46.7180488 1.09619512,36.4846829 1.09619512,23.9063415 C1.09619512,11.3287805 11.3291707,1.09619512 23.907122,1.09619512 C36.4842927,1.09619512 46.716878,11.3287805 46.716878,23.9063415 C46.716878,36.4846829 36.4842927,46.7180488 23.907122,46.7180488 Z",
    "data-testid": "Brands_wordpress_path"
  })))));
});

var Zapier = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'brand/zapier' : _ref$title;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    height: "64px",
    width: "64px",
    version: "1.1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Brands_zapier_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Brands_zapier_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    "data-testid": "Brands_zapier_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "brand/zapier",
    "data-testid": "Brands_zapier_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FF4A00",
    points: "0 0 64 0 64 64 0 64",
    "data-testid": "Brands_zapier_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Shape",
    d: "M37.25,32.009135 C37.249055,33.569645 36.963665,35.06348 36.443495,36.442655 C35.06474,36.96272 33.57017,37.248845 32.00903,37.25 L31.99097,37.25 C30.430565,37.248845 28.936415,36.96356 27.55766,36.4436 C27.03749,35.064635 26.75105,33.570065 26.75,32.009135 L26.75,31.99097 C26.75105,30.43046 27.03686,28.93652 27.55619,27.557555 C28.93568,27.03728 30.429935,26.750945 31.99097,26.75 L32.00903,26.75 C33.57017,26.750945 35.06474,27.03728 36.443495,27.557555 C36.963665,28.93652 37.249055,30.43046 37.25,31.99097 L37.25,32.009135 Z M52.7081,28.500035 L40.44977,28.500035 L49.11752,19.83218 C48.43628,18.875315 47.67671,17.97809 46.84826,17.149745 L46.84784,17.149325 C46.020125,16.32182 45.123635,15.56309 44.16782,14.88248 L35.499965,23.55023 L35.499965,11.292005 C34.365125,11.101535 33.200045,11.00063 32.01113,11 L31.988765,11 C30.799955,11.00063 29.634875,11.101535 28.500035,11.292005 L28.500035,23.550335 L19.83218,14.88248 C18.87584,15.563405 17.979035,16.322555 17.15111,17.15048 L17.148065,17.15342 C16.321085,17.980715 15.56288,18.876785 14.882585,19.83218 L23.55044,28.500035 L11.2919,28.500035 C11.2919,28.500035 11.00042,30.80237 11,31.992335 L11,32.00735 C11.00042,33.197525 11.10143,34.364075 11.292005,35.499965 L23.55023,35.499965 L14.882585,44.167715 C16.24475,46.0805 17.919395,47.755355 19.832285,49.11752 L28.500035,40.449875 L28.500035,52.707995 C29.633615,52.89815 30.79754,52.99916 31.98509,53 L32.01512,53 C33.202565,52.99916 34.366385,52.89815 35.499965,52.7081 L35.499965,40.449665 L44.167925,49.117415 C45.12395,48.4367 46.02044,47.677865 46.84826,46.850255 L46.85036,46.84826 C47.677865,46.02044 48.4367,45.123845 49.117415,44.167925 L40.449665,35.499965 L52.707995,35.499965 C52.89815,34.366385 52.99916,33.20246 53,32.01491 L53,31.98488 C52.99916,30.797435 52.89815,29.633615 52.7081,28.500035 L52.7081,28.500035 Z",
    fill: "#FFFFFF",
    "data-testid": "Brands_zapier_path"
  }))));
});

var BrandIcon = {
  Mailchimp: Mailchimp,
  Zapier: Zapier,
  WordPress: WordPress,
  Webhooks: Webhooks,
  Stripe: Stripe
};

var VariantIcon = function VariantIcon(_ref) {
  var icon = _ref.icon,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      className = _ref.className,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["icon", "height", "width", "className", "variant"]);

  if ( /*#__PURE__*/React__default['default'].isValidElement(icon)) {
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].cloneElement(icon, _objectSpread2({
      height: height,
      width: width,
      className: cx__default['default'](variant, className)
    }, props)));
  }

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(icon, _objectSpread2({
    height: height,
    width: width,
    className: cx__default['default'](variant, className)
  }, props)));
};

VariantIcon.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  height: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
  icon: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].node]),
  variant: PropTypes__default['default'].string,
  width: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number])
};

var User = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Edit Profile' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M19.996 19.55v.004A10.97 10.97 0 0 1 12 23a10.97 10.97 0 0 1-7.997-3.447A.003.003 0 0 0 4 19.55h.001L4 19.549V18c0-2.66 5.33-4 8-4s8 1.34 8 4v1.548c0 .001 0 .002-.002.002zM12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: title,
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_user_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_user_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.996 19.55v.004A10.97 10.97 0 0 1 12 23a10.97 10.97 0 0 1-7.997-3.447A.003.003 0 0 0 4 19.55h.001L4 19.549V18c0-2.66 5.33-4 8-4s8 1.34 8 4v1.548c0 .001 0 .002-.002.002zM12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z",
    fill: color,
    "data-testid": "CustomizableIcons_user_path"
  }));
});

var Edit = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Edit' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M16.75 11L13 7.25l-9 9V20h3.75l9-9zm2.96-2.96a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0L14 6.25 17.75 10l1.96-1.96z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Edit",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_edit_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_edit_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16.75 11L13 7.25l-9 9V20h3.75l9-9zm2.96-2.96a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0L14 6.25 17.75 10l1.96-1.96z",
    fill: color,
    "data-testid": "CustomizableIcons_edit_path"
  }));
});

var Trash = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Delete Account' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: title,
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_trash_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_trash_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
    fill: color,
    "data-testid": "CustomizableIcons_trash_path"
  }));
});

var SwitchPlan = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Switch Plan' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M4.74 13.358a1 1 0 0 1 1.86-.405l1.438 2.49 5.687-3.284a1 1 0 0 1 1 1.732l-5.687 3.284 1.437 2.489a1 1 0 0 1-1.28 1.41l-4.33-1.975a1 1 0 0 1-.58-1.005l.454-4.736zM19.136 4.9a1 1 0 0 1 .58 1.005l-.455 4.736a1 1 0 0 1-1.861.405l-1.437-2.49-5.689 3.285a1 1 0 0 1-1-1.732l5.689-3.285-1.437-2.489a1 1 0 0 1 1.28-1.41l4.33 1.975z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Switch Plan",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_switchPlan_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_switchPlan_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M4.74 13.358a1 1 0 0 1 1.86-.405l1.438 2.49 5.687-3.284a1 1 0 0 1 1 1.732l-5.687 3.284 1.437 2.489a1 1 0 0 1-1.28 1.41l-4.33-1.975a1 1 0 0 1-.58-1.005l.454-4.736zM19.136 4.9a1 1 0 0 1 .58 1.005l-.455 4.736a1 1 0 0 1-1.861.405l-1.437-2.49-5.689 3.285a1 1 0 0 1-1-1.732l5.689-3.285-1.437-2.489a1 1 0 0 1 1.28-1.41l4.33 1.975z",
    fill: color,
    "data-testid": "CustomizableIcons_switchPlan_path"
  }));
});

var PaymentMethod = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Update Payment Method' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M6 5h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6zM5 9h14v3H5V9zm10 5h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Update Payment Method",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_paymentMethod_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_paymentMethod_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6 5h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6zM5 9h14v3H5V9zm10 5h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2z",
    fill: color,
    "data-testid": "CustomizableIcons_paymentMethod_path"
  }));
});

var Close = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Stop Subscribing' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M16.936 18.361L12 13.425l-4.936 4.936a1.008 1.008 0 1 1-1.425-1.425L10.575 12 5.639 7.064A1.008 1.008 0 1 1 7.064 5.64L12 10.575l4.936-4.936a1.008 1.008 0 1 1 1.425 1.425L13.425 12l4.936 4.936a1.008 1.008 0 1 1-1.425 1.425z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Stop Subscribing",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_close_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_close_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16.936 18.361L12 13.425l-4.936 4.936a1.008 1.008 0 1 1-1.425-1.425L10.575 12 5.639 7.064A1.008 1.008 0 1 1 7.064 5.64L12 10.575l4.936-4.936a1.008 1.008 0 1 1 1.425 1.425L13.425 12l4.936 4.936a1.008 1.008 0 1 1-1.425 1.425z",
    fill: color,
    "data-testid": "CustomizableIcons_close_path"
  }));
});

var Back = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Back' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "Menu-Tray-Header-Nav clickable",
    height: "24px",
    icon: "M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Back",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_back_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_back_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z",
    fill: color,
    "data-testid": "CustomizableIcons_back_path"
  }));
});

var Keep = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Keep Subscription' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M6.36 6.35A7.958 7.958 0 0 1 12.01 4C16.43 4 20 7.58 20 12s-3.57 8-7.99 8c-3.73 0-6.84-2.55-7.73-6h2.08c.82 2.33 3.04 4 5.65 4 3.31 0 6-2.69 6-6s-2.69-6-6-6c-1.66 0-3.14.69-4.22 1.78l2.366 2.366a.5.5 0 0 1-.353.854H4.01V5.207a.5.5 0 0 1 .854-.353L6.36 6.35z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Keep Subscription",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_keep_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_keep_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6.36 6.35A7.958 7.958 0 0 1 12.01 4C16.43 4 20 7.58 20 12s-3.57 8-7.99 8c-3.73 0-6.84-2.55-7.73-6h2.08c.82 2.33 3.04 4 5.65 4 3.31 0 6-2.69 6-6s-2.69-6-6-6c-1.66 0-3.14.69-4.22 1.78l2.366 2.366a.5.5 0 0 1-.353.854H4.01V5.207a.5.5 0 0 1 .854-.353L6.36 6.35z",
    fill: color,
    "data-testid": "CustomizableIcons_keep_path"
  }));
});

var Gift$1 = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Gift a Subscription' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "16px",
    icon: "M2.686 4C2.257 3.6 2 3.04 2 2.4 2 1.04 3.114 0 4.571 0 5.43 0 6.971.72 8 1.68 9.029.72 10.571 0 11.429 0 12.886 0 14 1.04 14 2.4c0 .64-.257 1.2-.686 1.6H15a1 1 0 011 1v1H9V4H7v2H0V5a1 1 0 011-1h1.686zM1 8h6v7H2a1 1 0 01-1-1V8zm8 0h6v6a1 1 0 01-1 1H9V8zM4.77 3.2s2-.08 2.23-.16C6.615 2.56 5.23 1.6 4.77 1.6c-.462 0-.77.32-.77.8 0 .48.308.8.77.8zm6.46 0c.462 0 .77-.32.77-.8 0-.48-.308-.8-.77-.8-.46 0-1.768.88-2.23 1.44.23.08 2.23.16 2.23.16z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Gift a Subscription",
    width: "16px",
    viewBox: "0 0 16 16",
    "data-testid": "CustomizableIcons_gift_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_gift_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M2.686 4C2.257 3.6 2 3.04 2 2.4 2 1.04 3.114 0 4.571 0 5.43 0 6.971.72 8 1.68 9.029.72 10.571 0 11.429 0 12.886 0 14 1.04 14 2.4c0 .64-.257 1.2-.686 1.6H15a1 1 0 011 1v1H9V4H7v2H0V5a1 1 0 011-1h1.686zM1 8h6v7H2a1 1 0 01-1-1V8zm8 0h6v6a1 1 0 01-1 1H9V8zM4.77 3.2s2-.08 2.23-.16C6.615 2.56 5.23 1.6 4.77 1.6c-.462 0-.77.32-.77.8 0 .48.308.8.77.8zm6.46 0c.462 0 .77-.32.77-.8 0-.48-.308-.8-.77-.8-.46 0-1.768.88-2.23 1.44.23.08 2.23.16 2.23.16z",
    fill: color,
    "data-testid": "CustomizableIcons_gift_path"
  }));
});

var Eye = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Show' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M8.115 9.164C7.091 9.826 6.135 10.772 5.25 12c1.923 2.667 4.173 4 6.75 4s4.827-1.333 6.75-4c-.886-1.228-1.84-2.174-2.865-2.836.075.23.115.506.115.836a4 4 0 1 1-8 0c0-.33.04-.606.115-.836zM12 18c-3.314 0-6.314-2-9-6 2.686-4 5.686-6 9-6s6.314 2 9 6c-2.686 4-5.686 6-9 6zm-1-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Show Password",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_eye_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_eye_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M8.115 9.164C7.091 9.826 6.135 10.772 5.25 12c1.923 2.667 4.173 4 6.75 4s4.827-1.333 6.75-4c-.886-1.228-1.84-2.174-2.865-2.836.075.23.115.506.115.836a4 4 0 1 1-8 0c0-.33.04-.606.115-.836zM12 18c-3.314 0-6.314-2-9-6 2.686-4 5.686-6 9-6s6.314 2 9 6c-2.686 4-5.686 6-9 6zm-1-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: color,
    "data-testid": "CustomizableIcons_eye_path"
  }));
});

var EyeCrossed = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Hide' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M10.545 15.851c.473.1.958.149 1.455.149 2.577 0 4.827-1.333 6.75-4-.657-.912-1.353-1.667-2.086-2.267l-.686.685a4.001 4.001 0 0 1-3.56 3.56l-1.873 1.873zm7.412-7.411c1.055.924 2.07 2.11 3.043 3.56-2.686 4-5.686 6-9 6a8.03 8.03 0 0 1-3.017-.587l-2.149 2.15a1 1 0 0 1-1.414-1.415L18.148 5.42a1 1 0 1 1 1.414 1.414L17.957 8.44zM6.869 13.859l-1.282 1.282C4.694 14.286 3.832 13.24 3 12c2.686-4 5.686-6 9-6 .809 0 1.599.12 2.37.357L11.558 9.17a1 1 0 0 0-1.388 1.388L8.608 12.12A3.981 3.981 0 0 1 8 10c0-.33.04-.606.115-.836-1.024.662-1.98 1.608-2.865 2.836a12.54 12.54 0 0 0 1.619 1.859z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Hide Password",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_eyeCrossed_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_eyeCrossed_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M10.545 15.851c.473.1.958.149 1.455.149 2.577 0 4.827-1.333 6.75-4-.657-.912-1.353-1.667-2.086-2.267l-.686.685a4.001 4.001 0 0 1-3.56 3.56l-1.873 1.873zm7.412-7.411c1.055.924 2.07 2.11 3.043 3.56-2.686 4-5.686 6-9 6a8.03 8.03 0 0 1-3.017-.587l-2.149 2.15a1 1 0 0 1-1.414-1.415L18.148 5.42a1 1 0 1 1 1.414 1.414L17.957 8.44zM6.869 13.859l-1.282 1.282C4.694 14.286 3.832 13.24 3 12c2.686-4 5.686-6 9-6 .809 0 1.599.12 2.37.357L11.558 9.17a1 1 0 0 0-1.388 1.388L8.608 12.12A3.981 3.981 0 0 1 8 10c0-.33.04-.606.115-.836-1.024.662-1.98 1.608-2.865 2.836a12.54 12.54 0 0 0 1.619 1.859z",
    fill: color,
    "data-testid": "CustomizableIcons_eyeCrossed_path"
  }));
});

var Down = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Show details' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "12px",
    icon: "M.787 3.312a.932.932 0 0 1 1.39 0l3.824 4.122 3.824-4.122a.931.931 0 0 1 1.39 0c.384.414.377 1.093-.006 1.507L6.702 9.688a.943.943 0 0 1-1.402 0L.793 4.819a1.125 1.125 0 0 1-.006-1.507z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Show details",
    width: "12px",
    viewBox: "0 0 12 12",
    "data-testid": "CustomizableIcons_down_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_down_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M.787 3.312a.932.932 0 0 1 1.39 0l3.824 4.122 3.824-4.122a.931.931 0 0 1 1.39 0c.384.414.377 1.093-.006 1.507L6.702 9.688a.943.943 0 0 1-1.402 0L.793 4.819a1.125 1.125 0 0 1-.006-1.507z",
    fill: color,
    "data-testid": "CustomizableIcons_down_path"
  }));
});

var Up = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Hide details' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "12px",
    icon: "M.787 9.188a.932.932 0 0 0 1.39 0l3.824-4.122 3.824 4.122a.931.931 0 0 0 1.39 0c.384-.414.377-1.093-.006-1.507L6.702 2.812a.943.943 0 0 0-1.402 0L.793 7.681a1.125 1.125 0 0 0-.006 1.507z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: title,
    width: "12px",
    viewBox: "0 0 12 12",
    "data-testid": "CustomizableIcons_up_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_up_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M.787 9.188a.932.932 0 0 0 1.39 0l3.824-4.122 3.824 4.122a.931.931 0 0 0 1.39 0c.384-.414.377-1.093-.006-1.507L6.702 2.812a.943.943 0 0 0-1.402 0L.793 7.681a1.125 1.125 0 0 0-.006 1.507z",
    fill: color,
    "data-testid": "CustomizableIcons_up_path"
  }));
});

var Bank = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Stripe Test Bank' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M12.77 3.209l7.98 4.877c.279.17.333.49.12.714a.7.7 0 0 1-.505.2H3.635C3.285 9 3 8.772 3 8.49c0-.158.092-.308.25-.404l7.98-4.877a1.528 1.528 0 0 1 1.54 0zM6 10a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zM5 19h14a2 2 0 0 1 2 2H3a2 2 0 0 1 2-2z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Bank",
    width: "24px",
    viewBox: "0 0 24 24",
    "data-testid": "CustomizableIcons_bank_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_bank_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.77 3.209l7.98 4.877c.279.17.333.49.12.714a.7.7 0 0 1-.505.2H3.635C3.285 9 3 8.772 3 8.49c0-.158.092-.308.25-.404l7.98-4.877a1.528 1.528 0 0 1 1.54 0zM6 10a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zM5 19h14a2 2 0 0 1 2 2H3a2 2 0 0 1 2-2z",
    fill: color,
    "data-testid": "CustomizableIcons_bank_path"
  }));
});

var AddPayment = (function (_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Add Payment' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "clickable",
    height: "24px",
    icon: "M14.748 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1.582c.63.256 1.301.433 2 .52V17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-4c0-.69-.088-1.36-.252-2zm0 4H20v3h-6.755a7.973 7.973 0 0 0 1.503-3zM8 7V5a1 1 0 1 0-2 0v2H4a1 1 0 1 0 0 2h2v2a1 1 0 0 0 2 0V9h2a1 1 0 0 0 0-2H8zm8 8h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2zm-9-1A6 6 0 1 1 7 2a6 6 0 0 1 0 12z",
    role: "img",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    },
    title: "Add Payment",
    width: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "CustomizableIcons_addPayment_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title",
    "data-testid": "CustomizableIcons_addPayment_title"
  }, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14.748 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1.582c.63.256 1.301.433 2 .52V17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-4c0-.69-.088-1.36-.252-2zm0 4H20v3h-6.755a7.973 7.973 0 0 0 1.503-3zM8 7V5a1 1 0 1 0-2 0v2H4a1 1 0 1 0 0 2h2v2a1 1 0 0 0 2 0V9h2a1 1 0 0 0 0-2H8zm8 8h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2zm-9-1A6 6 0 1 1 7 2a6 6 0 0 1 0 12z",
    fill: color,
    "data-testid": "CustomizableIcons_addPayment_path"
  }));
});

var CustomizableIcons = {
  User: User,
  Edit: Edit,
  Trash: Trash,
  SwitchPlan: SwitchPlan,
  PaymentMethod: PaymentMethod,
  Close: Close,
  Back: Back,
  Keep: Keep,
  Gift: Gift$1,
  Eye: Eye,
  EyeCrossed: EyeCrossed,
  Down: Down,
  Up: Up,
  Bank: Bank,
  AddPayment: AddPayment
};

var Facebook = function Facebook(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Social_facebook_svg"
  }, /*#__PURE__*/React__default['default'].createElement("defs", {
    "data-testid": "Social_facebook_defs"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    id: "path-1",
    cx: "12",
    cy: "12",
    r: "12",
    "data-testid": "Social_facebook_circle"
  })), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Social_facebook_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "socialicon_facebook",
    "data-testid": "Social_facebook_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,17.9892084 19.6123357,22.9536229 13.8760391,23.8542116 L13.875,15.4692566 L16.6710937,15.4692566 L17.203125,12.000393 L13.875,12.000393 L13.875,9.74931148 C13.875,8.80029602 14.3398828,7.87525791 15.8305781,7.87525791 L15.8305781,7.87525791 L17.34375,7.87525791 L17.34375,4.9220362 C17.34375,4.9220362 15.9704766,4.68765352 14.6575781,4.68765352 C11.9165156,4.68765352 10.125,6.34895793 10.125,9.35655643 L10.125,9.35655643 L10.125,12.000393 L7.078125,12.000393 L7.078125,15.4692566 L10.125,15.4692566 L10.1249608,23.8543686 C4.38817415,22.9541998 0,17.9895564 0,12 C0,5.372583 5.372583,0 12,0 Z",
    id: "Shape",
    fill: "#1877F2",
    "data-testid": "Social_facebook_path"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Shape",
    "data-testid": "Social_facebook_g"
  }, /*#__PURE__*/React__default['default'].createElement("mask", {
    id: "mask-2",
    fill: "white",
    "data-testid": "Social_facebook_mask"
  }, /*#__PURE__*/React__default['default'].createElement("use", {
    xlinkHref: "#path-1",
    "data-testid": "Social_facebook_use"
  })), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Mask",
    opacity: "0.993536086",
    "data-testid": "Social_facebook_g"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M10.125,24 L10.125,15.4692566 L7.078125,15.4692566 L7.078125,12.000393 L10.125,12.000393 L10.125,9.35655643 C10.125,6.34895793 11.9165156,4.68765352 14.6575781,4.68765352 C15.9704766,4.68765352 17.34375,4.9220362 17.34375,4.9220362 L17.34375,7.87525791 L15.8305781,7.87525791 C14.3398828,7.87525791 13.875,8.80029602 13.875,9.74931148 L13.875,12.000393 L17.203125,12.000393 L16.6710937,15.4692566 L13.875,15.4692566 L13.875,24",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    "data-testid": "Social_facebook_path"
  })))));
};

Facebook.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Github = function Github(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Social_github_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Social_github_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "socialicon_github",
    fill: "#151513",
    "data-testid": "Social_github_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12,1.77635684e-15 C5.3735,1.77635684e-15 0,5.3725 0,12 C0,17.302 3.4385,21.8 8.2065,23.387 C8.8065,23.498 9.0265,23.127 9.0265,22.8095 C9.0265,22.5235 9.015,21.578 9.01,20.5755 C5.6715,21.3015 4.967,19.1595 4.967,19.1595 C4.421,17.7725 3.6345,17.404 3.6345,17.404 C2.546,16.659 3.717,16.674 3.717,16.674 C4.922,16.759 5.5565,17.911 5.5565,17.911 C6.6265,19.7455 8.3635,19.215 9.0485,18.9085 C9.156,18.133 9.467,17.6035 9.81,17.3035 C7.145,17.0005 4.343,15.9715 4.343,11.3735 C4.343,10.0635 4.8115,8.9925 5.5795,8.1525 C5.4545,7.85 5.044,6.6295 5.6955,4.9765 C5.6955,4.9765 6.7035,4.654 8.9965,6.2065 C9.9535,5.941 10.9805,5.8075 12,5.803 C13.02,5.8075 14.0475,5.941 15.0065,6.2065 C17.2965,4.654 18.303,4.9765 18.303,4.9765 C18.956,6.6295 18.545,7.85 18.4205,8.1525 C19.1905,8.9925 19.6555,10.063 19.6555,11.3735 C19.6555,15.9825 16.8485,16.997 14.176,17.2945 C14.6065,17.6665 14.99,18.397 14.99,19.5165 C14.99,21.122 14.9765,22.4145 14.9765,22.8095 C14.9765,23.1295 15.1925,23.503 15.8005,23.3855 C20.566,21.797 24,17.3 24,12 C24,5.372 18.6275,1.77635684e-15 12,1.77635684e-15",
    id: "Shape",
    "data-testid": "Social_github_path"
  }))));
};

Github.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Google = function Google(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Social_google_svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    "data-testid": "Social_google_title"
  }, "socialicon_google"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Social_google_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "socialicon_google",
    "data-testid": "Social_google_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M23.763885,12.2747545 C23.763885,11.4237048 23.6875088,10.6053879 23.5456671,9.81980357 L12.2419821,9.81980357 L12.2419821,14.4623885 L18.7012307,14.4623885 C18.4230029,15.9626363 17.5774088,17.2337553 16.3062897,18.0848049 L16.3062897,21.0962113 L20.1851121,21.0962113 C22.4545779,19.0067754 23.763885,15.9299036 23.763885,12.2747545 L23.763885,12.2747545 Z",
    id: "Shape",
    fill: "#4285F4",
    "data-testid": "Social_google_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.2419821,24.0039643 C15.4825173,24.0039643 18.1993296,22.9292413 20.1851121,21.0962113 L16.3062897,18.0848049 C15.2315668,18.8049238 13.8567943,19.2304487 12.2419821,19.2304487 C9.11601134,19.2304487 6.47011982,17.1191909 5.52632759,14.2823588 L1.51657446,14.2823588 L1.51657446,17.3919632 C3.49144607,21.3144292 7.55029821,24.0039643 12.2419821,24.0039643 L12.2419821,24.0039643 Z",
    id: "Shape",
    fill: "#34A853",
    "data-testid": "Social_google_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M5.52632759,14.2823588 C5.28628795,13.5622398 5.14990179,12.7930219 5.14990179,12.0019821 C5.14990179,11.2109424 5.28628795,10.4417245 5.52632759,9.72160554 L5.52632759,6.61200107 L1.51657446,6.61200107 C0.703712946,8.23226866 0.24,10.0652987 0.24,12.0019821 C0.24,13.9386656 0.703712946,15.7716956 1.51657446,17.3919632 L5.52632759,14.2823588 L5.52632759,14.2823588 Z",
    id: "Shape",
    fill: "#FBBC05",
    "data-testid": "Social_google_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.2419821,4.77351563 C14.0040913,4.77351563 15.5861708,5.37907018 16.8300126,6.5683575 L20.2723993,3.1259708 C18.1938742,1.18928732 15.4770619,7.10542736e-15 12.2419821,7.10542736e-15 C7.55029821,7.10542736e-15 3.49144607,2.68953509 1.51657446,6.61200107 L5.52632759,9.72160554 C6.47011982,6.88477339 9.11601134,4.77351563 12.2419821,4.77351563 L12.2419821,4.77351563 Z",
    id: "Shape",
    fill: "#EA4335",
    "data-testid": "Social_google_path"
  }))));
};

Google.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var LinkedIn = function LinkedIn(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Social_linkedin_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Social_linkedin_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "socialicon_linkedin",
    fill: "#2867B2",
    fillRule: "nonzero",
    "data-testid": "Social_linkedin_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M22.08,0 L2.05,0 C0.957,0 2.13162821e-14,0.787 2.13162821e-14,1.869 L2.13162821e-14,21.943 C2.13162821e-14,23.031 0.957,24 2.05,24 L22.075,24 C23.175,24 24.0000323,23.025 24.0000323,21.943 L24.0000323,1.869 C24.006,0.788 23.175,0 22.081,0 L22.08,0 Z M7.44,20.005 L4.001,20.005 L4.001,9.315 L7.439,9.315 L7.44,20.005 Z M5.839,7.69 L5.814,7.69 C4.714,7.69 4.001,6.871 4.001,5.846 C4.001,4.801 4.732,4.001 5.858,4.001 C6.983,4.001 7.671,4.795 7.696,5.846 C7.696,6.871 6.983,7.69 5.839,7.69 Z M20.005,20.005 L16.567,20.005 L16.567,14.16 C16.567,12.76 16.067,11.803 14.822,11.803 C13.872,11.803 13.31,12.447 13.06,13.072 C12.966,13.297 12.941,13.604 12.941,13.916 L12.941,20.005 L9.502,20.005 L9.502,9.315 L12.941,9.315 L12.941,10.803 C13.441,10.09 14.222,9.065 16.041,9.065 C18.299,9.065 20.005,10.553 20.005,13.76 L20.005,20.005 L20.005,20.005 Z",
    id: "Shape",
    "data-testid": "Social_linkedin_path"
  }))));
};

LinkedIn.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Twitter = function Twitter(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '24' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Social_twitter_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Social_twitter_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "socialicon_twitter",
    fill: "#1DA1F2",
    fillRule: "nonzero",
    "data-testid": "Social_twitter_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M7.54752,21.7514103 C16.60416,21.7514103 21.55776,14.2480503 21.55776,7.74117027 C21.55776,7.52805027 21.55776,7.31589027 21.54336,7.10469027 C22.5070381,6.40764469 23.3389013,5.54457449 24,4.55589027 C23.1013239,4.95409997 22.1479961,5.21524577 21.17184,5.33061027 C22.1997542,4.71523304 22.9690786,3.74735138 23.33664,2.60709027 C22.3700712,3.18064737 21.3126203,3.58486181 20.20992,3.80229027 C18.6835995,2.17930878 16.2582906,1.78207835 14.2939673,2.833343 C12.329644,3.88460765 11.314824,6.12292297 11.81856,8.29317027 C7.85941991,8.09468983 4.17069675,6.22468061 1.6704,3.14853027 C0.363477846,5.39842921 1.03102837,8.27671537 3.19488,9.72165027 C2.41127155,9.69842552 1.6447482,9.48703892 0.96,9.10533027 C0.96,9.12549027 0.96,9.14661027 0.96,9.16773027 C0.960641408,11.5116595 2.61288143,13.530484 4.9104,13.9946103 C4.18547481,14.1923127 3.42487736,14.2212128 2.68704,14.0790903 C3.33211001,16.0849362 5.18071158,17.4590428 7.28736,17.4986103 C5.54374564,18.8689449 3.38981713,19.6128449 1.17216,19.6106103 C0.780387426,19.6098582 0.388995903,19.5861375 0,19.5395703 C2.25181051,20.9846358 4.87191687,21.7511385 7.54752,21.7475703",
    id: "Path",
    "data-testid": "Social_twitter_path"
  }))));
};

Twitter.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Social = {
  Facebook: Facebook,
  Github: Github,
  Google: Google,
  LinkedIn: LinkedIn,
  Twitter: Twitter
};

var Abandonment = function Abandonment(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_abandonment_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_abandonment_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_abandonment",
    "data-testid": "Activity_abandonment_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FFEFEE",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_abandonment_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14.5,23 C15.8807119,23 17,24.1192881 17,25.5 C17,26.8807119 15.8807119,28 14.5,28 C13.1192881,28 12,26.8807119 12,25.5 C12,24.1192881 13.1192881,23 14.5,23 Z M23.5,23 C24.8807119,23 26,24.1192881 26,25.5 C26,26.8807119 24.8807119,28 23.5,28 C22.1192881,28 21,26.8807119 21,25.5 C21,24.1192881 22.1192881,23 23.5,23 Z M8,6 C8.4365242,6 8.80772097,6.27969998 8.94415089,6.66966052 C8.96057338,6.70798683 8.97478022,6.74776881 8.98657347,6.78889675 L12.7530258,20 L26,20 C26.5522847,20 27,20.4477153 27,21 C27,21.5522847 26.5522847,22 26,22 L12,22 C11.5274099,22 11.131388,21.6721728 11.0269366,21.2315208 C11.0192549,21.210257 11.0122367,21.1885891 11.0059125,21.1665342 L7.25216668,8 L5,8 C4.44771525,8 4,7.55228475 4,7 C4,6.44771525 4.44771525,6 5,6 L8,6 Z M27.2803895,9 C27.6426498,9 27.8743291,9.25858105 27.8300182,9.59407246 L27.8109814,9.6873405 L25.4390186,18.3126595 C25.344745,18.6554729 24.9994858,18.9430392 24.6389927,18.9924908 L24.5306235,19 L14.4693765,19 C14.1170073,19 13.7408441,18.7456754 13.5969316,18.4142296 L13.5609814,18.3126595 L11.1890186,9.6873405 C11.0939593,9.34167031 11.2850684,9.05217185 11.6237023,9.0063226 L11.7196105,9 L27.2803895,9 Z M16.7924873,11.2924873 C16.4325029,11.6524718 16.4048118,12.2189168 16.709414,12.6106643 L16.7924873,12.7047411 L18.0877462,14 L16.7924873,15.2952589 C16.4025042,15.685242 16.4025042,16.3175295 16.7924873,16.7075127 C17.1524718,17.0674971 17.7189168,17.0951882 18.1106643,16.790586 L18.2047411,16.7075127 L19.5,15.4122538 L20.7952589,16.7075127 C21.185242,17.0974958 21.8175295,17.0974958 22.2075127,16.7075127 C22.5674971,16.3475282 22.5951882,15.7810832 22.290586,15.3893357 L22.2075127,15.2952589 L20.9122538,14 L22.2075127,12.7047411 C22.5974958,12.314758 22.5974958,11.6824705 22.2075127,11.2924873 C21.8475282,10.9325029 21.2810832,10.9048118 20.8893357,11.209414 L20.7952589,11.2924873 L19.5,12.5877462 L18.2047411,11.2924873 C17.814758,10.9025042 17.1824705,10.9025042 16.7924873,11.2924873 Z",
    id: "Combined-Shape",
    fill: "#FF4440",
    "data-testid": "Activity_abandonment_path"
  }))));
};

Abandonment.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Access = function Access(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_access_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_access_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_access",
    "data-testid": "Activity_access_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_access_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M9,6 C10.1045695,6 11,6.8954305 11,8 C11,8.7398375 10.5982846,9.38584934 10.0010775,9.73181186 L10,24 C11.0543618,24 11.9181651,24.8158778 11.9945143,25.8507377 L12,26 L6,26 C6,24.8954305 6.8954305,24 8,24 L7.99992752,9.73239368 C7.40216612,9.38657394 7,8.74025244 7,8 C7,6.8954305 7.8954305,6 9,6 Z M23,6 C24.1045695,6 25,6.8954305 25,8 C25,8.7398375 24.5982846,9.38584934 24.0010775,9.73181186 L24,24 C25.0543618,24 25.9181651,24.8158778 25.9945143,25.8507377 L26,26 L20,26 C20,24.8954305 20.8954305,24 22,24 L21.9999275,9.73239368 C21.4021661,9.38657394 21,8.74025244 21,8 C21,6.8954305 21.8954305,6 23,6 Z M21,10.3374332 L21,14.4536884 C19.6731088,16.0371548 17.9208861,17 16,17 C14.0791139,17 12.3268912,16.0371548 11,14.4536884 L11,10.3374332 C11.8696105,13.0892712 13.7813983,15 16,15 C18.2186017,15 20.1303895,13.0892712 21,10.3374332 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_access_path"
  }))));
};

Access.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Add = function Add(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_add_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_add_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_add",
    "data-testid": "Activity_add_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#F9F4FF",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_add_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16,6 C21.5228475,6 26,10.4771525 26,16 C26,21.5228475 21.5228475,26 16,26 C10.4771525,26 6,21.5228475 6,16 C6,10.4771525 10.4771525,6 16,6 Z M16,10 C15.4477153,10 15,10.4477153 15,11 L15,11 L15,14.999 L11,15 C10.4477153,15 10,15.4477153 10,16 C10,16.5522847 10.4477153,17 11,17 L11,17 L15,16.999 L15,21 C15,21.5522847 15.4477153,22 16,22 C16.5522847,22 17,21.5522847 17,21 L17,21 L17,16.999 L21,17 C21.5522847,17 22,16.5522847 22,16 C22,15.4477153 21.5522847,15 21,15 L21,15 L17,14.999 L17,11 C17,10.4477153 16.5522847,10 16,10 Z",
    id: "Combined-Shape",
    fill: "#7A34FF",
    "data-testid": "Activity_add_path"
  }))));
};

Add.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Cancel = function Cancel(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_cancel_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_cancel_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_cancel",
    "data-testid": "Activity_cancel_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FFEFEE",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_cancel_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16,6 C18.4008955,6 20.6041735,6.8461012 22.3279248,8.25639439 L22.363961,8.22182541 L23.7781746,9.63603897 L23.7436056,9.6720752 C25.1538988,11.3958265 26,13.5991045 26,16 C26,21.5228475 21.5228475,26 16,26 C13.5991045,26 11.3958265,25.1538988 9.6720752,23.7436056 L9.63603897,23.7781746 L8.22182541,22.363961 L8.25639439,22.3279248 C6.8461012,20.6041735 6,18.4008955 6,16 C6,10.4771525 10.4771525,6 16,6 Z M22.3207287,11.0954772 L11.0954772,22.3207287 C12.449979,23.3732643 14.1517985,24 16,24 C20.418278,24 24,20.418278 24,16 C24,14.1517985 23.3732643,12.449979 22.3207287,11.0954772 Z M16,8 C11.581722,8 8,11.581722 8,16 C8,17.8482015 8.62673571,19.550021 9.67927125,20.9045228 L20.9045228,9.67927125 C19.550021,8.62673571 17.8482015,8 16,8 Z",
    id: "Shape",
    fill: "#FF4440",
    "data-testid": "Activity_cancel_path"
  }))));
};

Cancel.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Discount = function Discount(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_discount_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_discount_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_discount",
    "data-testid": "Activity_discount_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#28BF6F",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_discount_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M24.9623448,7.03858815 C25.5075996,7.58495981 25.7832793,8.30613483 25.7893999,9.0371744 L26,15.0485132 C25.9573041,15.4161295 25.82239,15.7369387 25.5493495,16.0105385 L16.0579946,25.4401789 C15.3043942,26.1888793 14.0885741,26.1862692 13.3381821,25.43434 L6.56450361,18.6467863 C5.81183213,17.8925731 5.81183213,16.6697518 6.5645036,15.9155386 L16.0095237,6.45117124 C16.2829657,6.22357379 16.6486259,6.0427834 17.0154907,6 L23.0615877,6.21278035 C23.7452997,6.25351897 24.4230204,6.52818842 24.9623448,7.03858815 Z M20.5250107,11.4747585 C21.2768316,12.2257008 22.559469,12.2697546 23.3114391,11.4744901 C24.0634093,10.6792255 24.0635288,9.44226004 23.3117079,8.69131773 C22.515658,7.94037967 21.2772454,7.94049898 20.5252794,8.69158617 C19.7733093,9.4868507 19.7731898,10.7238162 20.5250107,11.4747585 Z",
    id: "Shape",
    fill: "#FFFFFF",
    "data-testid": "Activity_discount_path"
  }))));
};

Discount.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Donation = function Donation(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_donation_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_donation_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_donation",
    "data-testid": "Activity_donation_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_donation_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20.3,13.5 C21.8347823,13.5 23.2301,14.0813427 24.2911717,15.0291258 C25.5212102,16.1281116 26.3,17.7216076 26.3,19.5001676 C26.3,22.8138882 23.6139632,25.5 20.3,25.5 C18.7172766,25.5 17.282064,24.8824491 16.209929,23.8813595 C15.0372185,22.7863968 14.3,21.2311206 14.3,19.5001676 C14.3,16.1867823 16.986372,13.5 20.3,13.5 Z M20.9395566,14.639548 L19.7719991,14.639548 L19.7719991,15.7715019 C18.4975356,16.0097447 17.7588032,16.832183 17.7588032,17.8920634 C17.7588032,19.0476413 18.628065,19.6434486 19.9029289,20.0722857 C19.9597853,20.0915053 20.0082333,20.1107249 20.0610857,20.1295441 C20.8278459,20.4074273 21.1777928,20.6849102 21.1777928,21.1089424 C21.1777928,21.5734158 20.70092,21.8476954 20.0222472,21.8476954 C19.5061355,21.8476954 19.0240576,21.7355811 18.6104475,21.5806232 C18.4034423,21.5025436 18.2116522,21.4148542 18.0446866,21.3231608 L18.0446866,21.3231608 L17.7608052,22.4302893 L17.6871321,22.7173819 C18.1399811,22.967637 18.9143488,23.1938676 19.7123399,23.2178921 L19.7123399,23.2178921 L19.7123399,24.3614577 L20.8798975,24.3614577 L20.8798975,23.1342068 C22.2624682,22.8959639 23.0008001,22.002253 23,20.9415718 C23,19.9509621 22.5243278,19.3203192 21.3527663,18.8366262 C21.2422567,18.7909797 21.1341495,18.7445323 21.0108273,18.7016886 C19.9982234,18.3325123 19.5810097,18.070245 19.5810097,17.6890565 C19.5810097,17.3555165 19.8312578,17.0103647 20.606026,17.0103647 C21.4632758,17.0103647 22.0234312,17.2842438 22.3213265,17.4271895 L22.3213265,17.4271895 L22.678881,16.0810174 C22.2736793,15.8900227 21.7375477,15.7118411 20.9395566,15.6878166 L20.9395566,15.6878166 L20.9395566,14.639548 Z M15.2985824,8.60442049 C17.4197253,6.4732907 20.8674967,6.46415304 22.999611,8.58408921 C24.4368681,10.0125333 24.9264681,12.0303561 24.3758396,13.9117995 L24.397632,13.8333684 C23.2459424,12.996858 21.8325695,12.5 20.3,12.5 C16.4341006,12.5 13.3,15.6345794 13.3,19.5001956 C13.3,20.7234023 13.6155576,21.8714127 14.1684445,22.8704294 L14.1700807,22.8715576 L12.877806,21.5794674 C12.7397177,21.4414039 12.5983316,21.3000449 12.4542757,21.1560186 L10.4045648,19.1068668 C10.3268819,19.0292111 10.2492381,18.9515952 10.1717119,18.8740978 L9.70859389,18.411162 C9.47836855,18.1810327 9.2506147,17.9533824 9.02745194,17.7303313 L8.58787591,17.2909894 C8.29974357,17.0030205 8.02228528,16.7257406 7.76052528,16.4641752 C5.41583957,14.1199096 5.46543957,10.7035685 7.59778243,8.58408921 C9.72989671,6.4639246 13.1778967,6.4732907 15.2985824,8.60442049 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_donation_path"
  }))));
};

Donation.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Email = function Email(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_email_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_email_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_email",
    "data-testid": "Activity_email_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EFF8FF",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_email_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M22,9 C24.209139,9 26,10.790861 26,13 L26,20 C26,22.209139 24.209139,24 22,24 L10,24 C7.790861,24 6,22.209139 6,20 L6,13 C6,10.790861 7.790861,9 10,9 L22,9 Z M23.9736063,12.2001753 C23.9266735,12.1319094 23.8332865,12.1146155 23.7650207,12.1615483 L23.7650207,12.1615483 L17.1330576,16.7210229 C16.4505536,17.1902444 15.5494464,17.1902444 14.8669424,16.7210229 L14.8669424,16.7210229 L8.23497932,12.1615483 C8.20997457,12.1443575 8.18034403,12.1351546 8.15,12.1351546 C8.06715729,12.1351546 8,12.2023119 8,12.2851546 L8,12.2851546 L8,20 C8,21.1045695 8.8954305,22 10,22 L10,22 L22,22 C23.1045695,22 24,21.1045695 24,20 L24,20 L24,12.2851546 C24,12.2548105 23.9907971,12.22518 23.9736063,12.2001753 Z",
    id: "Combined-Shape",
    fill: "#2899F7",
    "data-testid": "Activity_email_path"
  }))));
};

Email.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Gift = function Gift(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_gift_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_gift_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_gift",
    "data-testid": "Activity_gift_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_gift_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M15,17 L15,25 L9,25 C8.44771525,25 8,24.5522847 8,24 L8,17 L15,17 Z M24,17 L24,24 C24,24.5522847 23.5522847,25 23,25 L17,25 L17,17 L24,17 Z M9.35714286,12 C8.82142857,11.5 8.5,10.8 8.5,10 C8.5,8.3 9.89285714,7 11.7142857,7 C12.7857143,7 14.7142857,7.9 16,9.1 C17.2857143,7.9 19.2142857,7 20.2857143,7 C22.1071429,7 23.5,8.3 23.5,10 C23.5,10.8 23.1785714,11.5 22.6428571,12 L22.6428571,12 L24,12 C24.5522847,12 25,12.4477153 25,13 L25,15 L17,15 L17,13 L15,13 L15,15 L7,15 L7,13 C7,12.4477153 7.44771525,12 8,12 Z M11.9615385,9 C11.3846154,9 11,9.4 11,10 C11,10.6 11.3846154,11 11.9615385,11 C11.9615385,11 14.4615385,10.9 14.75,10.8 C14.2692308,10.2 12.5384615,9 11.9615385,9 Z M20.0384615,9 C19.4615385,9 17.8269231,10.1 17.25,10.8 C17.5384615,10.9 20.0384615,11 20.0384615,11 C20.6153846,11 21,10.6 21,10 C21,9.4 20.6153846,9 20.0384615,9 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_gift_path"
  }))));
};

Gift.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Group = function Group(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_group_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_group_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_group",
    "data-testid": "Activity_group_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_group_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16,15.8571431 C17.9971427,15.8571431 22,16.8600001 22,18.8571431 L22,20.1407651 C22,20.6169002 21.613617,21 21.1369895,21 L10.8630104,21 C10.3856704,21 10,20.6153075 10,20.1407651 L10,18.8571431 C10,16.8600001 14.0028572,15.8571431 16,15.8571431 Z M10,14.5714287 C10.4844523,14.5714287 11.1459335,14.6599431 11.7914783,14.8366968 C10.0359361,15.4988728 8.46142825,16.5538855 8.08507128,17.9999403 L6.57534026,18 C6.25711357,18 6,17.7435383 6,17.4271767 L6,16.5714287 C6,15.2400001 8.66857147,14.5714287 10,14.5714287 Z M22,14.5714287 C23.3314285,14.5714287 26,15.2400001 26,16.5714287 L26,17.4271767 C26,17.7446001 25.7424114,18 25.4246597,18 L23.9149287,17.9999403 C23.5385717,16.5538855 21.9640639,15.4988728 20.208902,14.8365956 C20.8540664,14.6599431 21.5155477,14.5714287 22,14.5714287 Z M16.0000002,10 C17.4228572,10 18.562857,11.1485715 18.562857,12.5714285 C18.562857,13.9942855 17.4228572,15.1428569 16.0000002,15.1428569 C14.5771432,15.1428569 13.4285716,13.9942855 13.4285716,12.5714285 C13.4285716,11.1485715 14.5771432,10 16.0000002,10 Z M10.003339,10 C11.1118532,10 12,10.8933334 12,12 C12,13.1066666 11.1118532,14 10.003339,14 C8.89482488,14 8,13.1066666 8,12 C8,10.8933334 8.89482488,10 10.003339,10 Z M22.003339,10 C23.1118532,10 24,10.8933334 24,12 C24,13.1066666 23.1118532,14 22.003339,14 C20.8948249,14 20,13.1066666 20,12 C20,10.8933334 20.8948249,10 22.003339,10 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_group_path"
  }))));
};

Group.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Import = function Import(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_import_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_import_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_import",
    "data-testid": "Activity_import_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#F9F4FF",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_import_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20.0003882,8.00038816 C22.2095272,8.00038816 24.0003882,9.79124916 24.0003882,12.0003882 L24.0003882,20.0003882 C24.0003882,22.2095272 22.2095272,24.0003882 20.0003882,24.0003882 L12.0003882,24.0003882 C9.79124916,24.0003882 8.00038816,22.2095272 8.00038816,20.0003882 L8,12.242 L10,14.242 L10.0003882,20.0003882 C10.0003882,21.05475 10.8162659,21.9185533 11.8511258,21.9949024 L12.0003882,22.0003882 L20.0003882,22.0003882 C21.05475,22.0003882 21.9185533,21.1845104 21.9949024,20.1496505 L22.0003882,20.0003882 L22.0003882,12.0003882 C22.0003882,10.8958187 21.1049577,10.0003882 20.0003882,10.0003882 L14.241,10 L12.241,8 L20.0003882,8.00038816 Z M8.29328137,8.29328137 C8.68380567,7.90275708 9.31697064,7.90275708 9.70749494,8.29328137 L9.70749494,8.29328137 L17.1310036,15.71679 L17.1361465,13.0580666 C17.1372122,12.5071168 17.5841447,12.061048 18.1350956,12.0610481 C18.6857349,12.0610482 19.1321161,12.5074296 19.1321161,13.0580689 L19.1321161,13.0580689 L19.1321161,18.1321161 C19.1321161,18.6844009 18.6844009,19.1321161 18.1321161,19.1321161 L18.1321161,19.1321161 L13.0580691,19.1321161 L12.9417954,19.1254084 C12.4459384,19.0678154 12.0610483,18.6464033 12.0610484,18.1350954 C12.0610484,17.5841444 12.5071173,17.1372118 13.0580673,17.1361462 L13.0580673,17.1361462 L15.71679,17.1310036 L8.29328137,9.70749494 C7.90275708,9.31697064 7.90275708,8.68380567 8.29328137,8.29328137 Z",
    id: "Combined-Shape",
    fill: "#7A34FF",
    "data-testid": "Activity_import_path"
  }))));
};

Import.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Join = function Join(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_join_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_join_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_join",
    "data-testid": "Activity_join_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_join_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M23,18 C25.209139,18 27,19.790861 27,22 C27,24.209139 25.209139,26 23,26 C20.790861,26 19,24.209139 19,22 C19,19.790861 20.790861,18 23,18 Z M23,19 C22.6203042,19 22.306509,19.2821539 22.2568466,19.6482294 L22.25,19.75 L22.25,21.249 L20.75,21.25 C20.3357864,21.25 20,21.5857864 20,22 C20,22.3796958 20.2821539,22.693491 20.6482294,22.7431534 L20.75,22.75 L22.25,22.749 L22.25,24.25 C22.25,24.6642136 22.5857864,25 23,25 C23.3796958,25 23.693491,24.7178461 23.7431534,24.3517706 L23.75,24.25 L23.75,22.749 L25.25,22.75 C25.6642136,22.75 26,22.4142136 26,22 C26,21.6203042 25.7178461,21.306509 25.3517706,21.2568466 L25.25,21.25 L23.75,21.249 L23.75,19.75 C23.75,19.3357864 23.4142136,19 23,19 Z M16,15.8571431 C17.0904797,15.8571431 18.7789385,16.1561326 20.0872464,16.7527164 C18.5235359,17.6233557 17.3896542,19.1715438 17.0829263,21.0001915 L10.8630104,21 C10.3856704,21 10,20.6153075 10,20.1407651 L10,18.8571431 C10,16.8600001 14.0028572,15.8571431 16,15.8571431 Z M10,14.5714287 C10.4844523,14.5714287 11.1459335,14.6599431 11.7914783,14.8366968 C10.0359361,15.4988728 8.46142825,16.5538855 8.08507128,17.9999403 L6.57534026,18 C6.25711357,18 6,17.7435383 6,17.4271767 L6,16.5714287 C6,15.2400001 8.66857147,14.5714287 10,14.5714287 Z M22,14.5714287 C23.3314285,14.5714287 26,15.2400001 26,16.5714287 L25.9999606,16.8026704 C25.1174494,16.2921742 24.0928452,16 23,16 C22.8146177,16 22.6311991,16.0084074 22.4501046,16.0248617 C21.8134338,15.5431477 21.0309838,15.1467927 20.208902,14.8365956 C20.8540664,14.6599431 21.5155477,14.5714287 22,14.5714287 Z M16.0000002,10 C17.4228572,10 18.562857,11.1485715 18.562857,12.5714285 C18.562857,13.9942855 17.4228572,15.1428569 16.0000002,15.1428569 C14.5771432,15.1428569 13.4285716,13.9942855 13.4285716,12.5714285 C13.4285716,11.1485715 14.5771432,10 16.0000002,10 Z M10.003339,10 C11.1118532,10 12,10.8933334 12,12 C12,13.1066666 11.1118532,14 10.003339,14 C8.89482488,14 8,13.1066666 8,12 C8,10.8933334 8.89482488,10 10.003339,10 Z M22.003339,10 C23.1118532,10 24,10.8933334 24,12 C24,13.1066666 23.1118532,14 22.003339,14 C20.8948249,14 20,13.1066666 20,12 C20,10.8933334 20.8948249,10 22.003339,10 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_join_path"
  }))));
};

Join.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Pass = function Pass(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_pass_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_pass_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_pass",
    "data-testid": "Activity_pass_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_pass_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M21,13 L21,25 C21,25.5522847 20.5522847,26 20,26 L18.5,26 L18.5,26 C18.5,24.6192881 17.3807119,23.5 16,23.5 C14.6192881,23.5 13.5,24.6192881 13.5,26 L12,26 C11.4477153,26 11,25.5522847 11,25 L11,13 L21,13 Z M16,15 L14.9713758,17.0842203 L12.6713022,17.4184405 L14.3356511,19.0407797 L13.9427516,21.3315595 L16,20.25 L18.0572484,21.3315595 L17.6643489,19.0407797 L19.3286978,17.4184405 L17.0286242,17.0842203 L16,15 Z M13.5,6 C13.5,7.38071187 14.6192881,8.5 16,8.5 C17.3807119,8.5 18.5,7.38071187 18.5,6 L20,6 C20.5522847,6 21,6.44771525 21,7 L21,11 L11,11 L11,7 C11,6.44771525 11.4477153,6 12,6 L13.5,6 L13.5,6 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    transform: "translate(16.000000, 16.000000) rotate(-315.000000) translate(-16.000000, -16.000000) ",
    "data-testid": "Activity_pass_path"
  }))));
};

Pass.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var RecurringDonation = function RecurringDonation(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_recurringDonation_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_recurringDonation_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_recurring_donation",
    "data-testid": "Activity_recurringDonation_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_recurringDonation_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20.3,13.5 C21.8347823,13.5 23.2301,14.0813427 24.2911717,15.0291258 C25.5212102,16.1281116 26.3,17.7216076 26.3,19.5001676 C26.3,22.8138882 23.6139632,25.5 20.3,25.5 C18.7172766,25.5 17.282064,24.8824491 16.209929,23.8813595 C15.0372185,22.7863968 14.3,21.2311206 14.3,19.5001676 C14.3,16.1867823 16.986372,13.5 20.3,13.5 Z M16.8562176,17.473979 C16.5028471,18.0703926 16.3,18.7665076 16.3,19.51 C16.3,21.719139 18.090861,23.51 20.3,23.51 L20.3,23.51 L20.3000006,24.3296416 L20.3077281,24.4254099 C20.3534855,24.7059426 20.5969458,24.920056 20.8904149,24.920056 C21.0470025,24.920056 21.1971768,24.8578518 21.3079009,24.7471276 L21.3079009,24.7471276 L22.8825146,23.172514 L22.9508319,23.0907441 C23.1102391,22.8606382 23.0874667,22.5424941 22.8825146,22.337542 L22.8825146,22.337542 L21.3079009,20.7629284 L21.226131,20.694611 C20.9960251,20.5352038 20.6778811,20.5579762 20.4729289,20.7629284 C20.3622047,20.8736525 20.3000006,21.0238267 20.3000006,21.1804144 L20.3000006,21.1804144 L20.3000006,22.01 C18.9192887,22.01 17.8000006,20.8907119 17.8000006,19.51 C17.8000006,19.1861432 17.8615808,18.8766693 17.9736709,18.5926488 L17.9736709,18.5926488 Z M22.999611,8.58408921 C24.3769824,9.95301476 24.8840229,11.8632274 24.439257,13.6759612 L24.396,13.833 L24.1638472,13.6706416 C23.0569629,12.9328185 21.7303982,12.5 20.3,12.5 C16.4341006,12.5 13.3,15.6345794 13.3,19.5001956 C13.3,20.6122017 13.5607914,21.6620621 14.0236001,22.5943317 L14.167,22.868 L12.877806,21.5794674 C12.7397177,21.4414039 12.5983316,21.3000449 12.4542757,21.1560186 L10.4045648,19.1068668 C10.3268819,19.0292111 10.2492381,18.9515952 10.1717119,18.8740978 L8.02733196,16.7307926 C7.9367762,16.6402982 7.84777862,16.5513637 7.76052528,16.4641752 C5.41583957,14.1199096 5.46543957,10.7035685 7.59778243,8.58408921 C9.72989671,6.4639246 13.1778967,6.4732907 15.2985824,8.60442049 C17.4197253,6.4732907 20.8674967,6.46415304 22.999611,8.58408921 Z M19.7095862,14.09 C19.5529986,14.09 19.4028244,14.1522042 19.2921002,14.2629284 L19.2921002,14.2629284 L17.7174866,15.837542 L17.6491692,15.9193119 C17.489762,16.1494178 17.5125344,16.4675619 17.7174866,16.672514 L17.7174866,16.672514 L19.2921002,18.2471276 L19.3738701,18.315445 C19.603976,18.4748522 19.9221201,18.4520798 20.1270722,18.2471276 C20.2377964,18.1364035 20.3000006,17.9862293 20.3000006,17.8296416 L20.3000006,17.8296416 L20.3000006,17.01 C21.6807124,17.01 22.8000006,18.1292881 22.8000006,19.51 C22.8000006,19.8308511 22.739558,20.1375852 22.629438,20.4194369 L22.629438,20.4194369 L23.7479514,21.5389682 C24.0987478,20.9441223 24.3,20.2505636 24.3,19.51 C24.3,17.300861 22.509139,15.51 20.3,15.51 L20.3,15.51 L20.3000006,14.6804144 L20.292273,14.5846461 C20.2465157,14.3041134 20.0030554,14.09 19.7095862,14.09 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_recurringDonation_path"
  }))));
};

RecurringDonation.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Refund = function Refund(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_refund_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_refund_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_refund",
    "data-testid": "Activity_refund_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FF4440",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_refund_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_return",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF",
    "data-testid": "Activity_refund_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M11.8833789,18.9932723 C11.3860402,18.9355072 11,18.5128358 11,18 C11,17.4477153 11.4477153,17 12,17 L12,17 L16,17 C18.209139,17 20,15.209139 20,13 C20,10.8578046 18.3160315,9.10892112 16.1996403,9.00489531 L16,9 L5.421,8.99910678 L8.70680912,12.28 C9.09773029,12.6705243 9.09773029,13.3094757 8.70680912,13.7 C8.31588794,14.0905243 7.68629733,14.0905243 7.29537615,13.7 L2.29319088,8.70264069 C1.90226971,8.3121164 1.90226971,7.67895142 2.29319088,7.28842712 L7.29537615,2.29 C7.68629733,1.89947571 8.31588794,1.89947571 8.70680912,2.29 C9.09773029,2.68052429 9.09773029,3.31947571 8.70680912,3.71 L5.413,6.99910678 L16,7 C19.3137085,7 22,9.6862915 22,13 C22,16.3137085 19.3137085,19 16,19 L12,19 Z",
    id: "Shape",
    "data-testid": "Activity_refund_path"
  })))));
};

Refund.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Remove = function Remove(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_remove_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_remove_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_remove",
    "data-testid": "Activity_remove_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FFEFEE",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_remove_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M23,18 C25.209139,18 27,19.790861 27,22 C27,24.209139 25.209139,26 23,26 C20.790861,26 19,24.209139 19,22 C19,19.790861 20.790861,18 23,18 Z M25.25,21.25 L20.75,21.25 C20.3357864,21.25 20,21.5857864 20,22 C20,22.4142136 20.3357864,22.75 20.75,22.75 L20.75,22.75 L25.25,22.75 C25.6642136,22.75 26,22.4142136 26,22 C26,21.5857864 25.6642136,21.25 25.25,21.25 L25.25,21.25 Z M16,15.8571431 C17.0904797,15.8571431 18.7789385,16.1561326 20.0872464,16.7527164 C18.5235359,17.6233557 17.3896542,19.1715438 17.0829263,21.0001915 L10.8630104,21 C10.3856704,21 10,20.6153075 10,20.1407651 L10,18.8571431 C10,16.8600001 14.0028572,15.8571431 16,15.8571431 Z M10,14.5714287 C10.4844523,14.5714287 11.1459335,14.6599431 11.7914783,14.8366968 C10.0359361,15.4988728 8.46142825,16.5538855 8.08507128,17.9999403 L6.57534026,18 C6.25711357,18 6,17.7435383 6,17.4271767 L6,16.5714287 C6,15.2400001 8.66857147,14.5714287 10,14.5714287 Z M22,14.5714287 C23.3314285,14.5714287 26,15.2400001 26,16.5714287 L25.9999606,16.8026704 C25.1174494,16.2921742 24.0928452,16 23,16 C22.8146177,16 22.6311991,16.0084074 22.4501046,16.0248617 C21.8134338,15.5431477 21.0309838,15.1467927 20.208902,14.8365956 C20.8540664,14.6599431 21.5155477,14.5714287 22,14.5714287 Z M16.0000002,10 C17.4228572,10 18.562857,11.1485715 18.562857,12.5714285 C18.562857,13.9942855 17.4228572,15.1428569 16.0000002,15.1428569 C14.5771432,15.1428569 13.4285716,13.9942855 13.4285716,12.5714285 C13.4285716,11.1485715 14.5771432,10 16.0000002,10 Z M10.003339,10 C11.1118532,10 12,10.8933334 12,12 C12,13.1066666 11.1118532,14 10.003339,14 C8.89482488,14 8,13.1066666 8,12 C8,10.8933334 8.89482488,10 10.003339,10 Z M22.003339,10 C23.1118532,10 24,10.8933334 24,12 C24,13.1066666 23.1118532,14 22.003339,14 C20.8948249,14 20,13.1066666 20,12 C20,10.8933334 20.8948249,10 22.003339,10 Z",
    id: "Combined-Shape",
    fill: "#FF4440",
    "data-testid": "Activity_remove_path"
  }))));
};

Remove.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Renewal = function Renewal(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_renewal_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_renewal_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_renewal",
    "data-testid": "Activity_renewal_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_renewal_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M8.37981954,11.2089614 L9.84109435,12.6703297 C9.30462875,13.660542 9,14.7946961 9,16 C9,19.8656591 12.1334649,22.9994582 15.9989974,22.9999999 L15.9999992,20.9046807 C15.9999992,20.6099957 16.1170624,20.3273803 16.3254361,20.1190065 C16.759352,19.6850907 17.4628686,19.6850907 17.8967845,20.1190065 L17.8967845,20.1190065 L20.7698803,22.9921023 C21.2037962,23.4260182 21.2037962,24.1295348 20.7698803,24.5634507 L20.7698803,24.5634507 L17.8967845,27.4365465 C17.6884108,27.6449202 17.4057953,27.7619834 17.1111103,27.7619834 C16.4974606,27.7619834 15.9999992,27.264522 15.9999992,26.6508723 L15.9999992,26.6508723 L15.999,24.999015 L15.7346377,24.9961629 C10.8868137,24.8557914 7,20.8818027 7,16 C7,14.2391016 7.50571039,12.5963182 8.37981954,11.2089614 Z M14.8888881,4.238015 C15.5025378,4.238015 15.9999992,4.73547639 15.9999992,5.34912611 L15.9999992,5.34912611 L15.998999,7.00000005 C15.9993326,7.00000002 15.9996663,7 16,7 C20.9705627,7 25,11.0294373 25,16 C25,17.7608984 24.4942896,19.4036818 23.6201805,20.7910386 L22.1589056,19.3296703 C22.6953712,18.339458 23,17.2053039 23,16 C23,12.1340068 19.8659932,9 16,9 L15.999,8.999015 L15.9999992,11.0953177 C15.9999992,11.3479048 15.9139936,11.5916245 15.7581998,11.7873247 L15.6745623,11.8809919 C15.2406464,12.3149077 14.5371298,12.3149077 14.1032139,11.8809919 L14.1032139,11.8809919 L11.2301181,9.00789609 C10.7962022,8.57398021 10.7962022,7.87046357 11.2301181,7.43654769 L11.2301181,7.43654769 L14.1032139,4.56345191 C14.3115876,4.35507816 14.5942031,4.238015 14.8888881,4.238015 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_renewal_path"
  }))));
};

Renewal.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Reverse = function Reverse(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_reverse_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_reverse_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_reverse",
    "data-testid": "Activity_reverse_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FFFAF1",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_reverse_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6.89734645,8.46869518 C7.30026834,8.06577329 7.93565211,8.03699316 8.37178283,8.38235478 L8.46869485,8.46869518 L9.63603954,9.63603874 L9.63603954,9.63603874 C13.1507582,6.12132011 18.849243,6.12132011 22.3639616,9.63603874 C25.8786802,13.1507574 25.8786802,18.8492422 22.3639616,22.3639608 C18.849243,25.8786794 13.1507582,25.8786794 9.63603954,22.3639608 C8.39089633,21.1188176 7.58686428,19.599603 7.22394339,18.0005051 L9.29056415,18.0005712 C9.61141153,19.0800955 10.1979745,20.0974686 11.0502531,20.9497472 C13.7839231,23.6834173 18.216078,23.6834173 20.949748,20.9497472 C23.6834181,18.2160772 23.6834181,13.7839223 20.949748,11.0502523 C18.2782069,8.37871112 13.9845074,8.31799427 11.2392318,10.8681018 L11.0488495,11.0502629 L12.5318659,12.5318662 C12.7104719,12.7104723 12.8219927,12.9436233 12.8502107,13.192167 L12.8573028,13.3175404 C12.8573028,13.8902801 12.4239586,14.3618069 11.8672595,14.4221317 L11.7461917,14.4286515 L7.68302065,14.4286515 C7.11028091,14.4286515 6.63875411,13.9953074 6.57842939,13.4386082 L6.57190954,13.3175404 L6.57190954,9.25436938 C6.57190954,8.95968439 6.68897269,8.67706893 6.89734645,8.46869518 Z",
    id: "Path",
    fill: "#FCAF2F",
    "data-testid": "Activity_reverse_path"
  }))));
};

Reverse.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Signup = function Signup(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_signup_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_signup_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_signup",
    "data-testid": "Activity_signup_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#F9F4FF",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_signup_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M15.6633692,21.8874086 L10.8548345,24.9031997 C10.5605608,25.0877607 10.1712916,25.0005574 9.98537735,24.7084256 C9.89290311,24.5631185 9.86471563,24.3864452 9.90743227,24.2198819 L11.3107313,18.7480505 C11.3707383,18.5140676 11.2897708,18.2666892 11.102684,18.1124076 L6.72754714,14.5044376 C6.45979662,14.2836363 6.42304917,13.8891667 6.64546942,13.6233651 C6.75610185,13.4911546 6.91664975,13.4099468 7.0894226,13.3988062 L12.7652438,13.0328195 C13.0079496,13.0171694 13.2199251,12.8642812 13.3099186,12.6399705 L15.4144699,7.39433136 C15.5432647,7.07330766 15.9098228,6.91671534 16.2332003,7.04457263 C16.3940491,7.10816918 16.5214607,7.23465331 16.5855235,7.39433136 L18.6900749,12.6399705 C18.7800684,12.8642812 18.9920439,13.0171694 19.2347497,13.0328195 L24.9105708,13.3988062 C25.2579209,13.4212039 25.5212137,13.7188941 25.4986518,14.0637159 C25.4874294,14.2352311 25.4056261,14.3946104 25.2724463,14.5044376 L20.8973094,18.1124076 C20.7102226,18.2666892 20.6292552,18.5140676 20.6892622,18.7480505 L22.0925612,24.2198819 C22.1784406,24.5547481 21.9746064,24.8953231 21.6372848,24.9805774 C21.4695002,25.0229831 21.2915315,24.9950008 21.1451589,24.9031997 L16.3366242,21.8874086 C16.1310048,21.7584492 15.8689887,21.7584492 15.6633692,21.8874086 Z",
    id: "Star",
    fill: "#7A34FF",
    "data-testid": "Activity_signup_path"
  }))));
};

Signup.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Stop = function Stop(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_stop_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_stop_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_stop",
    "data-testid": "Activity_stop_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FFEFEE",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_stop_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.1428589,6 C19.6947442,6 20.4570799,6.31494423 20.8487309,6.70659531 L25.2934047,11.1512691 C25.6836465,11.5415109 26,12.3032628 26,12.8571411 L26,19.1428589 C26,19.6947442 25.6850558,20.4570799 25.2934047,20.8487309 L20.8487309,25.2934047 C20.4584891,25.6836465 19.6967372,26 19.1428589,26 L12.8571411,26 C12.3052558,26 11.5429201,25.6850558 11.1512691,25.2934047 L6.70659531,20.8487309 C6.3163535,20.4584891 6,19.6967372 6,19.1428589 L6,12.8571411 C6,12.3052558 6.31494423,11.5429201 6.70659531,11.1512691 L11.1512691,6.70659531 C11.5415109,6.3163535 12.3032628,6 12.8571411,6 L19.1428589,6 Z M18.8155751,8 L13.1844249,8 C12.9464586,8 12.6345975,8.11586146 12.4278459,8.27146961 L12.334058,8.35223353 L8.35223353,12.334058 C8.18396591,12.5023256 8.04537325,12.8047711 8.00920938,13.0609981 L8,13.1844249 L8,18.8155751 C8,19.0535414 8.11586146,19.3654025 8.27146961,19.5721541 L8.35223353,19.665942 L12.334058,23.6477665 C12.5023256,23.8160341 12.8047711,23.9546268 13.0609981,23.9907906 L13.1844249,24 L18.8155751,24 C19.0535414,24 19.3654025,23.8841385 19.5721541,23.7285304 L19.665942,23.6477665 L23.6477665,19.665942 C23.8160341,19.4976744 23.9546268,19.1952289 23.9907906,18.9390019 L24,18.8155751 L24,13.1844249 C24,12.9464586 23.8841385,12.6345975 23.7285304,12.4278459 L23.6477665,12.334058 L19.665942,8.35223353 C19.4696298,8.1559213 19.0906866,8 18.8155751,8 Z M15.9414606,10.3741525 C16.1936445,10.549165 16.2440813,10.8491864 16.2440813,10.8491864 L16.2488475,10.9018752 C16.2674817,11.1077122 16.3381439,11.8867954 16.414341,12.7079483 L16.4526856,13.1195715 C16.5230403,13.8716243 16.5915347,14.5846382 16.6223572,14.8494719 C16.6475756,15.2244986 16.6980124,15.3495076 16.7484492,15.3495076 C16.9501963,15.3495076 17.0006331,14.9744808 17.0006331,14.9744808 L17.4041274,11.9242631 C17.4041274,11.8492578 17.4293458,11.4492292 17.6815297,11.2242132 C17.8076216,11.0992042 17.958932,11.0742025 18.1606791,11.0742025 C18.3876447,11.0992042 18.538955,11.1742096 18.665047,11.3242203 C18.8163573,11.5242346 18.7659205,11.7742524 18.7659205,11.824256 L18.3624263,16.1745664 C18.3624263,16.3495789 18.3876447,16.8496146 18.6398286,16.8996182 C18.9676677,16.9496217 19.1441964,16.6996039 19.1441964,16.6746021 L20.1781505,15.1994968 C20.3546793,14.9994826 20.7833919,14.6744594 21.2121046,14.9994826 C21.6155989,15.2745022 21.5147253,15.8245415 21.3886333,16.0495575 L19.0181045,20.4248698 C18.9928861,20.4498715 18.085024,22.25 16.2440813,22.25 C16.0675526,22.25 15.512748,22.2249982 15.3362192,22.1999964 C13.2178743,21.7999679 12.6630696,19.8748305 12.6630696,19.8498287 L11.0995293,15.0244844 C11.0743109,14.949479 10.948219,14.6744594 11.0238741,14.3994398 C11.0743109,14.249429 11.2004029,14.1244201 11.3769316,14.024413 C11.5786788,13.9244059 11.7804259,13.9244059 11.9317363,13.9994112 C12.1839202,14.0994183 12.2595754,14.3494362 12.2595754,14.3494362 C12.6126328,15.3495076 13.0665639,16.1995682 13.2178743,16.22457 C13.2430927,16.22457 13.2935294,16.1995682 13.2935294,16.1495646 C13.3691846,15.9995539 13.2935294,15.7495361 13.268311,15.649529 L12.5369777,12.5993113 C12.5369777,12.5743095 12.2091386,11.5992399 12.8395984,11.3742239 C13.0161271,11.2992185 13.1926559,11.3242203 13.3439662,11.3992256 C13.5961501,11.5242346 13.6718053,11.7992542 13.6970237,11.7992542 L14.6553226,15.0244844 C14.7057594,15.1744951 14.7814146,15.52452 14.9327249,15.4995183 C14.9831617,15.4995183 15.0083801,15.4745165 15.0083801,15.4495147 C15.0840353,15.3495076 15.0335985,15.0994897 15.0335985,15.0994897 L14.7309778,11.3242203 C14.680541,10.9991971 14.7309778,10.3991543 15.3362192,10.2741454 C15.5631847,10.2241418 15.7649319,10.2491436 15.9414606,10.3741525 Z",
    id: "Shape",
    fill: "#FF4440",
    "data-testid": "Activity_stop_path"
  }))));
};

Stop.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Subscription = function Subscription(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_subscription_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_subscription_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_subscription",
    "data-testid": "Activity_subscription_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_subscription_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M15.443507,10.5634245 L16.2951354,10.7110233 C16.7209495,10.784918 17.1467637,10.8581541 17.572578,10.9271239 C17.9447892,13.3338794 19.7480207,15.2671823 22.0859062,15.8316886 C22.3350395,16.6525514 23.097749,17.25 24,17.25 C25.0330407,17.25 25.8831519,16.4667856 25.9877609,15.4615584 C25.9897831,15.4606358 25.9918048,15.4597121 25.9938258,15.4587873 L25.9931051,21.8291185 C25.9931051,22.1540502 25.8051049,22.4140081 25.5544381,22.4790449 C19.2869791,24.3637242 13.0195201,20.3993814 6.75212174,22.0890765 C6.40498863,22.1490522 6.05785552,21.9321631 6.00650447,21.5406659 L6,21.4392132 L6,11.1058695 C6,10.8459115 6.18800013,10.5859536 6.50139429,10.5209799 C9.4821079,9.62462345 12.4628078,10.0512374 15.443507,10.5634245 Z M16.0278859,13.2505067 C14.7744305,13.2505067 13.7716419,14.6803068 13.7716419,16.5000124 C13.7716419,18.3197179 14.7744305,19.7494551 16.0278859,19.7494551 C17.2814019,19.7494551 18.2841905,18.3197179 18.2841905,16.5000124 C18.2841905,14.6803068 17.2814019,13.2505067 16.0278859,13.2505067 Z M20.0562176,7.96397897 L21.1736709,9.08264876 C21.0615808,9.3666693 21.0000006,9.67614323 21.0000006,10 C21.0000006,11.3807119 22.1192887,12.5 23.5000006,12.5 L23.5000006,11.6704144 C23.5000006,11.5138267 23.5622047,11.3636525 23.6729289,11.2529284 C23.8778811,11.0479762 24.1960251,11.0252038 24.426131,11.184611 L24.5079009,11.2529284 L26.0825146,12.827542 C26.2874667,13.0324941 26.3102391,13.3506382 26.1508319,13.5807441 L26.0825146,13.662514 L24.5079009,15.2371276 C24.3971768,15.3478518 24.2470025,15.410056 24.0904149,15.410056 C23.7969458,15.410056 23.5534855,15.1959426 23.5077281,14.9154099 L23.5000006,14.8196416 L23.5,14 C21.290861,14 19.5,12.209139 19.5,10 C19.5,9.25650758 19.7028471,8.56039264 20.0562176,7.96397897 Z M22.9095862,4.58 C23.2030554,4.58 23.4465157,4.79411339 23.492273,5.07464609 L23.5000006,5.17041437 L23.5,6 C25.709139,6 27.5,7.790861 27.5,10 C27.5,10.7405636 27.2987478,11.4341223 26.9479514,12.0289682 L25.829438,10.9094369 C25.939558,10.6275852 26.0000006,10.3208511 26.0000006,10 C26.0000006,8.61928813 24.8807124,7.5 23.5000006,7.5 L23.5000006,8.31964163 C23.5000006,8.47622925 23.4377964,8.62640346 23.3270722,8.73712763 C23.1221201,8.94207976 22.803976,8.96485222 22.5738701,8.80544501 L22.4921002,8.73712763 L20.9174866,7.162514 C20.7125344,6.95756186 20.689762,6.63941779 20.8491692,6.40931189 L20.9174866,6.32754199 L22.4921002,4.75292836 C22.6028244,4.64220419 22.7529986,4.58 22.9095862,4.58 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_subscription_path"
  }))));
};

Subscription.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Switch = function Switch(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_switch_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_switch_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_switch",
    "data-testid": "Activity_switch_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#FFFAF1",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_switch_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M24.3955431,13.0499852 C23.899536,13.3363551 23.2745097,13.1968314 22.9439174,12.7448782 L22.8777371,12.6432903 L21.9335681,11.0073055 L12.489561,16.4598055 C12.0112684,16.7359479 11.399678,16.5720728 11.1235356,16.0937801 C10.8473933,15.6154875 11.0112684,15.0038971 11.489561,14.7277547 L20.9335681,9.27525473 L20.0046413,7.66694244 C19.8783478,7.44819556 19.8309709,7.1941253 19.8680423,6.94674709 L19.8936409,6.82381017 C20.0411205,6.27340863 20.5769889,5.93079242 21.12737,6.01181899 L21.2544685,6.03813596 L25.1791903,7.08976201 C25.7295919,7.23724165 26.0722081,7.77311007 25.9911815,8.32349117 L25.9648645,8.45058964 L24.9132385,12.3753115 C24.8369684,12.6599553 24.6507478,12.9026427 24.3955431,13.0499852 Z M10.8756305,25.9882928 L10.748532,25.9619759 L6.82381017,24.9103498 C6.27340863,24.7628702 5.93079242,24.2270018 6.01181899,23.6766207 L6.03813596,23.5495222 L7.08976201,19.6248004 C7.16603209,19.3401565 7.35225268,19.0974691 7.60745737,18.9501266 C8.10346453,18.6637568 8.72849079,18.8032804 9.05908312,19.2552337 L9.12526337,19.3568215 L10.0694324,20.9928063 L19.5134395,15.5403063 C19.9917321,15.2641639 20.6033225,15.4280391 20.8794649,15.9063317 C21.1556072,16.3846243 20.9917321,16.9962147 20.5134395,17.2723571 L11.0694324,22.7248571 L11.9983591,24.3331694 C12.1246527,24.5519163 12.1720296,24.8059865 12.1349582,25.0533647 L12.1093596,25.1763017 C11.96188,25.7267032 11.4260116,26.0693194 10.8756305,25.9882928 Z",
    id: "Shape",
    fill: "#FCAF2F",
    "data-testid": "Activity_switch_path"
  }))));
};

Switch.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Trial = function Trial(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Activity_trial_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Activity_trial_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_activity_trial",
    "data-testid": "Activity_trial_g"
  }, /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "bounds",
    fill: "#EBFAF2",
    points: "-5.55555592e-07 -5.55555557e-07 31.9999994 -5.55555557e-07 31.9999994 31.9999994 -5.55555592e-07 31.9999994",
    "data-testid": "Activity_trial_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20,11 C20.5522847,11 21,11.4477153 21,12 C21,12.5522847 20.5522847,13 20,13 L19,13 L19,15.9830475 C19,17.1887444 19.5438506,18.3301173 20.4802502,19.0896309 L24.6191694,22.4467083 C25.4770287,23.142518 25.6083959,24.4020156 24.9125862,25.2598749 C24.5328293,25.7280747 23.9621429,26 23.3592944,26 L8.64070555,26 C7.53613605,26 6.64070555,25.1045695 6.64070555,24 C6.64070555,23.3971515 6.91263087,22.8264651 7.38083063,22.4467083 L11.5197498,19.0896309 C12.4561494,18.3301173 13,17.1887444 13,15.9830475 L13,13 L12,13 C11.4477153,13 11,12.5522847 11,12 C11,11.4477153 11.4477153,11 12,11 L20,11 Z M17,13 L15,13 L14.999157,17.938337 C14.9990573,18.5220675 14.743941,19.076622 14.3007398,19.4565088 L14.3007398,19.4565088 L12.499,21 L19.5,21 L17.6975327,19.4547755 C17.2541753,19.0747338 16.9990574,18.5199064 16.9991571,17.9359565 L16.9991571,17.9359565 L17,13 Z M18,8 C18.5522847,8 19,8.44771525 19,9 C19,9.55228475 18.5522847,10 18,10 C17.4477153,10 17,9.55228475 17,9 C17,8.44771525 17.4477153,8 18,8 Z M14.5,6 C15.3284271,6 16,6.67157288 16,7.5 C16,8.32842712 15.3284271,9 14.5,9 C13.6715729,9 13,8.32842712 13,7.5 C13,6.67157288 13.6715729,6 14.5,6 Z M17.5,5 C17.7761424,5 18,5.22385763 18,5.5 C18,5.77614237 17.7761424,6 17.5,6 C17.2238576,6 17,5.77614237 17,5.5 C17,5.22385763 17.2238576,5 17.5,5 Z",
    id: "Combined-Shape",
    fill: "#28BF6F",
    "data-testid": "Activity_trial_path"
  }))));
};

Trial.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Activity = {
  Abandonment: Abandonment,
  Access: Access,
  Add: Add,
  Cancel: Cancel,
  Discount: Discount,
  Donation: Donation,
  Email: Email,
  Gift: Gift,
  Group: Group,
  Import: Import,
  Join: Join,
  Pass: Pass,
  RecurringDonation: RecurringDonation,
  Refund: Refund,
  Remove: Remove,
  Renewal: Renewal,
  Reverse: Reverse,
  Signup: Signup,
  Stop: Stop,
  Subscription: Subscription,
  Switch: Switch,
  Trial: Trial
};

var Amex = function Amex(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '42px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Payment_amex_svg"
  }, /*#__PURE__*/React__default['default'].createElement("defs", {
    "data-testid": "Payment_amex_defs"
  }, /*#__PURE__*/React__default['default'].createElement("radialGradient", {
    cx: "17.5409177%",
    cy: "17.466056%",
    fx: "17.5409177%",
    fy: "17.466056%",
    r: "93.2873442%",
    gradientTransform: "translate(0.175409,0.174661),scale(1.000000,0.998787),translate(-0.175409,-0.174661)",
    id: "radialGradient-1",
    "data-testid": "Payment_amex_radialGradient"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#9DD5F6",
    offset: "0%",
    "data-testid": "Payment_amex_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#98D3F5",
    offset: "7.11%",
    "data-testid": "Payment_amex_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#89CEF3",
    offset: "15.75%",
    "data-testid": "Payment_amex_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#70C6EF",
    offset: "25.16%",
    "data-testid": "Payment_amex_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#4EBBEA",
    offset: "35.14%",
    "data-testid": "Payment_amex_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#23ADE3",
    offset: "45.46%",
    "data-testid": "Payment_amex_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#0DA6E0",
    offset: "50%",
    "data-testid": "Payment_amex_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#2E77BC",
    offset: "100%",
    "data-testid": "Payment_amex_stop"
  }))), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Payment_amex_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_payment/amex",
    "data-testid": "Payment_amex_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M32.7965474,0.0505352113 L9.05381053,0.0505352113 L9.05381053,23.9631549 L32.7965474,23.9631549 L32.7965474,16.0713803 C32.8908632,15.9345634 32.9374316,15.7595493 32.9374316,15.5455775 C32.9374316,15.3006761 32.8908632,15.1489859 32.7965474,15.0212113",
    id: "Shape",
    fill: "url(#radialGradient-1)",
    "data-testid": "Payment_amex_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M11.1939368,10.3979155 L10.7371789,9.28098592 L10.2830316,10.3979155 L11.1939368,10.3979155 Z M21.2562526,9.95315493 C21.1645474,10.0090141 21.0560842,10.0108732 20.9261474,10.0108732 L20.1154526,10.0108732 L20.1154526,9.38856338 L20.9371789,9.38856338 C21.0534737,9.38856338 21.1748211,9.39380282 21.2536421,9.43909859 C21.3402105,9.47991549 21.3937684,9.56678873 21.3937684,9.68678873 C21.3937684,9.80923944 21.3428211,9.90777465 21.2562526,9.95315493 L21.2562526,9.95315493 Z M27.0396632,10.3979155 L26.5778526,9.28098592 L26.1185684,10.3979155 L27.0396632,10.3979155 L27.0396632,10.3979155 Z M16.2590316,11.6068732 L15.5749053,11.6068732 L15.5723789,9.41256338 L14.6047158,11.6068732 L14.0187789,11.6068732 L13.0485895,9.41061972 L13.0485895,11.6068732 L11.6912842,11.6068732 L11.4348632,10.9819437 L10.0453895,10.9819437 L9.78635789,11.6068732 L9.06155789,11.6068732 L10.2565895,8.80512676 L11.2480842,8.80512676 L12.3830737,11.4578028 L12.3830737,8.80512676 L13.4722526,8.80512676 L14.3456,10.7057746 L15.1478737,8.80512676 L16.2589474,8.80512676 L16.2589474,11.6068732 L16.2590316,11.6068732 Z M18.9856842,11.6068732 L16.7563789,11.6068732 L16.7563789,8.80512676 L18.9856842,8.80512676 L18.9856842,9.38856338 L17.4237474,9.38856338 L17.4237474,9.89357746 L18.9482105,9.89357746 L18.9482105,10.4678873 L17.4237474,10.4678873 L17.4237474,11.0274085 L18.9856842,11.0274085 L18.9856842,11.6068732 L18.9856842,11.6068732 Z M22.1289263,9.55969014 C22.1289263,10.0063944 21.8318316,10.2371831 21.6586947,10.3064789 C21.8047158,10.3622535 21.9294316,10.4607887 21.9888,10.5424225 C22.0830316,10.6817746 22.0992842,10.8062535 22.0992842,11.0564789 L22.0992842,11.6068732 L21.4261895,11.6068732 L21.4236632,11.2535493 C21.4236632,11.0849577 21.4397474,10.842507 21.3183158,10.7077183 C21.2208,10.6091831 21.0721684,10.5878028 20.8319158,10.5878028 L20.1155368,10.5878028 L20.1155368,11.6068732 L19.4482526,11.6068732 L19.4482526,8.80512676 L20.9831579,8.80512676 C21.3242105,8.80512676 21.5754947,8.81416901 21.7912421,8.93932394 C22.0023579,9.06447887 22.1289263,9.2471831 22.1289263,9.55969014 L22.1289263,9.55969014 Z M23.1968842,11.6068732 L22.5159579,11.6068732 L22.5159579,8.80512676 L23.1968842,8.80512676 L23.1968842,11.6068732 L23.1968842,11.6068732 Z M31.0965053,11.6068732 L30.1508211,11.6068732 L28.8858947,9.504 L28.8858947,11.6068732 L27.5268211,11.6068732 L27.2671158,10.9819437 L25.8808421,10.9819437 L25.6288842,11.6068732 L24.848,11.6068732 C24.5236211,11.6068732 24.1129263,11.5348732 23.8803368,11.2969859 C23.6458105,11.0590986 23.5237895,10.7368732 23.5237895,10.2273803 C23.5237895,9.81185915 23.5967158,9.432 23.8835368,9.13183099 C24.0992842,8.90822535 24.4371368,8.80512676 24.8970105,8.80512676 L25.5430737,8.80512676 L25.5430737,9.40546479 L24.9105684,9.40546479 C24.6670316,9.40546479 24.5295158,9.44180282 24.3970526,9.57143662 C24.2832842,9.68940845 24.2052211,9.91242254 24.2052211,10.2060845 C24.2052211,10.5062535 24.2646737,10.7226761 24.3887158,10.8640563 C24.4914526,10.9749296 24.6781474,11.0085634 24.8538105,11.0085634 L25.1535158,11.0085634 L26.0940632,8.80521127 L27.0939789,8.80521127 L28.2238316,11.4552676 L28.2238316,8.80521127 L29.2399158,8.80521127 L30.4129684,10.7564789 L30.4129684,8.80521127 L31.0965053,8.80521127 L31.0965053,11.6068732 L31.0965053,11.6068732 Z M9.05381053,12.1571831 L10.1940211,12.1571831 L10.4511158,11.5348732 L11.0266947,11.5348732 L11.2831158,12.1571831 L13.5265684,12.1571831 L13.5265684,11.6814085 L13.7268211,12.1592113 L14.8914526,12.1592113 L15.0917053,11.6743099 L15.0917053,12.1571831 L20.6671158,12.1571831 L20.6645053,11.135662 L20.7723789,11.135662 C20.8479158,11.1382817 20.8699789,11.1452958 20.8699789,11.2704507 L20.8699789,12.1571831 L23.7536,12.1571831 L23.7536,11.9193803 C23.9861895,12.0444507 24.3479579,12.1571831 24.824,12.1571831 L26.0371368,12.1571831 L26.2967579,11.5348732 L26.8723368,11.5348732 L27.1262316,12.1571831 L29.464,12.1571831 L29.464,11.5660563 L29.8180211,12.1571831 L31.6913684,12.1571831 L31.6913684,8.24957746 L29.8373895,8.24957746 L29.8373895,8.71107042 L29.5777684,8.24957746 L27.6753684,8.24957746 L27.6753684,8.71107042 L27.4369684,8.24957746 L24.8672842,8.24957746 C24.4371368,8.24957746 24.0590316,8.30983099 23.7536,8.47774648 L23.7536,8.24957746 L21.9802947,8.24957746 L21.9802947,8.47774648 C21.7859368,8.30467606 21.5210947,8.24957746 21.2266105,8.24957746 L14.7480421,8.24957746 L14.3133474,9.25884507 L13.8669474,8.24957746 L11.8263579,8.24957746 L11.8263579,8.71107042 L11.6021895,8.24957746 L9.86189474,8.24957746 L9.05372632,10.1074648 L9.05372632,12.1571831 L9.05381053,12.1571831 Z",
    id: "Shape",
    fill: "#FFFFFF",
    "data-testid": "Payment_amex_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M32.7965474,14.2238028 L31.5802947,14.2238028 C31.4588632,14.2238028 31.3781895,14.2283662 31.3102316,14.2744225 C31.2398316,14.3198028 31.2127158,14.3871549 31.2127158,14.4760563 C31.2127158,14.5817746 31.2721684,14.6536901 31.3586526,14.6847887 C31.4290526,14.7093803 31.5046737,14.7165634 31.6158316,14.7165634 L31.9775158,14.7262817 C32.3424842,14.7353239 32.5861053,14.7982817 32.7346526,14.951831 C32.7616842,14.9732113 32.7779368,14.9972113 32.7965474,15.0212113 L32.7965474,14.2238028 Z M32.7965474,16.0713803 C32.6344421,16.3092676 32.3185684,16.4298592 31.8909474,16.4298592 L30.6021895,16.4298592 L30.6021895,15.8289296 L31.8857263,15.8289296 C32.0130526,15.8289296 32.1021474,15.8121127 32.1557895,15.7595493 C32.2022737,15.7161972 32.2346947,15.6532394 32.2346947,15.5767606 C32.2346947,15.4951268 32.2022737,15.4303099 32.1531789,15.3914366 C32.1047579,15.3486761 32.0342737,15.3292394 31.9180632,15.3292394 C31.2914526,15.3078592 30.5097263,15.3486761 30.5097263,14.4618592 C30.5097263,14.0553803 30.7669053,13.6275211 31.4672,13.6275211 L32.7964632,13.6275211 L32.7964632,13.0699437 L31.5614316,13.0699437 C31.1887158,13.0699437 30.9179789,13.1595211 30.7262316,13.2987887 L30.7262316,13.0699437 L28.8994526,13.0699437 C28.6073263,13.0699437 28.2644211,13.1426197 28.1022316,13.2987887 L28.1022316,13.0699437 L24.8400842,13.0699437 L24.8400842,13.2987887 C24.5804632,13.1108451 24.1424,13.0699437 23.9402105,13.0699437 L21.7884632,13.0699437 L21.7884632,13.2987887 C21.5830737,13.0991831 21.1263158,13.0699437 20.8479158,13.0699437 L18.4397474,13.0699437 L17.8886737,13.6684225 L17.3725474,13.0699437 L13.7752421,13.0699437 L13.7752421,16.9802535 L17.3048421,16.9802535 L17.8726737,16.3723099 L18.4075789,16.9802535 L20.5832421,16.9821972 L20.5832421,16.062338 L20.7971368,16.062338 C21.0858105,16.0668169 21.4262737,16.0551549 21.7266526,15.9248451 L21.7266526,16.980169 L23.5211789,16.980169 L23.5211789,15.9610141 L23.6077474,15.9610141 C23.7182316,15.9610141 23.7290947,15.9655775 23.7290947,16.0763662 L23.7290947,16.9800845 L29.1805474,16.9800845 C29.5266526,16.9800845 29.8884211,16.8911831 30.0887579,16.7298592 L30.0887579,16.9800845 L31.8179368,16.9800845 C32.1777684,16.9800845 32.5291789,16.9294648 32.7965474,16.799831 L32.7965474,16.0713803 L32.7965474,16.0713803 Z M30.1345684,14.951831 C30.2645053,15.0867887 30.3341474,15.2571549 30.3341474,15.5455775 C30.3341474,16.1484507 29.9588211,16.4298592 29.2858105,16.4298592 L27.9860211,16.4298592 L27.9860211,15.8289296 L29.2805895,15.8289296 C29.4071579,15.8289296 29.4969263,15.8121127 29.5531789,15.7595493 C29.5990737,15.7161972 29.632,15.6532394 29.632,15.5767606 C29.632,15.4951268 29.5963789,15.4303099 29.5505684,15.3914366 C29.4995368,15.3486761 29.4291368,15.3292394 29.3129263,15.3292394 C28.6888421,15.3078592 27.9072842,15.3486761 27.9072842,14.4618592 C27.9072842,14.0553803 28.1617684,13.6275211 28.8613895,13.6275211 L30.1992421,13.6275211 L30.1992421,14.2239718 L28.9750737,14.2239718 C28.8537263,14.2239718 28.7748211,14.2285352 28.7077053,14.2745915 C28.6346105,14.3199718 28.6074947,14.3873239 28.6074947,14.4762254 C28.6074947,14.5819437 28.6695579,14.6538592 28.7535158,14.6849577 C28.8239158,14.7095493 28.8995368,14.7167324 29.0132211,14.7167324 L29.3724632,14.7264507 C29.7347368,14.7353239 29.9834105,14.7981972 30.1345684,14.951831 L30.1345684,14.951831 Z M24.1128421,14.7787606 C24.0235789,14.8319155 23.9131789,14.8364789 23.7833263,14.8364789 L22.9726316,14.8364789 L22.9726316,14.2070704 L23.7943579,14.2070704 C23.9131789,14.2070704 24.0320842,14.2096056 24.1128421,14.2576901 C24.1993263,14.3030704 24.2510316,14.3898592 24.2510316,14.5097746 C24.2510316,14.6296901 24.1993263,14.7262817 24.1128421,14.7787606 L24.1128421,14.7787606 Z M24.5158737,15.1275211 C24.6644211,15.1825352 24.7858526,15.2811549 24.8427789,15.3627887 C24.9370105,15.4996056 24.9506526,15.6272958 24.9533474,15.8743099 L24.9533474,16.4298592 L24.2833684,16.4298592 L24.2833684,16.0792394 C24.2833684,15.9106479 24.2995368,15.6610141 24.1754947,15.5307042 C24.0779789,15.4303099 23.9293474,15.4063099 23.6858947,15.4063099 L22.9727158,15.4063099 L22.9727158,16.4298592 L22.3021474,16.4298592 L22.3021474,13.6274366 L23.8428632,13.6274366 C24.1807158,13.6274366 24.4267789,13.6423944 24.6458105,13.7596901 C24.8564211,13.8873803 24.9888842,14.0623099 24.9888842,14.382 C24.9888,14.8292958 24.6915368,15.0575493 24.5158737,15.1275211 L24.5158737,15.1275211 Z M25.3589053,13.6274366 L27.5861895,13.6274366 L27.5861895,14.2069859 L26.0234947,14.2069859 L26.0234947,14.7164789 L27.5480421,14.7164789 L27.5480421,15.2882535 L26.0234947,15.2882535 L26.0234947,15.845831 L27.5861895,15.8483662 L27.5861895,16.4298592 L25.3589053,16.4298592 L25.3589053,13.6274366 L25.3589053,13.6274366 Z M20.8564211,14.9207324 L19.9940211,14.9207324 L19.9940211,14.2070704 L20.8641684,14.2070704 C21.1050947,14.2070704 21.2723368,14.3056056 21.2723368,14.5506761 C21.2723368,14.7930423 21.1128421,14.9207324 20.8564211,14.9207324 L20.8564211,14.9207324 Z M19.3293474,16.1749859 L18.3047579,15.0334648 L19.3293474,13.9281972 L19.3293474,16.1749859 L19.3293474,16.1749859 Z M16.6833684,15.845831 L15.0426105,15.845831 L15.0426105,15.2882535 L16.5077053,15.2882535 L16.5077053,14.7164789 L15.0426105,14.7164789 L15.0426105,14.2069859 L16.7157053,14.2069859 L17.4456421,15.023662 L16.6833684,15.845831 L16.6833684,15.845831 Z M21.9888,14.5506761 C21.9888,15.3291549 21.4100211,15.4898873 20.8266947,15.4898873 L19.9940211,15.4898873 L19.9940211,16.4298592 L18.6969263,16.4298592 L17.8752,15.5021408 L17.0212211,16.4298592 L14.3778526,16.4298592 L14.3778526,13.6274366 L17.0618947,13.6274366 L17.8829474,14.5460282 L18.7317895,13.6274366 L20.8641684,13.6274366 C21.3937684,13.6274366 21.9888,13.7745634 21.9888,14.5506761 L21.9888,14.5506761 Z",
    id: "Shape",
    fill: "#FFFFFF",
    "data-testid": "Payment_amex_path"
  }))));
};

Amex.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var ApplePay = function ApplePay(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '42px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Payment_applePay_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Payment_applePay_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_payment/applepay",
    fill: "#000000",
    "data-testid": "Payment_applePay_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M40.6408803,8.31919045 L38.2673738,14.6828822 C38.1191782,15.0672397 37.9804926,15.4547671 37.8536942,15.8319922 C37.79188,16.0206047 37.7340283,16.1981224 37.676969,16.3677152 L37.6317971,16.3677152 C37.5747379,16.1901975 37.5153011,16.0055474 37.450317,15.8113875 C37.3266886,15.4381249 37.1943428,15.0712022 37.0580346,14.7225067 L34.5196903,8.31919045 L33.1621556,8.31919045 L36.7933431,17.529505 C36.8884418,17.7514021 36.9019142,17.8520483 36.9019142,17.8932578 C36.9019142,17.9059376 36.8971592,17.9812241 36.7917581,18.260973 C36.5643136,18.8125457 36.304377,19.2880395 36.0214582,19.673982 C35.7306145,20.0646794 35.4635455,20.3824677 35.2289685,20.6162522 C34.9539746,20.8888686 34.6678859,21.1115582 34.3786272,21.2803585 C34.0830285,21.4523287 33.8127896,21.5918069 33.5750427,21.6964155 L33.437942,21.7574372 L33.8793587,22.8177884 L34.0196293,22.7662765 C34.1345403,22.7234821 34.35089,22.6260059 34.6789807,22.4683004 C35.0102414,22.307425 35.3771641,22.0522434 35.7678615,21.7075104 C36.1038771,21.4182517 36.4113631,21.0751037 36.6839795,20.6891612 C36.951841,20.3095587 37.220495,19.863387 37.484394,19.3688735 C37.7443306,18.8751524 38.0050597,18.3124848 38.2586564,17.6967203 C38.5122531,17.0777859 38.785662,16.3875274 39.0669959,15.6441722 L42,8.31839796 L40.6408803,8.31839796 M30.7149476,15.082297 C30.7149476,15.2162278 30.681663,15.4000854 30.6206413,15.619605 C30.5421848,15.849427 30.4280663,16.0752865 30.2790783,16.2916362 C30.1308827,16.5056084 29.9446476,16.7013533 29.7243355,16.8733236 C29.5048159,17.0445014 29.2432943,17.1816021 28.9461107,17.2830407 C28.6489271,17.3852719 28.3057791,17.4359912 27.9261765,17.4359912 C27.6963545,17.4359912 27.47208,17.3979517 27.2565228,17.3242502 C27.0433431,17.2497562 26.853938,17.1380151 26.6922702,16.9914046 C26.5306023,16.844794 26.3982565,16.6553889 26.2960253,16.4263594 C26.1961716,16.1973299 26.1454523,15.9152036 26.1454523,15.5871129 C26.1454523,15.0498049 26.2912704,14.6131431 26.5789441,14.2937698 C26.8761278,13.9625092 27.2589003,13.7073275 27.7129968,13.5361497 C28.1766033,13.3594245 28.692514,13.2445135 29.2456718,13.1914167 C29.6958059,13.1494148 30.1364301,13.1272251 30.5532797,13.1272251 C30.6079615,13.1272251 30.6610583,13.1272251 30.7141551,13.1280176 L30.7141551,15.080712 M32.0059132,17.0381614 C31.9924409,16.649049 31.9861009,16.2583516 31.9861009,15.8692392 L31.9861009,12.0478542 C31.9861009,11.5953426 31.9393441,11.1325287 31.8490002,10.6736772 C31.7570714,10.2053158 31.5795538,9.77499391 31.3219946,9.39539138 C31.063643,9.01261888 30.7014752,8.69562303 30.2481712,8.45549867 C29.7948671,8.21616679 29.2060473,8.0933309 28.498354,8.0933309 C27.9808583,8.0933309 27.4752499,8.15990003 26.9981712,8.29066082 C26.5171299,8.42300659 26.0463911,8.64490369 25.5938795,8.9500122 L25.4908559,9.01975129 L25.9203853,10.0119483 L26.0765057,9.90813217 C26.4045964,9.68940503 26.7738966,9.5158498 27.1772738,9.39142893 C27.5798586,9.26938552 27.9887832,9.20677884 28.3977079,9.20677884 C28.9278834,9.20677884 29.3510729,9.30108511 29.6530114,9.48811266 C29.9589124,9.67751769 30.1903194,9.91130213 30.3401,10.1847111 C30.4954279,10.4668374 30.5968666,10.7671909 30.6420385,11.0794319 C30.6895879,11.4035601 30.7133626,11.6944038 30.7133626,11.9440381 L30.7133626,12.0541941 C28.8272372,12.0454767 27.3547915,12.3553402 26.3760668,12.976652 C25.3505852,13.628871 24.8299195,14.5568764 24.8299195,15.734516 C24.8299195,16.0729091 24.8917337,16.4152646 25.0129846,16.7520727 C25.1358205,17.0944282 25.3228481,17.3995367 25.5677274,17.6610583 C25.8149841,17.9257498 26.13198,18.141307 26.5115825,18.3021824 C26.8911851,18.4646428 27.3357717,18.5470617 27.8334552,18.5470617 C28.2281151,18.5470617 28.5974152,18.4963424 28.9334309,18.3996586 C29.2662765,18.2998049 29.5674226,18.1698366 29.8313216,18.0073763 C30.0928432,17.8472934 30.3258351,17.6666057 30.52475,17.4708608 C30.6143014,17.3844794 30.6911729,17.2957206 30.7672519,17.2077542 L30.8163862,17.2077542 L30.9336747,18.3235796 L32.1596562,18.3235796 L32.1263716,18.1436845 C32.0598025,17.7878566 32.020178,17.416179 32.0059132,17.0349915 M22.1608144,10.7148866 C21.507803,11.2545721 20.58376,11.5287735 19.4100829,11.5287735 C19.0883321,11.5287735 18.7832236,11.5153012 18.5026822,11.489149 C18.2704828,11.4677518 18.0565106,11.4312973 17.8631431,11.3829554 L17.8631431,5.53834431 C18.0311509,5.5082297 18.2395757,5.47890759 18.4836625,5.45275543 C18.7935259,5.42026335 19.1667886,5.40362107 19.5939405,5.40362107 C20.124116,5.40362107 20.6130821,5.46622775 21.0473665,5.58985614 C21.4776883,5.71189954 21.8533284,5.89417216 22.1647769,6.12954158 C22.4690929,6.36332602 22.7100097,6.66605706 22.8764326,7.03218728 C23.0444404,7.40227994 23.1284443,7.84448915 23.1284443,8.34455012 C23.1284443,9.38429652 22.8019385,10.1815411 22.1600219,10.7140941 M23.3289441,5.46464277 C22.9311143,5.08662522 22.4183735,4.79261156 21.8057791,4.58973421 C21.1979395,4.39081931 20.4672641,4.28938064 19.6351499,4.28938064 C19.0598025,4.28938064 18.523287,4.31632529 18.0422458,4.37100707 C17.5643745,4.42489637 17.1205803,4.48591807 16.721958,4.55407218 L16.5935747,4.5754694 L16.5935747,18.3219947 L17.8655206,18.3219947 L17.8655206,12.5312729 C18.2942575,12.6033894 18.7848086,12.6414289 19.3252865,12.6414289 C20.0456596,12.6414289 20.7200683,12.5502926 21.3310778,12.37119 C21.9468422,12.1912948 22.4881126,11.913131 22.9374543,11.5438308 C23.3883809,11.1745306 23.7489636,10.7109242 24.0120702,10.1672763 C24.2720068,9.6228359 24.4051451,8.98171178 24.4051451,8.26213119 C24.4051451,7.66617899 24.3092538,7.13045599 24.1230188,6.66922702 C23.9351987,6.20720556 23.6705072,5.80303585 23.3329066,5.46385028 M10.6372226,11.2014753 C10.6197878,9.24719581 12.2539015,8.30571812 12.3299805,8.25896124 C11.408315,6.93629603 9.97787121,6.75243843 9.46830038,6.73262619 C8.24945131,6.61375275 7.09083146,7.44031944 6.47189706,7.44031944 C5.85375514,7.44031944 4.90197508,6.75085345 3.88996582,6.77225068 C2.56175318,6.79127043 1.3365642,7.53383322 0.652645646,8.70671788 C-0.723908855,11.0746769 0.303157716,14.5711412 1.64722014,16.4850037 C2.30498654,17.4233114 3.08717381,18.4757376 4.11820283,18.4376981 C5.11119235,18.3996586 5.48286999,17.8044989 6.68190681,17.8044989 C7.87856616,17.8029139 8.21695924,18.4361132 9.26146058,18.4186784 C10.3281516,18.3964887 11.0049378,17.4605584 11.6547793,16.5182882 C12.406852,15.4333699 12.7183004,14.3793587 12.7341502,14.3254694 C12.712753,14.3135821 10.6578273,13.5393197 10.6340526,11.2014753 M8.36832476,5.46464277 C8.91435012,4.81163131 9.28206531,3.90502317 9.18221162,3 C8.39447692,3.03169959 7.44031939,3.52066569 6.87844424,4.17050719 C6.37045838,4.74823214 5.93062663,5.67227506 6.05108506,6.555901 C6.92837109,6.62326262 7.8222994,6.11527677 8.36832476,5.46305779",
    id: "Shape",
    "data-testid": "Payment_applePay_path"
  }))));
};

ApplePay.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Default = function Default(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '42px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Payment_default_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Payment_default_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_payment/default",
    fill: "#AAA7B0",
    "data-testid": "Payment_default_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M32,2 C33.6568542,2 35,3.34314575 35,5 L35,19 C35,20.6568542 33.6568542,22 32,22 L10,22 C8.34314575,22 7,20.6568542 7,19 L7,5 C7,3.34314575 8.34314575,2 10,2 L32,2 Z M33,12 L9,12 L9,18.5 C9,19.2796961 9.59488808,19.9204487 10.35554,19.9931334 L10.5,20 L31.5,20 C32.3284271,20 33,19.3284271 33,18.5 L33,18.5 L33,12 Z M15,16 C15.5522847,16 16,16.4477153 16,17 C16,17.5522847 15.5522847,18 15,18 L12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 L15,16 Z M27,16 C27.5522847,16 28,16.4477153 28,17 C28,17.5522847 27.5522847,18 27,18 L19,18 C18.4477153,18 18,17.5522847 18,17 C18,16.4477153 18.4477153,16 19,16 L27,16 Z M31.5,4 L10.5,4 C9.67157288,4 9,4.67157288 9,5.5 L9,5.5 L9,7 L33,7 L33,5.5 C33,4.72030388 32.4051119,4.07955132 31.64446,4.00686658 L31.5,4 Z",
    id: "shape",
    "data-testid": "Payment_default_path"
  }))));
};

Default.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Discover = function Discover(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '42px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Payment_discover_svg"
  }, /*#__PURE__*/React__default['default'].createElement("defs", {
    "data-testid": "Payment_discover_defs"
  }, /*#__PURE__*/React__default['default'].createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "50%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.970547,1.000000),rotate(90.000000),scale(1.000000,1.029991),translate(-0.500000,-0.500000)",
    id: "radialGradient-1",
    "data-testid": "Payment_discover_radialGradient"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#FFEEDD",
    offset: "0%",
    "data-testid": "Payment_discover_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#E77A2C",
    offset: "100%",
    "data-testid": "Payment_discover_stop"
  }))), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Payment_discover_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_payment/discover",
    "data-testid": "Payment_discover_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M3.44594444,13.6756727 C3.0332037,14.0413273 2.50185185,14.1992727 1.65744444,14.1992727 L1.30666667,14.1992727 L1.30666667,9.85189091 L1.65744444,9.85189091 C2.50185185,9.85189091 3.01285185,9.99990909 3.44594444,10.3838909 C3.89757407,10.7781818 4.16694444,11.3887091 4.16694444,12.0192182 C4.16694444,12.651 3.89757407,13.2829091 3.44594444,13.6756727 L3.44594444,13.6756727 Z M1.91942593,8.73889091 L0,8.73889091 L0,15.3120182 L1.90944444,15.3120182 C2.9225,15.3120182 3.65516667,15.0763091 4.29787037,14.5536 C5.06048148,13.9326364 5.51275926,12.9962909 5.51275926,12.0286364 C5.51275926,10.0879818 4.03614815,8.73889091 1.91942593,8.73889091 L1.91942593,8.73889091 Z",
    id: "D",
    fill: "#0B1015",
    "data-testid": "Payment_discover_path"
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    id: "I",
    fill: "#0B1015",
    points: "6.11553704 15.3120182 7.42 15.3120182 7.42 8.73889091 6.11553704 8.73889091",
    "data-testid": "Payment_discover_polygon"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M10.6136852,11.2602909 C9.82968519,10.9750727 9.59894444,10.7869636 9.59894444,10.4334 C9.59894444,10.0191273 10.0097407,9.704 10.5728519,9.704 C10.9643333,9.704 11.2855556,9.86156364 11.6279074,10.2349818 L12.3096296,9.35921818 C11.7475556,8.8752 11.075037,8.62918182 10.341463,8.62918182 C9.15807407,8.62918182 8.25390741,9.43774545 8.25390741,10.5110364 C8.25390741,11.4186182 8.6752037,11.8813818 9.90033333,12.3161455 C10.4126296,12.4926727 10.6730556,12.6104 10.8038519,12.6908364 C11.0647963,12.8584545 11.1958519,13.0941636 11.1958519,13.3699636 C11.1958519,13.9029818 10.7637963,14.2966364 10.1807222,14.2966364 C9.55824074,14.2966364 9.05683333,13.9914364 8.75544444,13.4198545 L7.91324074,14.2191273 C8.51433333,15.0852182 9.23727778,15.4708545 10.2321852,15.4708545 C11.5873333,15.4708545 12.5405,14.5826182 12.5405,13.3115455 C12.5405,12.2666364 12.0998889,11.7931818 10.6136852,11.2602909",
    id: "S",
    fill: "#0B1015",
    "data-testid": "Payment_discover_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.9519444,12.0286364 C12.9519444,13.9625455 14.4984259,15.4602909 16.4866852,15.4602909 C17.0487593,15.4602909 17.5305926,15.3512182 18.1235185,15.0763091 L18.1235185,13.5674909 C17.6007222,14.0805273 17.1388519,14.2869636 16.5463148,14.2869636 C15.2314815,14.2869636 14.2972407,13.3503636 14.2972407,12.0192182 C14.2972407,10.7582 15.2606481,9.76254545 16.4866852,9.76254545 C17.1081296,9.76254545 17.5807593,9.97929091 18.1235185,10.5016182 L18.1235185,8.99292727 C17.5513333,8.70796364 17.0787037,8.59061818 16.5165,8.59061818 C14.5383519,8.59061818 12.9519444,10.1186545 12.9519444,12.0286364",
    id: "C",
    fill: "#0B1015",
    "data-testid": "Payment_discover_path"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    id: "O",
    fill: "url(#radialGradient-1)",
    cx: "22.1850009",
    cy: "12.04",
    rx: "3.56500006",
    ry: "3.46000004",
    "data-testid": "Payment_discover_ellipse"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    id: "V",
    fill: "#0B1015",
    points: "28.7041481 13.1542364 26.9170741 8.73889091 25.4914074 8.73889091 28.333537 15.4798909 29.0357407 15.4798909 31.9275185 8.73889091 30.5123519 8.73889091 28.7041481 13.1542364",
    "data-testid": "Payment_discover_polyline"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    id: "E",
    fill: "#0B1015",
    points: "32.5210926 15.3120182 36.2251296 15.3120182 36.2251296 14.1992727 33.8260741 14.1992727 33.8260741 12.4238182 36.1333519 12.4238182 36.1333519 11.3108182 33.8260741 11.3108182 33.8260741 9.85189091 36.2251296 9.85189091 36.2251296 8.73889091 32.5210926 8.73889091 32.5210926 15.3120182",
    "data-testid": "Payment_discover_polyline"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M38.7736481,11.7642909 L38.3937037,11.7642909 L38.3937037,9.77247273 L38.7945185,9.77247273 C39.6095,9.77247273 40.0510185,10.1086 40.0510185,10.7482727 C40.0510185,11.4081818 39.6095,11.7642909 38.7736481,11.7642909 L38.7736481,11.7642909 Z M41.3941111,10.6787818 C41.3941111,9.44741818 40.5319444,8.73889091 39.0251296,8.73889091 L37.0872963,8.73889091 L37.0872963,15.3120182 L38.3937037,15.3120182 L38.3937037,12.6702182 L38.5646852,12.6702182 L40.3708148,15.3120182 L41.9771852,15.3120182 L39.8675926,12.5432 C40.8529074,12.3454182 41.3941111,11.6847455 41.3941111,10.6787818 L41.3941111,10.6787818 Z",
    id: "R",
    fill: "#0B1015",
    "data-testid": "Payment_discover_path"
  }))));
};

Discover.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Jcb = function Jcb(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '42px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Payment_jcb_svg"
  }, /*#__PURE__*/React__default['default'].createElement("defs", {
    "data-testid": "Payment_jcb_defs"
  }, /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    x1: "0.182516704%",
    y1: "49.95997%",
    x2: "100.273441%",
    y2: "49.95997%",
    id: "linearGradient-1",
    "data-testid": "Payment_jcb_linearGradient"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#007940",
    offset: "0%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%",
    "data-testid": "Payment_jcb_stop"
  })), /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    x1: "-57.5270968%",
    y1: "50.1241953%",
    x2: "232.39121%",
    y2: "50.1241953%",
    id: "linearGradient-2",
    "data-testid": "Payment_jcb_linearGradient"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#007940",
    offset: "0%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%",
    "data-testid": "Payment_jcb_stop"
  })), /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    x1: "-62.8015845%",
    y1: "49.8578253%",
    x2: "253.671294%",
    y2: "49.8578253%",
    id: "linearGradient-3",
    "data-testid": "Payment_jcb_linearGradient"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#007940",
    offset: "0%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%",
    "data-testid": "Payment_jcb_stop"
  })), /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    x1: "0.175556793%",
    y1: "50.0058048%",
    x2: "101.808162%",
    y2: "50.0058048%",
    id: "linearGradient-4",
    "data-testid": "Payment_jcb_linearGradient"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#1F286F",
    offset: "0%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#004E94",
    offset: "47.51%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#0066B1",
    offset: "82.61%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#006FBC",
    offset: "100%",
    "data-testid": "Payment_jcb_stop"
  })), /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    x1: "-0.575855512%",
    y1: "49.9142191%",
    x2: "98.13299%",
    y2: "49.9142191%",
    id: "linearGradient-5",
    "data-testid": "Payment_jcb_linearGradient"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#6C2C2F",
    offset: "0%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#882730",
    offset: "17.35%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#BE1833",
    offset: "57.31%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#DC0436",
    offset: "85.85%",
    "data-testid": "Payment_jcb_stop"
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    stopColor: "#E60039",
    offset: "100%",
    "data-testid": "Payment_jcb_stop"
  }))), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Payment_jcb_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_payment/jcb",
    "data-testid": "Payment_jcb_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M31.1539537,2.34459565e-15 C28.9585095,2.34459565e-15 27.1582453,1.78185151 27.1582453,4.00366636 L27.1582453,8.16131989 L32.8005368,8.16131989 C32.9322634,8.16131989 33.0859445,8.16131989 33.1957167,8.18331806 C34.4690743,8.24931256 35.4131153,8.90925756 35.4131153,10.0531622 C35.4131153,10.9550871 34.7764365,11.7250229 33.5908967,11.8790101 L33.5908967,11.9230064 C34.8862087,12.0109991 35.8741585,12.7369386 35.8741585,13.8588451 C35.8741585,15.0687443 34.7764365,15.8606783 33.3274434,15.8606783 L27.1362909,15.8606783 L27.1362909,24 L32.9981267,24 C35.1935709,24 36.9938351,22.2181485 36.9938351,19.9963336 L36.9938351,0 L31.1539537,0 L31.1539537,2.34459565e-15 Z",
    id: "path6349",
    fill: "url(#linearGradient-1)",
    "data-testid": "Payment_jcb_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M29.1121906,14.592105 L31.417407,14.592105 C31.4832703,14.592105 31.6369514,14.5701039 31.7028147,14.5701039 C32.1419035,14.4820995 32.515129,14.0860797 32.515129,13.5360522 C32.515129,13.0080259 32.1419035,12.6120061 31.7028147,12.5020006 C31.6369514,12.4799995 31.5052247,12.4799995 31.417407,12.4799995 L29.1121906,12.4799995 L29.1121906,14.592105 Z",
    id: "path6338",
    fill: "url(#linearGradient-2)",
    "data-testid": "Payment_jcb_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M32.2297213,10.3180487 C32.2297213,9.79002234 31.8564958,9.43800477 31.417407,9.37200148 C31.3734981,9.37200148 31.2637259,9.35000038 31.1978625,9.35000038 L29.1121906,9.35000038 L29.1121906,11.286097 L31.1978625,11.286097 C31.2637259,11.286097 31.3954525,11.286097 31.417407,11.2640959 C31.8564958,11.1980926 32.2297213,10.846075 32.2297213,10.3180487 L32.2297213,10.3180487 Z",
    id: "path6360",
    fill: "url(#linearGradient-3)",
    "data-testid": "Payment_jcb_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M9.01766276,2.34674665e-15 C6.82221863,2.34674665e-15 5.02195444,1.78348624 5.02195444,4.00733945 L5.02195444,13.893578 C6.14163095,14.4440367 7.30521634,14.7963303 8.46880173,14.7963303 C9.85193153,14.7963303 10.5983825,13.959633 10.5983825,12.8146789 L10.5983825,8.14678899 L14.0232754,8.14678899 L14.0232754,12.7926606 C14.0232754,14.5981651 12.9035989,16.0733945 9.10548053,16.0733945 C6.80026419,16.0733945 5,15.5669725 5,15.5669725 L5,24 L10.8618358,24 C13.05728,24 14.8575442,22.2165138 14.8575442,19.9926606 L14.8575442,0 L9.01766276,0 L9.01766276,2.34674665e-15 Z",
    id: "path6371",
    fill: "url(#linearGradient-4)",
    "data-testid": "Payment_jcb_path"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20.0638538,0 C17.8684096,0 16.0681455,1.78021978 16.0681455,4 L16.0681455,9.23076923 C17.0780498,8.37362637 18.8344051,7.82417582 21.666528,7.95604396 C23.1813844,8.02197802 24.8060131,8.43956044 24.8060131,8.43956044 L24.8060131,10.1318681 C23.9936988,9.71428571 23.0277034,9.34065934 21.7763002,9.25274725 C19.6247649,9.0989011 18.3294529,10.1538462 18.3294529,12 C18.3294529,13.8681319 19.6247649,14.9230769 21.7763002,14.7472527 C23.0277034,14.6593407 23.9936988,14.2637363 24.8060131,13.8681319 L24.8060131,15.5604396 C24.8060131,15.5604396 23.2033389,15.978022 21.666528,16.043956 C18.8344051,16.1758242 17.0780498,15.6263736 16.0681455,14.7692308 L16.0681455,24 L21.9299813,24 C24.1254254,24 25.9256896,22.2197802 25.9256896,20 L25.9256896,3.90408097e-15 L20.0638538,3.90408097e-15 L20.0638538,0 Z",
    id: "path6384",
    fill: "url(#linearGradient-5)",
    "data-testid": "Payment_jcb_path"
  }))));
};

Jcb.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Maestro = function Maestro(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '42px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Payment_maestro_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Payment_maestro_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_payment/maestro",
    "data-testid": "Payment_maestro_g"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    id: "Oval",
    fill: "#D32011",
    cx: "13.59",
    cy: "12",
    r: "12",
    "data-testid": "Payment_maestro_circle"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    id: "Oval",
    fill: "#0099DF",
    cx: "28.4099998",
    cy: "12",
    r: "12",
    "data-testid": "Payment_maestro_circle"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M21.0010004,2.56128517 C23.7953384,4.75836765 25.59,8.16960099 25.59,12 C25.59,15.830399 23.7953384,19.2416323 21.0010004,21.4387148 C18.2050919,19.2424504 16.4099998,15.8308583 16.4099998,12 C16.4099998,8.22747032 18.1508439,4.86153656 20.8730369,2.66169381 Z",
    id: "Combined-Shape",
    fill: "#6C6BBD",
    "data-testid": "Payment_maestro_path"
  }))));
};

Maestro.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var MasterCard = function MasterCard(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '42px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Payment_masterCard_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Payment_masterCard_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_payment/mastercard",
    "data-testid": "Payment_masterCard_g"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    id: "Oval",
    fill: "#EA001B",
    cx: "13.59",
    cy: "12",
    r: "12",
    "data-testid": "Payment_masterCard_circle"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    id: "Oval",
    fill: "#F79F1A",
    cx: "28.4099998",
    cy: "12",
    r: "12",
    "data-testid": "Payment_masterCard_circle"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M21.0010004,2.56128517 C23.7953384,4.75836765 25.59,8.16960099 25.59,12 C25.59,15.830399 23.7953384,19.2416323 21.0010004,21.4387148 C18.2050919,19.2424504 16.4099998,15.8308583 16.4099998,12 C16.4099998,8.22747032 18.1508439,4.86153656 20.8730369,2.66169381 Z",
    id: "Combined-Shape",
    fill: "#FF5F01",
    "data-testid": "Payment_masterCard_path"
  }))));
};

MasterCard.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Visa = function Visa(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '42px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '24px' : _ref$height;
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 42 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Payment_visa_svg"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Oversized",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "Payment_visa_g"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_payment/visa",
    fill: "#1A1F71",
    "data-testid": "Payment_visa_g"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20.6407353,18.6597794 L17.8556618,5.63934191 L14.4879412,5.63934191 L17.2730147,18.6597794 L20.6407353,18.6597794 L20.6407353,18.6597794 Z M34.811,10.2515956 L36.5863235,15.1413015 L37.6054926,10.2515956 L34.811,10.2515956 L34.811,10.2515956 Z M38.5709779,5.63934191 L41.6871618,5.63934191 L38.9668382,18.6597794 L36.0897353,18.6597794 C35.4463529,18.6597794 34.8996838,18.2819853 34.6581838,17.7029412 L29.6038235,5.63934191 L33.1404191,5.63934191 L33.8439191,7.58336029 L38.1644118,7.58336029 L38.5709779,5.63934191 L38.5709779,5.63934191 Z M29.7783603,9.88968529 C29.7926176,13.3259338 25.0255662,13.5147279 25.0599485,15.0506103 C25.0697794,15.5174485 25.5139191,16.0136765 26.4872279,16.1423529 C26.9716176,16.2046838 28.3005882,16.2531176 29.8087279,15.5597059 L30.4016176,18.3202279 C29.5915735,18.6135588 28.5460515,18.8970588 27.2510515,18.8970588 C23.9219853,18.8970588 21.5774485,17.1259044 21.5573235,14.592625 C21.5374044,12.7165221 23.2301176,11.6732647 24.5066397,11.0500074 C25.8197574,10.4106397 26.2602426,10.0024779 26.2540147,9.43107206 C26.2459853,8.55868676 25.20875,8.17265735 24.2396103,8.15677353 C22.5467426,8.13043603 21.5615441,8.61478456 20.7772353,8.97869706 L20.1682353,6.12569779 C20.9541397,5.76379265 22.4078235,5.45034706 23.9136985,5.43446324 C27.4523015,5.43446324 29.7684779,7.18345956 29.7783603,9.88968529 L29.7783603,9.88968529 Z M15.8272059,18.6597794 L10.3702941,5.63934191 L6.80801471,5.63934191 L4.12388015,16.0301471 C3.96062059,16.6695147 3.81807279,16.9047868 3.32347132,17.1717647 C2.51321103,17.6125074 1.17819265,18.0246324 0,18.2819853 L0.0802215441,18.6597794 L5.81056618,18.6597794 C6.542375,18.6597794 7.19965441,18.1734338 7.36492647,17.3330221 L8.78397059,9.79719779 L12.2886029,18.6597794 L15.8272059,18.6597794 L15.8272059,18.6597794 Z",
    id: "Visa",
    transform: "translate(20.843581, 12.165761) scale(1, -1) translate(-20.843581, -12.165761) ",
    "data-testid": "Payment_visa_path"
  }))));
};

Visa.propTypes = {
  width: PropTypes__default['default'].string,
  height: PropTypes__default['default'].string
};

var Payment = {
  Amex: Amex,
  ApplePay: ApplePay,
  Default: Default,
  Discover: Discover,
  Jcb: Jcb,
  Maestro: Maestro,
  MasterCard: MasterCard,
  Visa: Visa
};

var Icons = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, Activity), DefaultIcon), BrandIcon), NavigationIcon), Social), {}, {
  Loading: Loading,
  Google: GoogleIcon
}, CustomizableIcons), Payment);

var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      type = _ref.type,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '56' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '56' : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#120A20' : _ref$color,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["icon", "type", "width", "height", "color", "className"]);

  if (icon) {
    return /*#__PURE__*/React__default['default'].createElement(VariantIcon, _extends({}, props, {
      width: width,
      height: height,
      className: className,
      icon: icon,
      "data-testid": "Icon_index_VariantIcon"
    }));
  }
  /**
   * example usage 1: <Icon.Loading />
   * example usage 2: <Icon type="loading" />
   *
  */


  var Component = Icons[type];
  if (typeof Component === 'undefined') return null;
  return /*#__PURE__*/React__default['default'].createElement("span", {
    className: className,
    style: {
      color: color
    },
    "data-testid": "Icon_index_span"
  }, /*#__PURE__*/React__default['default'].createElement(Component, _extends({}, props, {
    width: width,
    height: height,
    color: color,
    "data-testid": "Icon_index_Component"
  })));
};

Icon.Customizable = CustomizableIcons;
Icon.Navigation = NavigationIcon;
Icon.Brand = BrandIcon;
Icon.Loading = Loading;
Icon.Google = GoogleIcon;
Icon.Default = DefaultIcon;
Icon.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /* Not all icons accept color (e.g tada)*/
  color: PropTypes__default['default'].string,
  height: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),

  /* if this prop is passed component uses old version of Icon aka VariantIcon */
  icon: PropTypes__default['default'].any,
  width: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string])
};

var styles$2 = {"show":"Boutton-module_show__cyyaG","isSubmitting":"Boutton-module_isSubmitting__1GovA","rotate-forever":"Boutton-module_rotate-forever__KUEEf"};

var Boutton = /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var active = _ref.active,
      block = _ref.block,
      children = _ref.children,
      className = _ref.className,
      flexboxContainer = _ref.flexboxContainer,
      icon = _ref.icon,
      size = _ref.size,
      submitting = _ref.submitting,
      toggle = _ref.toggle,
      type = _ref.type,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["active", "block", "children", "className", "flexboxContainer", "icon", "size", "submitting", "toggle", "type", "variant"]);

  var classes = cx__default['default']('btn', active && 'active', icon && 'btn-icon', variant && "btn-".concat(variant), !children && 'btn-no-text', block && 'btn-block', size && "btn-".concat(size), submitting && styles$2['btnSubmitting'], toggle && 'btn-toggle', className);

  if (props.disabled || submitting) {
    props.disabled = true;
  }

  if (toggle) {
    return /*#__PURE__*/React__default['default'].createElement("label", _extends({}, props, {
      className: classes,
      "data-testid": "Boutton_index_label"
    }), children);
  }

  return /*#__PURE__*/React__default['default'].createElement("button", _extends({
    ref: ref,
    type: type,
    className: classes
  }, props, {
    "data-testid": "Boutton_index_button"
  }), /*#__PURE__*/React__default['default'].createElement(Box.Flexbox.Container, flexboxContainer, icon && !submitting && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, icon, children && /*#__PURE__*/React__default['default'].createElement("span", {
    "data-testid": "Boutton_index_span"
  }, children)), submitting && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Icon.Loading, {
    className: styles$2.isSubmitting,
    variant: variant
  }), children && /*#__PURE__*/React__default['default'].createElement("span", {
    "data-testid": "Boutton_index_span"
  }, children)), !icon && !submitting && children));
});
Boutton.displayName = 'Boutton';
Boutton.propTypes = {
  /** Manually set the visual state of the button to `:active` */
  active: PropTypes__default['default'].bool,

  /** Spans the full width of the Boutton parent */
  block: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  'data-testid': PropTypes__default['default'].string,

  /**
   * Disables the Boutton, preventing mouse events,
   * even if the underlying component is an `<a>` element
   */
  disabled: PropTypes__default['default'].bool,
  flexboxContainer: PropTypes__default['default'].object,
  icon: PropTypes__default['default'].any,

  /**
   * Specifies a large or small button.
   *
   * @type ('sm'|'lg')
   */
  size: PropTypes__default['default'].oneOf(['sm', 'lg']),

  /**
   * Whether the loading icon shows or not
   */
  submitting: PropTypes__default['default'].bool,
  // instead of a button component, we will use a label instead
  toggle: PropTypes__default['default'].bool,

  /**
   * Defines HTML button type attribute.
   */
  type: PropTypes__default['default'].oneOf(['button', 'reset', 'submit', null]),

  /**
   * Bouttons may be one of a variety of visual variants
   */
  variant: PropTypes__default['default'].oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link', 'facebook', 'github', 'google', 'linkedin', 'twitter'])
};
Boutton.defaultProps = {
  block: false,
  disabled: false,
  flexboxContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  },
  icon: false,
  submitting: false,
  toggle: false,
  type: 'button'
};

var FormSearch = function FormSearch(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      _ref$isDirty = _ref.isDirty,
      isDirty = _ref$isDirty === void 0 ? false : _ref$isDirty,
      _ref$isSearching = _ref.isSearching,
      isSearching = _ref$isSearching === void 0 ? false : _ref$isSearching,
      onClear = _ref.onClear,
      props = _objectWithoutProperties(_ref, ["children", "className", "isDirty", "isSearching", "onClear"]);

  var classes = cx__default['default'](styles$3.container, (_cx = {}, _defineProperty(_cx, styles$3.searching, isSearching), _defineProperty(_cx, styles$3.isDirty, isDirty), _cx), className);
  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: classes
  }, props, {
    "data-testid": "FormSearch_index_div"
  }), /*#__PURE__*/React__default['default'].cloneElement(children, {
    isInlineLeft: true,
    isInlineRight: true
  }), isDirty && !isSearching && /*#__PURE__*/React__default['default'].createElement(Boutton, {
    className: styles$3.pseudoInline,
    onClick: onClear,
    size: "sm",
    icon: /*#__PURE__*/React__default['default'].createElement(Icon.Default.Clear, {
      width: 15,
      height: 15
    }),
    variant: "secondary",
    "data-testid": "FormSearch_index_Boutton"
  }, "Clear search"));
};

FormSearch.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  children: PropTypes__default['default'].element,
  isDirty: PropTypes__default['default'].bool,
  isSearching: PropTypes__default['default'].bool,
  onClear: PropTypes__default['default'].func
};

var FormSwitch = /*#__PURE__*/function (_React$Component) {
  _inherits(FormSwitch, _React$Component);

  var _super = _createSuper(FormSwitch);

  function FormSwitch() {
    _classCallCheck(this, FormSwitch);

    return _super.apply(this, arguments);
  }

  _createClass(FormSwitch, [{
    key: "render",
    value: function render() {
      var input = this.props.input;
      return /*#__PURE__*/React__default['default'].createElement(Switch__default['default'], _extends({}, this.props, {
        onChange: input.onChange,
        checked: input.value || false,
        "data-testid": "FormSwitch_index_Switch"
      }));
    }
  }]);

  return FormSwitch;
}(React__default['default'].Component);

FormSwitch.propTypes = {
  input: PropTypes__default['default'].object.isRequired,

  /**
   * When disabled, the switch will no longer be interactive and its colors will be greyed out.
   */
  disabled: PropTypes__default['default'].bool,

  /**
   * The switch will take on this color when it is not checked. Only accepts hex-colors.
   */
  offColor: PropTypes__default['default'].string,

  /**
   * The switch will take on this color when it is checked. Only accepts hex-colors.
   */
  onColor: PropTypes__default['default'].string,

  /**
   * The handle of the switch will take on this color when it is not checked. Only accepts hex-colors.
   */
  offHandleColor: PropTypes__default['default'].string,

  /**
   * The handle of the switch will take on this color when it is checked. Only accepts hex-colors.
   */
  onHandleColor: PropTypes__default['default'].string,

  /**
   * The diameter of the handle, measured in pixels. By default it will be 2 pixels smaller than the height of the switch.
   */
  handleDiameter: PropTypes__default['default'].number,

  /**
   * An icon that will be shown on the switch when it is not checked. Pass in false if you don't want any icon.
   */
  uncheckedIcon: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].element]),

  /**
   * An icon that will be shown on the switch when it is checked. Pass in false if you don't want any icon.
   */
  checkedIcon: PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].element]),

  /**
   * The default box-shadow of the handle. You can read up on the box-shadow syntax on MDN.
   */
  boxShadow: PropTypes__default['default'].string,

  /**
   * The box-shadow of the handle when it is active or focused. Do not set this to null, since it is important for accessibility.
   */
  activeBoxShadow: PropTypes__default['default'].string,

  /**
   * The height of the background of the switch, measured in pixels.
   */
  height: PropTypes__default['default'].number,

  /**
   * The width of the background of the switch, measured in pixels.
   */
  width: PropTypes__default['default'].number,

  /**
   * Set as an attribute to the embedded checkbox. This is useful for the associated label, which can point to the id in its htmlFor attribute.
   */
  id: PropTypes__default['default'].string,

  /**
   * Set as the className of the outer shell of the switch. Useful for positioning the switch.
   */
  className: PropTypes__default['default'].string
};
FormSwitch.defaultProps = {
  checked: false,
  disabled: false,
  offColor: '#888',
  onColor: '#080',
  offHandleColor: '#fff',
  onHandleColor: '#fff',
  boxShadow: null,
  activeBoxShadow: '0 0 2px 3px #3bf',
  height: 28,
  width: 56
};

var styles$1 = {"container":"TextArea-module_container__PZURi","input":"TextArea-module_input__2oOcz","error":"TextArea-module_error__3qF2B","disabled":"TextArea-module_disabled__umxlD"};

var FormTextArea = function FormTextArea(_ref) {
  var className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      placeholder = _ref.placeholder,
      type = _ref.type,
      input = _ref.input,
      meta = _ref.meta,
      label = _ref.label,
      required = _ref.required,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? '#7A34FF' : _ref$themeColor,
      props = _objectWithoutProperties(_ref, ["className", "disabled", "placeholder", "type", "input", "meta", "label", "required", "autoFocus", "themeColor"]);

  return /*#__PURE__*/React__default['default'].createElement(Form.Field, _extends({
    label: label,
    name: input.name,
    required: required,
    meta: meta
  }, props), /*#__PURE__*/React__default['default'].createElement(FocusWithin__default['default'], {
    "data-testid": "FormTextArea_index_FocusWithin"
  }, function (_ref2) {
    var _cx;

    var isFocused = _ref2.isFocused,
        focusProps = _ref2.focusProps;
    return /*#__PURE__*/React__default['default'].createElement("div", _extends({}, focusProps, {
      className: cx__default['default'](styles$1.container, (_cx = {}, _defineProperty(_cx, styles$1.error, meta.touched && meta.error), _defineProperty(_cx, styles$1.disabled, disabled), _cx), className),
      "data-testid": "FormTextArea_index_div"
    }), /*#__PURE__*/React__default['default'].createElement("textarea", _extends({
      className: cx__default['default'](styles$1.input),
      disabled: disabled,
      type: type,
      placeholder: placeholder,
      autoFocus: autoFocus
    }, input, {
      style: isFocused ? {
        borderColor: themeColor
      } : {},
      "data-testid": "FormTextArea_index_textarea"
    })));
  }));
};

FormTextArea.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  disabled: PropTypes__default['default'].bool,
  input: PropTypes__default['default'].object.isRequired,
  meta: PropTypes__default['default'].object.isRequired,
  required: PropTypes__default['default'].bool,
  type: PropTypes__default['default'].oneOf(['password', 'email', 'text']),
  themeColor: PropTypes__default['default'].string
};

var styles = {"dropzone":"FormUploader-module_dropzone__3Qbig"};

var Uploader = /*#__PURE__*/function (_React$Component) {
  _inherits(Uploader, _React$Component);

  var _super = _createSuper(Uploader);

  function Uploader(props) {
    var _this;

    _classCallCheck(this, Uploader);

    _this = _super.call(this, props);
    _this.state = {
      preview: null
    };
    _this.getSignedUrl = _this.getSignedUrl.bind(_assertThisInitialized(_this));
    _this.handleFinishedUpload = _this.handleFinishedUpload.bind(_assertThisInitialized(_this));
    _this.onDrop = _this.onDrop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Uploader, [{
    key: "getSignedUrl",
    value: function getSignedUrl(file, callback) {
      var _this$props = this.props,
          bucket = _this$props.bucket,
          filePath = _this$props.filePath,
          serverUrl = _this$props.serverUrl;
      var params = {
        objectName: file.name,
        bucket: bucket,
        filePath: filePath
      };
      var headers = {
        'Content-Type': 'application/json'
      };
      axios__default['default'].get(serverUrl, {
        params: params
      }, headers).then(function (response) {
        callback(response.data);
      })["catch"](function (error) {
        console.error(error);
      });
    }
  }, {
    key: "handleFinishedUpload",
    value: function handleFinishedUpload(info) {
      var _this$props2 = this.props,
          input = _this$props2.input,
          progress = _this$props2.progress;
      input && input.onChange(info.signedUrl.split('?')[0]);
      progress(false);
    }
  }, {
    key: "onDrop",
    value: function onDrop(file) {
      var _this$props3 = this.props,
          customOnDrop = _this$props3.customOnDrop,
          progress = _this$props3.progress;
      this.setState({
        preview: file[0] && file[0].preview
      });
      progress(true);
      customOnDrop(file);
    }
  }, {
    key: "render",
    value: function render() {
      var options = {
        getSignedUrl: this.getSignedUrl
      };
      var preview = this.state.preview;
      var _this$props4 = this.props,
          s3Url = _this$props4.s3Url,
          child = _this$props4.child,
          className = _this$props4.className,
          filename = _this$props4.filename,
          input = _this$props4.input,
          childStyle = _this$props4.childStyle,
          savedImage = _this$props4.savedImage,
          accept = _this$props4.accept,
          multiple = _this$props4.multiple;
      var Component = child;
      return /*#__PURE__*/React__default['default'].createElement(DropzoneS3Uploader__default['default'], {
        className: cx__default['default'](styles.dropzone, className),
        s3Url: s3Url,
        filename: filename,
        notDropzoneProps: ['onFinish', 's3Url', 'filename', 'host', 'upload', 'isImage', 'notDropzoneProps', 'onDrop'],
        upload: options,
        onDrop: this.onDrop,
        onFinish: this.handleFinishedUpload,
        multiple: multiple,
        name: input.name,
        accept: accept,
        "data-testid": "FormUploader_index_DropzoneS3Uploader"
      }, /*#__PURE__*/React__default['default'].createElement(Component, {
        childStyle: childStyle,
        preview: preview,
        savedImage: savedImage,
        image: input && input.value,
        "data-testid": "FormUploader_index_Component"
      }));
    }
  }]);

  return Uploader;
}(React__default['default'].Component);

Uploader.defaultProps = {
  customOnDrop: function customOnDrop() {
    return null;
  },
  progress: function progress() {
    return null;
  }
};
Uploader.propTypes = {
  /* Give Array List For Accepted File Types Example: ['.csv','.pdf'] */
  accept: PropTypes__default['default'].array,
  bucket: PropTypes__default['default'].string,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  customOnDrop: PropTypes__default['default'].func,
  filename: PropTypes__default['default'].string,
  filePath: PropTypes__default['default'].string,
  input: PropTypes__default['default'].object,

  /* For Multiple Uploads */
  multiple: PropTypes__default['default'].bool,
  progress: PropTypes__default['default'].func,
  s3Url: PropTypes__default['default'].string
};

var style = {"container":"Requirement-module_container__3qcG_","met":"Requirement-module_met__2JAZB"};

var Requirement = function Requirement(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$met = _ref.met,
      met = _ref$met === void 0 ? false : _ref$met,
      props = _objectWithoutProperties(_ref, ["className", "label", "met"]);

  return /*#__PURE__*/React__default['default'].createElement("label", _extends({
    className: cx__default['default'](style.container, _defineProperty({}, style.met, met), className)
  }, props, {
    "data-testid": "FormRequirement_index_label"
  }), label);
};

Requirement.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  met: PropTypes__default['default'].bool,
  label: PropTypes__default['default'].string.isRequired
};

var Form = {
  Checkbox: Checkbox,
  Date: FormDate.Date,
  Dropdown: Dropdown,
  DynamicField: DynamicField,
  Feedback: FormFeedback,
  Field: FormField,
  FieldError: FormFieldError,
  FieldStatus: FieldStatus,
  Input: FormInput,
  Label: FormLabel,
  Radio: Radio,
  Search: FormSearch,
  SingleDate: FormDate.SingleDate,
  Switch: FormSwitch,
  TextArea: FormTextArea,
  Time: FormDate.Time,
  Typeahead: FormTypeahead,
  Uploader: Uploader,
  Validate: Requirement
};

module.exports = Form;
